/** Auto-generated — Azul from scripts/import-azul-tracker-html.mjs */
export const AZUL_IMPORT = {
  "operatorMatch": [
    "azul"
  ],
  "project": {
    "id": "proj-3af0f1ec-fa3",
    "title": "DAE Technical Call Tracker",
    "type": "general",
    "summary": "66 subtopics across 13 main topics. 11 critical · 26 in progress · 17 pending · 21 closed. 57 open next actions tracked.",
    "criticalItems": [
      "2.3 ED0541↔ ED0230 — PENDING",
      "2.4 ED0569↔ EB0133 — PENDING",
      "2.5 ED0570↔ ED0232 — PENDING",
      "2.7 ED0904↔ ED0306 — PENDING",
      "2.8 ED0736↔ ED0305 — PENDING",
      "2.9 ED0671↔ ED0325 — PENDING",
      "2.10 ED0942↔ ED0324 — PENDING",
      "4.8 ED0905 — IN PROGRESS",
      "8.2 14B26218 B726 B731 — IN PROGRESS",
      "12.1 Utilzation reports — PENDING",
      "13.2 Claim #4540 (MSN 1115) — IN PROGRESS"
    ],
    "contacts": [],
    "minutes": [
      {
        "id": "min-b9c49596-488",
        "number": "1.1",
        "sectionNumber": "1",
        "principalTopic": "MR Adjustment Calculations",
        "subTopic": "ED0707 ED0230 ED0232 EB0133 2X LG shipsets",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "Agreement for 4x Engine Swaps ) & 2x LG shipsets swaps — NEXT: Agreement confirmed — [COMPLETE] — –"
            }
          ],
          "nextAction": "",
          "nextActionBy": "DAE / Azul",
          "targetDate": ""
        }
      },
      {
        "id": "min-69435d1f-001",
        "number": "1.2",
        "sectionNumber": "1",
        "principalTopic": "MR Adjustment Calculations",
        "subTopic": "ED0305 ED0306",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-03-25",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "2026-03-25",
              "source": "meeting",
              "text": "ED0324 : Last update received Friday, 20 March. Azul to confirm arrival in Brazil and installation status."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Pending agreement for engines — NEXT: Agreement confirmed — [COMPLETE]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0324 ED0325 — Pending agreement for engines PT2 blades replaced HSI Complete — NEXT: - Finalize selection & confirmation - Additional forms for some compents requested. Leonardo to send request to DAE. — [COMPLETE] — Engineering evaluation ongoing DAE to respond about ARCs ENG in Std Aero"
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL, DAE",
          "targetDate": "2026-03-25"
        }
      },
      {
        "id": "min-19f63883-ad4",
        "number": "1.3",
        "sectionNumber": "1",
        "principalTopic": "MR Adjustment Calculations",
        "subTopic": "ED0904 ED0736",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-06-10",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "26-nov",
              "source": "excel",
              "text": ". Azil confirms calculuatoins are acceptable. DAE ( Follow up with Liam) — [COMPLETE] — ED0904 , ED0736 will be considered 'OVH' for the purposes of the calculations."
            },
            {
              "date": "2025-11-26",
              "source": "excel",
              "text": "Azil confirms calculuatoins are acceptable. DAE ( Follow up with Liam)"
            },
            {
              "date": "2026-04-08",
              "source": "meeting",
              "text": "Records: DAE reviewed the newly provided records. Progress remains minimal. AZUL to immediately assign sufficient labor resources to complete the records promptly. This issue requi"
            },
            {
              "date": "2026-04-23",
              "source": "meeting",
              "text": "ED0671 / ED0942 DAE to confirm shipping location. In progress."
            },
            {
              "date": "2026-05-13",
              "source": "meeting",
              "text": "ED0671, ED0942: Shipment to Standard Aero in PEI, Canada requested on May 6. Azul to provide AWB. Confirmation required that logbooks are included with engines."
            },
            {
              "date": "2026-05-29",
              "source": "meeting",
              "text": "ED0942 & ED0671 : DAE to provide shop details to resume the shipping process to PEI."
            },
            {
              "date": "2026-06-08",
              "source": "meeting",
              "text": "3. Engines ED0942 / ED0671 Azul to confirm shipping status, provide AWB, and confirm logbooks are traveling with engines."
            },
            {
              "date": "2026-06-10",
              "source": "meeting",
              "text": "Engines ED0942 and ED0671:"
            },
            {
              "date": "",
              "source": "excel",
              "text": "DAE provided calculations using — [COMPLETE]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0942 ED0671 — ED0671 + ed0942 CONFIRMED"
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL",
          "targetDate": "2026-06-10"
        }
      },
      {
        "id": "min-8392a680-57c",
        "number": "1.4",
        "sectionNumber": "1",
        "principalTopic": "MR Adjustment Calculations",
        "subTopic": "ED0942 ED0671",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "Azul to confirm if engines will be exchanged or overhauled — [COMPLETE]"
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL",
          "targetDate": ""
        }
      },
      {
        "id": "min-e19881bb-92d",
        "number": "2.1",
        "sectionNumber": "2",
        "principalTopic": "Engines Delivered",
        "subTopic": "ED0809",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "ED0809 – temporary lease installed on MSN 1241 — [COMPLETE]"
            }
          ],
          "nextAction": "",
          "nextActionBy": "DAE / Azul",
          "targetDate": ""
        }
      },
      {
        "id": "min-058c1f21-adf",
        "number": "2.2",
        "sectionNumber": "2",
        "principalTopic": "Engines Delivered",
        "subTopic": "ED0707 ↔ ED0886",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-23",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "2026-04-23",
              "source": "meeting",
              "text": "ED0886 Statement of Storage Azul provided the updated statement."
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0707 swapped with ED0886 – install on MSN1195 — NEXT: Confirm installation Pending NIS and Statemnet Pending confirmation of Nozzles, Flow devider , Logbook included. — [COMPLETE] — Leonardo will confirm. (AQV) Email sent to shop."
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0886 — ii. Missing components — NEXT: Ensure all parts match delivered configuration — [COMPLETE] — Complete"
            },
            {
              "date": "",
              "source": "excel",
              "text": "iii. Storage gap – DAE requires Azul statement — [COMPLETE] — Statement provided"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Shipped with AWB 25110122941 on 7/NOV — NEXT: Tracking in progress — [COMPLETE] — Follow up with Gustavo"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Ship Logbook to shop Shipped with FedEx AWB 886461486187 — [COMPLETE] — Delivered"
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL",
          "targetDate": "2026-04-23"
        }
      },
      {
        "id": "min-0a510426-786",
        "number": "2.3",
        "sectionNumber": "2",
        "principalTopic": "Engines Delivered",
        "subTopic": "ED0541↔ ED0230",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-01-19",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "05-JAN",
              "source": "excel",
              "text": "In transit MIA"
            },
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "Eng fitted on DAE A/C MSN: 1166 — [CLOSED]"
            },
            {
              "date": "12-JAN",
              "source": "excel",
              "text": "Engine delivered. — NEXT: Confirm arrival to NTE — [CLOSED] — Delivered"
            },
            {
              "date": "02-DEC",
              "source": "excel",
              "text": "Engine in customs"
            },
            {
              "date": "03-DEC",
              "source": "excel",
              "text": "Removal scheduled for DEC-16. Will be trucked to PLU. — [COMPLETE] — Inspected"
            },
            {
              "date": "03-DEC",
              "source": "excel",
              "text": "@ VCP --> Going to PLU"
            },
            {
              "date": "09-DEC",
              "source": "excel",
              "text": "Arrived. - Azul confirm installation."
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "AZul email received. Under DAE review — NEXT: Confirm acceptance — [CLOSED] — Engine in operation"
            },
            {
              "date": "17-DEC",
              "source": "excel",
              "text": "Azul reports suspected corrosion during incoming inspection. Assigned to MSN 1116 — NEXT: Confirm installation on DAE Aircraft"
            },
            {
              "date": "18-DEC",
              "source": "excel",
              "text": "Azul to provide maintenance records on finding."
            },
            {
              "date": "27-DEC",
              "source": "excel",
              "text": "Shipped with AWB 369-83317103"
            },
            {
              "date": "2002-11-26",
              "source": "excel",
              "text": "DEC - Engine in customs"
            },
            {
              "date": "2025-12-03",
              "source": "excel",
              "text": "VCP --> Going to PLU"
            },
            {
              "date": "2025-12-03",
              "source": "excel",
              "text": "Removal scheduled for DEC-16. Will be trucked to PLU."
            },
            {
              "date": "2025-12-09",
              "source": "excel",
              "text": "Arrived. - Azul confirm installation."
            },
            {
              "date": "2025-12-10",
              "source": "excel",
              "text": "AZul email received. Under DAE review"
            },
            {
              "date": "2025-12-17",
              "source": "meeting",
              "text": "Azul to complete by end of year"
            },
            {
              "date": "2025-12-17",
              "source": "excel",
              "text": "Azul reports suspected corrosion during incoming inspection. Assigned to MSN 1116"
            },
            {
              "date": "2025-12-18",
              "source": "excel",
              "text": "Azul to provide maintenance records on finding."
            },
            {
              "date": "2025-12-25",
              "source": "excel",
              "text": "DEC: Shipped with AWB 369-83317103"
            },
            {
              "date": "2026-01-05",
              "source": "excel",
              "text": "In transit MIA"
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "Updates expected today . DFPs being collected."
            },
            {
              "date": "2026-01-07",
              "source": "excel",
              "text": "Eng fitted on DAE A/C MSN: 1166"
            },
            {
              "date": "2026-01-12",
              "source": "excel",
              "text": "Engine delivered."
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Leonardo will follow-up with Rafael. Priority on LLPs."
            },
            {
              "date": "10:DEC",
              "source": "excel",
              "text": "Shipping - Export process started. To be shipped by"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Engine ready. TA signed — [COMPLETE] — Records in progress with Rafael. Pending to provide estimated date of completeness (priority)"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0541 — Pendging Records — NEXT: Completeness 55%. DAE to provide feedback. — [PENDING] — Urgent - Follow up with Rafael"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Coordinate inspections"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0230 (In Transit) — Engine was picked up by AZUL. Arriving WK 48 Expected in GRU"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Records Shop visit pack shared with AZUL"
            }
          ],
          "nextAction": "Completeness 55%. DAE to provide feedback.",
          "nextActionBy": "AZUL, DAE",
          "targetDate": "2026-01-19"
        }
      },
      {
        "id": "min-3ce6a263-f01",
        "number": "2.4",
        "sectionNumber": "2",
        "principalTopic": "Engines Delivered",
        "subTopic": "ED0569↔ EB0133",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-05-29",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "DFPs will be prepared."
            },
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "AZUL confirms engine is acceptable if in the new inspection the engine shows another condition."
            },
            {
              "date": "8-JAN",
              "source": "excel",
              "text": "— [CLOSED] — Engine was inspected"
            },
            {
              "date": "14-JAN",
              "source": "excel",
              "text": "RGB BSI report reviewed. Azul rejects engine due to impossibility of performing repetitive inspections. Awaiting Azul email."
            },
            {
              "date": "19-JAN",
              "source": "excel",
              "text": "If engine has no repetitive inspections , AZUL is likely to technically accept the engine."
            },
            {
              "date": "21-JAN",
              "source": "excel",
              "text": "Azul reports engine not acceptable unless RGB 1st stage helical shaft finding (CAT II with repetitive inspections) is addressed; test cell scheduled for"
            },
            {
              "date": "23-JAN",
              "source": "excel",
              "text": ". It is strongly recommended that Azul send a technical representative to witness the post–test cell BSI, as the shop expects to release the engine with no limitations; if no representative is assigned, Azul to confirm acceptance of the shop report on a permanent basis. If further discussion is required, Powerplant to be advised by email. Email chain retained in parallel. — NEXT: Azul will send details by email Confirm with Rafael Matias if travel is possible, or confirm if AZUL will accept the post test cell BSI report. — [PENDING] — Tracked above. Inspectoin"
            },
            {
              "date": "04-FEB",
              "source": "excel",
              "text": "Provide schedule and records. — [PENDING] — Contact Rafael."
            },
            {
              "date": "11-MAR",
              "source": "excel",
              "text": "with AWB 26030027934 - to PWC Singapore. AWB shows destination Miami. — NEXT: Provide status of shipment — [CLOSED] — Link to AWB tracking"
            },
            {
              "date": "2025-12-01",
              "source": "meeting",
              "text": "Engine will ship to STD Aero"
            },
            {
              "date": "2025-12-03",
              "source": "meeting",
              "text": "PT2 Blades on backorder with PWC"
            },
            {
              "date": "2025-12-17",
              "source": "meeting",
              "text": "PT2 Pack released and shipping"
            },
            {
              "date": "2025-12-18",
              "source": "meeting",
              "text": "to NTE. ETA"
            },
            {
              "date": "2025-12-29",
              "source": "meeting",
              "text": "Ship to StandardAero PEI"
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "AZUL confirms engine is acceptable if in the new inspection the engine shows another condition."
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "Azul to confirm if reinspection is possible in the coming days."
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "DFPs will be prepared."
            },
            {
              "date": "2026-01-14",
              "source": "meeting",
              "text": "RGB BSI report reviewed. Azul rejects engine due to impossibility of performing repetitive inspections. Awaiting Azul email."
            },
            {
              "date": "2026-01-14",
              "source": "meeting",
              "text": "Release pushed to"
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "If engine has no repetitive inspections , AZUL is likely to technically accept the engine."
            },
            {
              "date": "2026-01-21",
              "source": "excel",
              "text": "Azul reports engine not acceptable unless RGB 1st stage helical shaft finding (CAT II with repetitive inspections) is addressed; test cell scheduled for"
            },
            {
              "date": "2026-01-23",
              "source": "excel",
              "text": "It is strongly recommended that Azul send a technical representative to witness the post–test cell BSI, as the shop expects to release the engine with no limitations; if no representative is assigned, Azul to confirm acceptance of the shop report on a permanent basis. If further discussion is required, Powerplant to be advised by email. Email chain retained in parallel."
            },
            {
              "date": "2026-02-04",
              "source": "excel",
              "text": "Provide schedule and records."
            },
            {
              "date": "2026-03-11",
              "source": "excel",
              "text": "with AWB 26030027934 - to PWC Singapore. AWB shows destination Miami."
            },
            {
              "date": "2026-04-08",
              "source": "meeting",
              "text": "Records: DAE reviewed the newly provided records. Progress remains minimal. AZUL to immediately assign sufficient labor resources to complete the records promptly. This issue requi"
            },
            {
              "date": "2026-04-23",
              "source": "meeting",
              "text": "ED0569 Arrival confirmed at the shop in Singapore. Closed."
            },
            {
              "date": "2026-05-13",
              "source": "meeting",
              "text": "ED0569 TLB: Azul plans to ship by 14-MAY. AWB to be shared with DAE when available."
            },
            {
              "date": "2026-05-29",
              "source": "meeting",
              "text": "ED0569 : Parts received with the engine are to be disposed of by the shop if no update is received from Azul by end of day today."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Thrust upgrade + PT pack replacement. Impeller case replacement. Release pushed to December. — [IN PROGRESS]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0569 — Physical inspection — NEXT: Inspect aircraft in VCP"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Shipped"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Pendging Records — NEXT: 0% Progress Storage and insurance priority"
            },
            {
              "date": "",
              "source": "excel",
              "text": "EB0133 — Confirm installation — NEXT: Confirm installation — [PENDING] — Daniel / Leonardo."
            },
            {
              "date": "",
              "source": "excel",
              "text": "AZUL Requests -Confirmation that the DCU will be supplied together with the engine -A new inspection of the engine is recommended to validate the reported information -The engine will only be accepted if the RGB issue is classified as CAT 1 or lower, without requiring re-inspection every 500 flight hour"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Records — NEXT: details for the PT2 blades & engine shop visit reports, once available — [PENDING]"
            }
          ],
          "nextAction": "0% Progress Storage and insurance priority 07-JAN: DFPs will be prepared. 04-FEB: Provide schedule and records.\nConfirm installation\nAzul will send details by email Confirm with Rafael Matias if travel is possible, or confirm if AZUL will accept the post test cell BSI repo\ndetails for the PT2 blades & engine shop visit reports, once available",
          "nextActionBy": "DAE/NTE, DAE, AZUL",
          "targetDate": "2026-05-29"
        }
      },
      {
        "id": "min-34c8e96d-550",
        "number": "2.5",
        "sectionNumber": "2",
        "principalTopic": "Engines Delivered",
        "subTopic": "ED0570↔ ED0232",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-01-19",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "05-JAN",
              "source": "excel",
              "text": "In transit MIA — NEXT: Confirm arrival to NTE — [PENDING] — Engine arrived"
            },
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "Eng fitted on DAE A/C MSN: 1166 — [PENDING]"
            },
            {
              "date": "20-NOV",
              "source": "excel",
              "text": "Engine released"
            },
            {
              "date": "20-NOV",
              "source": "excel",
              "text": ". Pending pikcup from NTE — [PENDING] — ED0570 in PLU Records expected by [Confirm with Gustavo]"
            },
            {
              "date": "02-DEC",
              "source": "excel",
              "text": "QEC incomplete. No access to exhaust cone where corrosion was reported — NEXT: Confirm configuration matches incoming engine — [PENDING] — Engine shipped"
            },
            {
              "date": "02-DEC",
              "source": "excel",
              "text": "Engine in customs"
            },
            {
              "date": "03-DEC",
              "source": "excel",
              "text": "@ VCP --> Going to PLU — NEXT: Confirm arrival and installation on DAE Aircraft"
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "Shipping - Export process started. To be shipped by"
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "Email : DAE to confirm if 32 HPT blades were replaced during 2023 SV and provide support data"
            },
            {
              "date": "23-DEC",
              "source": "excel",
              "text": "DAE responded to all queries. No answer received. — NEXT: Awaiting Leonardo's email. — [PENDING]"
            },
            {
              "date": "27-DEC",
              "source": "excel",
              "text": "Shipped with AWB 369-83317102"
            },
            {
              "date": "2025-11-20",
              "source": "meeting",
              "text": "Engine released"
            },
            {
              "date": "2025-11-20",
              "source": "meeting",
              "text": "Pending pikcup from NTE"
            },
            {
              "date": "2025-12-02",
              "source": "excel",
              "text": "Engine in customs"
            },
            {
              "date": "2025-12-02",
              "source": "excel",
              "text": "QEC incomplete. No access to exhaust cone where corrosion was reported"
            },
            {
              "date": "2025-12-03",
              "source": "excel",
              "text": "VCP --> Going to PLU"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "Shipping - Export process started. To be shipped by"
            },
            {
              "date": "2025-12-10",
              "source": "excel",
              "text": "Email : DAE to confirm if 32 HPT blades were replaced during 2023 SV and provide support data"
            },
            {
              "date": "2025-12-17",
              "source": "meeting",
              "text": "Azul to complete by end of year"
            },
            {
              "date": "2025-12-23",
              "source": "excel",
              "text": "DAE responded to all queries. No answer received."
            },
            {
              "date": "2025-12-25",
              "source": "meeting",
              "text": "DEC: Shipped with AWB 369-83317102"
            },
            {
              "date": "2026-01-05",
              "source": "meeting",
              "text": "In transit MIA"
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "DFPs will be prepared."
            },
            {
              "date": "2026-01-07",
              "source": "excel",
              "text": "Eng fitted on DAE A/C MSN: 1166"
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Leonardo will follow-up with Rafael. Priority on LLPs."
            },
            {
              "date": "",
              "source": "excel",
              "text": "- TA Executed"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0570 — Pendging Records — NEXT: Completeness 55%. — [PENDING] — Urgent - Follow up with Rafael"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Inspection performed"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0232 (In transit) — Shipped"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Records Shop visit pack shared with AZUL — NEXT: Confirm acceptance — [PENDING]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "HPT Blades query - Follow up."
            }
          ],
          "nextAction": "Completeness 55%.\nConfirm configuration matches incoming engine\nConfirm arrival to NTE\nConfirm arrival and installation on DAE Aircraft 07-JAN: Eng fitted on DAE A/C MSN: 1166",
          "nextActionBy": "DAE/AZUL, AZUL, AZUL DAE, DAE",
          "targetDate": "2026-01-19"
        }
      },
      {
        "id": "min-8df5e438-483",
        "number": "2.6",
        "sectionNumber": "2",
        "principalTopic": "Engines Delivered",
        "subTopic": "ED0886 ED0570 ED0541 ED0569",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "i. Azul to expedite documentation for the engines returning — NEXT: Share records for redelivery — [PENDING] — Follow up with Rafael Tracked on each engine swap"
            }
          ],
          "nextAction": "Share records for redelivery",
          "nextActionBy": "AZUL",
          "targetDate": ""
        }
      },
      {
        "id": "min-15c50b42-eec",
        "number": "2.7",
        "sectionNumber": "2",
        "principalTopic": "Engines Delivered",
        "subTopic": "ED0904↔ ED0306",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-01-19",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "In sequence - After ED0230+ED0232 swaps — [PENDING]"
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "Coordinate inspections for"
            },
            {
              "date": "17-DEC",
              "source": "excel",
              "text": "(@JTC) - Will be redelivered at belo Horizonte. (PLU)"
            },
            {
              "date": "31-DEC",
              "source": "excel",
              "text": "Engine inspected. — NEXT: Provide proof of storage and insurance prior TA Confirm if A/C will be ferried to Belo Horizonte for engine drop. — [PENDING] — Engine inspeted"
            },
            {
              "date": "2025-12-05",
              "source": "meeting",
              "text": "in Std Aero Paris"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "Insurance and sotrage records pending from AZUL."
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "Insurance and storage records pending from AZUL."
            },
            {
              "date": "2025-12-10",
              "source": "excel",
              "text": "Coordinate inspections for"
            },
            {
              "date": "2025-12-17",
              "source": "excel",
              "text": "JTC) - Will be redelivered at belo Horizonte. (PLU)"
            },
            {
              "date": "2025-12-31",
              "source": "excel",
              "text": "Engine inspected."
            },
            {
              "date": "2026-01-06",
              "source": "meeting",
              "text": "Pending release from French customs."
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "In sequence - After ED0230+ED0232 swaps"
            },
            {
              "date": "2026-01-14",
              "source": "meeting",
              "text": "Engine released from French Customs. Azul to pickup and provide shipping data. Confirm arrival and installation."
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Leonardo will follow-up with Rafael. Priority on LLPs."
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Pickup scheduled for"
            },
            {
              "date": "",
              "source": "excel",
              "text": "[PENDING]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0306 — Delivered — NEXT: Confirm installation in MSN 1042 — [PENDING] — Executed."
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0904 — Pending records — NEXT: Azul to provide recxords"
            },
            {
              "date": "",
              "source": "excel",
              "text": "On wing in MSN 1166 (AQQ) Insppection pending"
            }
          ],
          "nextAction": "Confirm installation in MSN 1042\nAzul to provide recxords 07-JAN: In sequence - After ED0230+ED0232 swaps\nProvide proof of storage and insurance prior TA Confirm if A/C will be ferried to Belo Horizonte for engine drop.",
          "nextActionBy": "AZUL",
          "targetDate": "2026-01-19"
        }
      },
      {
        "id": "min-746985f9-523",
        "number": "2.8",
        "sectionNumber": "2",
        "principalTopic": "Engines Delivered",
        "subTopic": "ED0736↔ ED0305",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-01-19",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "12-JAN",
              "source": "excel",
              "text": "— [PENDING] — Inspected"
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "Coordinate inspections for"
            },
            {
              "date": "17-DEC",
              "source": "excel",
              "text": "(@JTC) - Will be redelivered at belo Horizonte. (PLU) — NEXT: Provide proof of storage and insurance prior TA Confirm if A/C will be ferried to Belo Horizonte for engine drop. — [PENDING] — Inspected"
            },
            {
              "date": "2025-12-05",
              "source": "meeting",
              "text": "in Std Aero Paris"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "Coordinate inspections for"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "Insurance and sotrage records pending from AZUL."
            },
            {
              "date": "2025-12-13",
              "source": "meeting",
              "text": "Pending pikcup"
            },
            {
              "date": "2025-12-17",
              "source": "meeting",
              "text": "JTC) - Will be redelivered at belo Horizonte. (PLU)"
            },
            {
              "date": "2025-12-17",
              "source": "meeting",
              "text": "Doublecheck customs paperwork if anything is holding the engine."
            },
            {
              "date": "2026-01-06",
              "source": "meeting",
              "text": "Pending release from french customs."
            },
            {
              "date": "2026-01-14",
              "source": "meeting",
              "text": "Engine released from French Customs."
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Leonardo will follow-up with Rafael. Priority on LLPs."
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Pickup scheduled for"
            },
            {
              "date": "",
              "source": "excel",
              "text": "[PENDING]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0305 — Delivered — NEXT: Confirm installation in MSN 1042 — [PENDING]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0736 — Pending records — NEXT: 0% Progress — [PENDING]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "On wing in MSN 1166 (AQQ) Inspection pending"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Physical inspection — NEXT: Inspect aircraft in PLU"
            }
          ],
          "nextAction": "Confirm installation in MSN 1042\n0% Progress\nProvide proof of storage and insurance prior TA Confirm if A/C will be ferried to Belo Horizonte for engine drop.\nInspect aircraft in PLU 12-JAN",
          "nextActionBy": "AZUL, DAE",
          "targetDate": "2026-01-19"
        }
      },
      {
        "id": "min-3611c806-d0a",
        "number": "2.9",
        "sectionNumber": "2",
        "principalTopic": "Engines Delivered",
        "subTopic": "ED0671↔ ED0325",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-05-06",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "8-JAN",
              "source": "excel",
              "text": "— [CLOSED] — Inspected"
            },
            {
              "date": "06-MAY",
              "source": "excel",
              "text": "Ship to Standard Aero PEI Canada. — NEXT: Azul to provide AWB"
            },
            {
              "date": "2025-12-03",
              "source": "meeting",
              "text": "Awaiting shop visit report. LRUs to be covered under shop ARC umbrella. Full B2B to be provided."
            },
            {
              "date": "2026-01-13",
              "source": "meeting",
              "text": "Records sent for review (ESV 2026)"
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Leonardo will follow-up with Rafael. Priority on LLPs."
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "No comments on the documentation provided. AZUL to confirm if review is complete. Gustavo to inspect."
            },
            {
              "date": "2026-05-06",
              "source": "excel",
              "text": "Ship to Standard Aero PEI Canada."
            },
            {
              "date": "",
              "source": "excel",
              "text": "[PENDING] — Eng in Gonesse France"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0671 —"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Pending records — NEXT: 0% Progress — [PENDING]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Physical inspection — NEXT: Inspect aircraft in VCP"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0325 — Delivered — NEXT: Confirm installation in MSN 1042 — [PENDING] — Follow up with Gustavo."
            },
            {
              "date": "",
              "source": "excel",
              "text": "-HSI Complete - Engines held in shop for PT2 blades replacement - work in progress at Std Aero (stator repair / replacement pacing item) — NEXT: ED0324 - Available probably earlier than FEB ED0325 - TBD. — [CLOSED] — Engine released"
            },
            {
              "date": "",
              "source": "excel",
              "text": "AZUL Engineering reviewing (HIS + PT2 blades) — NEXT: Confirm acceptance — [CLOSED] — Tracked above"
            }
          ],
          "nextAction": "Azul to provide AWB\n0% Progress\nConfirm installation in MSN 1042",
          "nextActionBy": "DAE, AZUL, Std Aero, Azul",
          "targetDate": "2026-05-06"
        }
      },
      {
        "id": "min-ad4b1724-a30",
        "number": "2.10",
        "sectionNumber": "2",
        "principalTopic": "Engines Delivered",
        "subTopic": "ED0942↔ ED0324",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-05-06",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "Inspection date might change."
            },
            {
              "date": "21-JAN",
              "source": "excel",
              "text": "Inspection to be scheduled in Campinas. No stand available. Date to be confirmed."
            },
            {
              "date": "11-FEB",
              "source": "excel",
              "text": "Engine on wing"
            },
            {
              "date": "11-FEB",
              "source": "excel",
              "text": "AZUL to provide inspection date."
            },
            {
              "date": "20-FEB",
              "source": "excel",
              "text": "Eng removed. @JTC and will be shipped to PLU for inspection"
            },
            {
              "date": "20-FEB",
              "source": "excel",
              "text": "Provide storage data and confirm inspection date and location — [IN PROGRESS]"
            },
            {
              "date": "24-FEB",
              "source": "excel",
              "text": "Engine is off-wing. Will ship to Campinas. — NEXT: Inspect aircraft in PLU"
            },
            {
              "date": "06-MAY",
              "source": "excel",
              "text": "Ship to Standard Aero PEI Canada. — NEXT: Azul to provide AWB — [PENDING]"
            },
            {
              "date": "15-DEC",
              "source": "excel",
              "text": "Possible release by"
            },
            {
              "date": "23-DEC",
              "source": "excel",
              "text": "— NEXT: ED0324 - Available probably earlier than FEB ED0325 - TBD. — [CLOSED] — Engine released"
            },
            {
              "date": "2007-01-12",
              "source": "meeting",
              "text": "JAN: Inspection date might change."
            },
            {
              "date": "2015-12-03",
              "source": "meeting",
              "text": "DEC: Possible release by"
            },
            {
              "date": "2025-12-03",
              "source": "meeting",
              "text": "Awaiting shop visit report. LRUs to be covered under shop ARC umbrella. Full B2B to be provided."
            },
            {
              "date": "2026-01-13",
              "source": "meeting",
              "text": "Records sent for review (ESV 2026)"
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Leonardo will follow-up with Rafael. Priority on LLPs."
            },
            {
              "date": "2026-01-21",
              "source": "excel",
              "text": "Inspection to be scheduled in Campinas. No stand available. Date to be confirmed."
            },
            {
              "date": "2026-02-11",
              "source": "excel",
              "text": "AZUL to provide inspection date."
            },
            {
              "date": "2026-02-11",
              "source": "excel",
              "text": "Engine on wing"
            },
            {
              "date": "2026-02-20",
              "source": "excel",
              "text": "Eng removed. @JTC and will be shipped to PLU for inspection"
            },
            {
              "date": "2026-02-20",
              "source": "excel",
              "text": "Provide storage data and confirm inspection date and location"
            },
            {
              "date": "2026-02-24",
              "source": "excel",
              "text": "Engine is off-wing. Will ship to Campinas."
            },
            {
              "date": "2026-05-06",
              "source": "excel",
              "text": "Ship to Standard Aero PEI Canada."
            },
            {
              "date": "",
              "source": "excel",
              "text": "[IN PROGRESS] — Eng in SA Prince Edward Island Canada"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0324 — Confirm pickup and installation — NEXT: Confirm pickup and installation — [PENDING]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Eng in SA Prince Edward Island Canada 'Test cell"
            },
            {
              "date": "",
              "source": "excel",
              "text": "AZUL Engineering reviewing (HIS + PT2 blades) — NEXT: Confirm acceptance — [CLOSED] — Inform if there is any objection with records ASAP. Tracked on records above."
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0942 — Pending records — NEXT: 0% Progress — [PENDING]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Physical inspection"
            }
          ],
          "nextAction": "Confirm pickup and installation\n0% Progress\nInspect aircraft in PLU 12-JAN 07-JAN: Inspection date might change. 11-FEB: AZUL to provide inspection date. 20-FEB: Provide storage data a\nAzul to provide AWB",
          "nextActionBy": "AZUL, Std Aero",
          "targetDate": "2026-05-06"
        }
      },
      {
        "id": "min-4971aebe-855",
        "number": "3.1",
        "sectionNumber": "3",
        "principalTopic": "Engines at NTE / Std Aero",
        "subTopic": "ED0232",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "Engine released TA Executed — [COMPLETE] — Wil be installed on MSN 1115"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Records Shop visit pack shared with AZUL — NEXT: Confirm acceptance — [COMPLETE] — Tracked on section above"
            }
          ],
          "nextAction": "",
          "nextActionBy": "DAE NTE, AZUL",
          "targetDate": ""
        }
      },
      {
        "id": "min-75a3e14d-c1f",
        "number": "3.2",
        "sectionNumber": "3",
        "principalTopic": "Engines at NTE / Std Aero",
        "subTopic": "ED0230",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2025-11-04",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "4-NOV",
              "source": "excel",
              "text": "to NTE - Stator delayed to"
            },
            {
              "date": "4-NOV",
              "source": "excel",
              "text": "Engine ready for pkcup. — [COMPLETE] — Azul to inspect ED0230/2 on 5/Nov Will be installed on MSN 1115"
            },
            {
              "date": "2025-11-04",
              "source": "excel",
              "text": "Engine ready for pkcup."
            },
            {
              "date": "2025-11-04",
              "source": "excel",
              "text": "to NTE - Stator delayed to"
            },
            {
              "date": "",
              "source": "excel",
              "text": "PT2 pack - Received at Std Aero on 22/OCT - Shipped from Std Aero"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Records Shop visit pack shared with AZUL — NEXT: Confirm acceptance — [IN PROGRESS] — Tracked on section above"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Sign technical acceptance — [COMPLETE] — Tracked on section above"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Installation on MSN 1115 — NEXT: Azul to confirm installation — [IN PROGRESS] — Tracked on section above"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0230 ED0232 — Inpsections @ NTE GVI + witness BSIs regardless of PT2 completeness. — NEXT: Gustavo on site AZUL to confirm acceptance of BSI. (verbal confirmation received) — [COMPLETE]"
            }
          ],
          "nextAction": "Confirm acceptance\nAzul to confirm installation",
          "nextActionBy": "DAE NTE, AZUL, DAE",
          "targetDate": "2025-11-04"
        }
      },
      {
        "id": "min-2ad466f1-645",
        "number": "3.3",
        "sectionNumber": "3",
        "principalTopic": "Engines at NTE / Std Aero",
        "subTopic": "EB0133",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2025-12-03",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "01-DEC",
              "source": "excel",
              "text": "Engine will ship to STD Aero"
            },
            {
              "date": "03-DEC",
              "source": "excel",
              "text": "PT2 Blades on backorder with PWC — [IN PROGRESS]"
            },
            {
              "date": "2025-12-01",
              "source": "excel",
              "text": "Engine will ship to STD Aero"
            },
            {
              "date": "2025-12-03",
              "source": "excel",
              "text": "PT2 Blades on backorder with PWC"
            },
            {
              "date": "",
              "source": "excel",
              "text": "PT2 Blades and Trhust upgrade - ENG at NTE for PT2 removal - PT2 pack removed/shipment to STD Aero being confirmed - Engine availability delayed to 24/Nov (pending PT2 blades availability - delay on the supply chain from PWC) - RGB replacement (?) - PT2 blades on backorder - AOG request with PWC. Possible exchange with ED1541 blades."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Records — NEXT: details for the PT2 blades & engine shop visit reports, once available — [IN PROGRESS]"
            },
            {
              "date": "",
              "source": "excel",
              "text": "10x engines (9 in work) — NEXT: Maintain release plan (3 engines/month) — [CLOSED] — Tracked below"
            }
          ],
          "nextAction": "details for the PT2 blades & engine shop visit reports, once available",
          "nextActionBy": "DAE, PWC",
          "targetDate": "2025-12-03"
        }
      },
      {
        "id": "min-2c7e23b1-8eb",
        "number": "4.1",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1083",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-01-06",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "06-JAN",
              "source": "excel",
              "text": "ESV package received. — NEXT: - Confirm installation — [CLOSED] — ESV provided"
            },
            {
              "date": "03-DEC",
              "source": "excel",
              "text": "Expected end of WK50 in Brazil"
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "Arrived at AZUL."
            },
            {
              "date": "12-DEC",
              "source": "excel",
              "text": "Provide ESV Package."
            },
            {
              "date": "2025-12-03",
              "source": "excel",
              "text": "Expected end of WK50 in Brazil"
            },
            {
              "date": "2025-12-10",
              "source": "excel",
              "text": "Arrived at AZUL."
            },
            {
              "date": "2025-12-12",
              "source": "excel",
              "text": "Provide ESV Package."
            },
            {
              "date": "2026-01-06",
              "source": "excel",
              "text": "ESV package received."
            },
            {
              "date": "",
              "source": "excel",
              "text": "WS: OVERHAUL + LLP HP blade distress\" Released. Payment being sent WK 49."
            }
          ],
          "nextAction": "",
          "nextActionBy": "PWC",
          "targetDate": "2026-01-06"
        }
      },
      {
        "id": "min-072799ef-5aa",
        "number": "4.2",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1141",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-23",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "NORMAL",
          "history": [
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "Going to STD Aero — NEXT: Confirm — [PENDING]"
            },
            {
              "date": "2026-03-25",
              "source": "excel",
              "text": "Going to STD Aero"
            },
            {
              "date": "2026-04-23",
              "source": "meeting",
              "text": "TPA Standard Aero Payment approved for engines ED1141, ED1025, and ED1008. Payment scheduled for 30 April. DAE contacted the shop and confirmed the timeline is acceptable."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Provide plan"
            }
          ],
          "nextAction": "Confirm",
          "nextActionBy": "AZUL",
          "targetDate": "2026-04-23"
        }
      },
      {
        "id": "min-d376c3a9-e70",
        "number": "4.3",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1113",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-02",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "2014-01-08",
              "source": "meeting",
              "text": "JAN- Changed to"
            },
            {
              "date": "2026-01-05",
              "source": "meeting",
              "text": "ETD"
            },
            {
              "date": "2026-04-02",
              "source": "meeting",
              "text": "Engines in Shop: Azul confirmed the release of engines ED1113, ED0604, ED0941, and ED1110 in late March. Awaiting ESV records."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Released from shop - SV Available. — NEXT: Confirm installation — [IN PROGRESS] — Follow up with Otavio."
            }
          ],
          "nextAction": "Confirm installation",
          "nextActionBy": "AZUL",
          "targetDate": "2026-04-02"
        }
      },
      {
        "id": "min-d75a53ba-7b6",
        "number": "4.4",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED0604",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-02",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "2014-01-12",
              "source": "meeting",
              "text": "JAN changed to"
            },
            {
              "date": "2026-01-05",
              "source": "meeting",
              "text": "ETD"
            },
            {
              "date": "2026-04-02",
              "source": "meeting",
              "text": "Engines in Shop: Azul confirmed the release of engines ED1113, ED0604, ED0941, and ED1110 in late March. Awaiting ESV records."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Released from shop - SV Available. — NEXT: Confirm installation — [IN PROGRESS]"
            }
          ],
          "nextAction": "Confirm installation",
          "nextActionBy": "AZUL",
          "targetDate": "2026-04-02"
        }
      },
      {
        "id": "min-552e236a-3a1",
        "number": "4.5",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED0941",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-02",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "2026-01-05",
              "source": "meeting",
              "text": "HP, LP Disk- LP Impeller - HPT Front & Rear cover - HP, LP & PT Blades - PT Stator -GGC"
            },
            {
              "date": "2026-04-02",
              "source": "meeting",
              "text": "Engines in Shop: Azul confirmed the release of engines ED1113, ED0604, ED0941, and ED1110 in late March. Awaiting ESV records."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Released from shop - SV Available. — NEXT: Confirm installation — [IN PROGRESS]"
            }
          ],
          "nextAction": "Confirm installation",
          "nextActionBy": "AZUL",
          "targetDate": "2026-04-02"
        }
      },
      {
        "id": "min-0831eca2-1b2",
        "number": "4.6",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1110",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-02",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "2026-01-05",
              "source": "meeting",
              "text": "HP, LP Disk- LP Impeller - HPT Front & Rear cover - HP, LP & PT Blades - PT Stator -GGC"
            },
            {
              "date": "2026-01-14",
              "source": "meeting",
              "text": "Release updated to"
            },
            {
              "date": "2026-04-02",
              "source": "meeting",
              "text": "Engines in Shop: Azul confirmed the release of engines ED1113, ED0604, ED0941, and ED1110 in late March. Awaiting ESV records."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Released from shop - SV Available. — NEXT: Confirm installation — [IN PROGRESS] — –"
            }
          ],
          "nextAction": "Confirm installation",
          "nextActionBy": "AZUL",
          "targetDate": "2026-04-02"
        }
      },
      {
        "id": "min-54a2b76d-599",
        "number": "4.7",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED0701",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-05-29",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "26-MAY",
              "source": "excel",
              "text": "— NEXT: Azul to provide ESV Report — [IN PROGRESS]"
            },
            {
              "date": "27-MAY",
              "source": "excel",
              "text": "Released"
            },
            {
              "date": "2026-05-27",
              "source": "excel",
              "text": "Released"
            },
            {
              "date": "2026-05-29",
              "source": "meeting",
              "text": "Azul confirmed the release in May of engines ED0701, ED0710, and ED0799 ."
            },
            {
              "date": "",
              "source": "excel",
              "text": "WS: TAIL PIPE SMOKE + REP EMT INVESTIGATION Not disassembled yet - Awaiting induction in APR-2026"
            }
          ],
          "nextAction": "Azul to provide ESV Report",
          "nextActionBy": "PWC",
          "targetDate": "2026-05-29"
        }
      },
      {
        "id": "min-e5d04207-e40",
        "number": "4.8",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED0905",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-06-03",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "5-JAN",
              "source": "excel",
              "text": "Engine is being prepared for shipment at PL5"
            },
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "Engine in shop. Release changed to APR 2026"
            },
            {
              "date": "28-JAN",
              "source": "excel",
              "text": "Induction"
            },
            {
              "date": "11-FEB",
              "source": "excel",
              "text": "Shop quotation gap (Approx 500k difference ) - Azul to confirm if insurance will cover the difference. Azul to confirm."
            },
            {
              "date": "19-FEB",
              "source": "excel",
              "text": "Insruance will inspect engine at PT5."
            },
            {
              "date": "23-FEB",
              "source": "excel",
              "text": "Insurance deductible 100K. It could take 6 months for insurance payment. Under review."
            },
            {
              "date": "25-FEB",
              "source": "excel",
              "text": "(PT5)"
            },
            {
              "date": "11-MAR",
              "source": "excel",
              "text": "Azul to confirm if insurance inspection took place."
            },
            {
              "date": "18-MAR",
              "source": "excel",
              "text": "Insurance inspetion completed. Awaiting PWC report. Payment to be made by azul on the Insurance amount per terms sheet conditions."
            },
            {
              "date": "22-MAY",
              "source": "excel",
              "text": "Breakout costs requested to shop. (FOD / HSI related....)"
            },
            {
              "date": "3-JUN",
              "source": "excel",
              "text": "Azul to confirm cost of shop visit - How much is the insurance covering ? — NEXT: Confirm induction dates & TAT Confirm insurance coverage on price difference. Confirm insurance inspection was performed. — [IN PROGRESS]"
            },
            {
              "date": "2026-01-05",
              "source": "meeting",
              "text": "Engine is being prepared for shipment at PL5"
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "Engine in shop. Release changed to APR 2026"
            },
            {
              "date": "2026-01-28",
              "source": "excel",
              "text": "Induction"
            },
            {
              "date": "2026-02-11",
              "source": "excel",
              "text": "Shop quotation gap (Approx 500k difference ) - Azul to confirm if insurance will cover the difference. Azul to confirm."
            },
            {
              "date": "2026-02-19",
              "source": "excel",
              "text": "Insruance will inspect engine at PT5."
            },
            {
              "date": "2026-02-23",
              "source": "excel",
              "text": "Insurance deductible 100K. It could take 6 months for insurance payment. Under review."
            },
            {
              "date": "2026-02-25",
              "source": "excel",
              "text": "PT5)"
            },
            {
              "date": "2026-03-11",
              "source": "excel",
              "text": "Azul to confirm if insurance inspection took place."
            },
            {
              "date": "2026-03-18",
              "source": "excel",
              "text": "Insurance inspetion completed. Awaiting PWC report. Payment to be made by azul on the Insurance amount per terms sheet conditions."
            },
            {
              "date": "2026-05-22",
              "source": "excel",
              "text": "Breakout costs requested to shop. (FOD / HSI related....)"
            },
            {
              "date": "2026-06-03",
              "source": "excel",
              "text": "Azul to confirm cost of shop visit - How much is the insurance covering ?"
            },
            {
              "date": "",
              "source": "excel",
              "text": "WS: HSI + FOD HSI - Will be inducted at Plant 5 insurance related & confirmed - induction subject to clearing the shop (likely Jan/26)"
            }
          ],
          "nextAction": "Confirm induction dates & TAT Confirm insurance coverage on price difference. Confirm insurance inspection was performed.",
          "nextActionBy": "PWC PT5",
          "targetDate": "2026-06-03"
        }
      },
      {
        "id": "min-0099fc94-826",
        "number": "4.9",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1007",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-03-25",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "5-JAN",
              "source": "excel",
              "text": "Rework 85% completed Ordered parts missing (70% received) :LP Disc - LP Impeller- Rear cover -HP & 2x PT Blades -PT Stator -GGC"
            },
            {
              "date": "04-FEB",
              "source": "excel",
              "text": "Release date"
            },
            {
              "date": "20-FEB",
              "source": "excel",
              "text": "Release date"
            },
            {
              "date": "04-MAR",
              "source": "excel",
              "text": "Release"
            },
            {
              "date": "17-MAR",
              "source": "excel",
              "text": "."
            },
            {
              "date": "18-MAR",
              "source": "excel",
              "text": "Release"
            },
            {
              "date": "21-MAR",
              "source": "excel",
              "text": ".(Materials) — NEXT: Confirm installation — [IN PROGRESS]"
            },
            {
              "date": "2004-03-15",
              "source": "excel",
              "text": "MAR: Release"
            },
            {
              "date": "2020-02-27",
              "source": "excel",
              "text": "FEB: Release date"
            },
            {
              "date": "2026-01-05",
              "source": "meeting",
              "text": "Rework 85% completed Ordered parts missing (70% received) :LP Disc - LP Impeller- Rear cover -HP & 2x PT Blades -PT Stator -GGC"
            },
            {
              "date": "2026-02-04",
              "source": "excel",
              "text": "Release date"
            },
            {
              "date": "2026-03-18",
              "source": "excel",
              "text": "Release"
            },
            {
              "date": "2026-03-21",
              "source": "excel",
              "text": "Materials)"
            },
            {
              "date": "2026-03-25",
              "source": "meeting",
              "text": "March shop releases remain firm, with a 2-day delay. Azul to confirm release dates for the three engines (ED1007, ED0712, ED0797) by Friday, 27 March."
            },
            {
              "date": "",
              "source": "excel",
              "text": "WS: OVH Might improve to JAN-26"
            }
          ],
          "nextAction": "Confirm installation",
          "nextActionBy": "PWC",
          "targetDate": "2026-03-25"
        }
      },
      {
        "id": "min-89446469-ff9",
        "number": "4.10",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED0797",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-03-25",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "5-JAN",
              "source": "excel",
              "text": "Rework 90%"
            },
            {
              "date": "20-FEB",
              "source": "excel",
              "text": "Release date MAR-23"
            },
            {
              "date": "04-MAR",
              "source": "excel",
              "text": "Release date MAR-28 — NEXT: Confirm installation — [IN PROGRESS]"
            },
            {
              "date": "2026-01-05",
              "source": "meeting",
              "text": "Rework 90%"
            },
            {
              "date": "2026-02-20",
              "source": "excel",
              "text": "Release date MAR-23"
            },
            {
              "date": "2026-03-04",
              "source": "excel",
              "text": "Release date MAR-28"
            },
            {
              "date": "2026-03-25",
              "source": "meeting",
              "text": "March shop releases remain firm, with a 2-day delay. Azul to confirm release dates for the three engines (ED1007, ED0712, ED0797) by Friday, 27 March."
            },
            {
              "date": "",
              "source": "excel",
              "text": "WS: OVH + LLP Might improve to JAN-26"
            }
          ],
          "nextAction": "Confirm installation",
          "nextActionBy": "PWC",
          "targetDate": "2026-03-25"
        }
      },
      {
        "id": "min-037d7c8f-917",
        "number": "4.11",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1085",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-02-20",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "20-FEB",
              "source": "excel",
              "text": "Release"
            },
            {
              "date": "31-MAR",
              "source": "excel",
              "text": "— NEXT: Confirm installation — [IN PROGRESS]"
            },
            {
              "date": "2026-02-20",
              "source": "excel",
              "text": "Release"
            },
            {
              "date": "",
              "source": "excel",
              "text": "WS: EMT INVESTIGATION ? PIPE SMOKE + OH & LLP Should pull to FEB-26"
            }
          ],
          "nextAction": "Confirm installation",
          "nextActionBy": "PWC",
          "targetDate": "2026-02-20"
        }
      },
      {
        "id": "min-93071911-661",
        "number": "4.12",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1008",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-23",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "Engine inducted in the queue for dissaslbly. No release date yet. — [IN PROGRESS]"
            },
            {
              "date": "2026-03-25",
              "source": "excel",
              "text": "Engine inducted in the queue for dissaslbly. No release date yet."
            },
            {
              "date": "2026-04-23",
              "source": "meeting",
              "text": "TPA Standard Aero Payment approved for engines ED1141, ED1025, and ED1008. Payment scheduled for 30 April. DAE contacted the shop and confirmed the timeline is acceptable."
            }
          ],
          "nextAction": "",
          "nextActionBy": "PWC",
          "targetDate": "2026-04-23"
        }
      },
      {
        "id": "min-01682d65-2a9",
        "number": "4.13",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED0942",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "Possible exchange with ED0234 — NEXT: Confirm — [CLOSED] — Exchange weith ED0324"
            }
          ],
          "nextAction": "",
          "nextActionBy": "PWC",
          "targetDate": ""
        }
      },
      {
        "id": "min-13c52fee-9c0",
        "number": "4.14",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED0863",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2025-12-10",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "NORMAL",
          "history": [
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "WS: OVH - (With ED1463-GB) — [PENDING]"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "WS: OVH - (With ED1463-GB)"
            }
          ],
          "nextAction": "",
          "nextActionBy": "PWC",
          "targetDate": "2025-12-10"
        }
      },
      {
        "id": "min-16f31ad9-5d0",
        "number": "4.15",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1463",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2025-12-10",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "WS: OVH — [CLOSED] — Not to be tracked"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "WS: OVH"
            }
          ],
          "nextAction": "",
          "nextActionBy": "PWC",
          "targetDate": "2025-12-10"
        }
      },
      {
        "id": "min-f40042ab-e58",
        "number": "4.16",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED0682",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-03-25",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "NORMAL",
          "history": [
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "Engine inducted and is Cost Estimate received under Azul’s review, no redelivery date yet. — [PENDING] — Std Aero"
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "WS: OVH"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "WS: OVH"
            },
            {
              "date": "2026-03-25",
              "source": "excel",
              "text": "Engine inducted and is Cost Estimate received under Azul’s review, no redelivery date yet."
            }
          ],
          "nextAction": "",
          "nextActionBy": "PWC",
          "targetDate": "2026-03-25"
        }
      },
      {
        "id": "min-5ef964e6-224",
        "number": "4.17",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1008",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2025-12-10",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "NORMAL",
          "history": [
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "WS: OVH — [PENDING]"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "WS: OVH"
            }
          ],
          "nextAction": "",
          "nextActionBy": "PWC",
          "targetDate": "2025-12-10"
        }
      },
      {
        "id": "min-0cedfe5b-df4",
        "number": "4.18",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1025",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-23",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "NORMAL",
          "history": [
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "WS: OVH — [PENDING]"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "WS: OVH"
            },
            {
              "date": "2026-04-23",
              "source": "meeting",
              "text": "TPA Standard Aero Payment approved for engines ED1141, ED1025, and ED1008. Payment scheduled for 30 April. DAE contacted the shop and confirmed the timeline is acceptable."
            }
          ],
          "nextAction": "",
          "nextActionBy": "PWC",
          "targetDate": "2026-04-23"
        }
      },
      {
        "id": "min-5699c0c6-b29",
        "number": "4.19",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED0607",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-03-05",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "5-JAN",
              "source": "excel",
              "text": "HSI - GGC Access (Weld) Can not be done in Sorocaba, GGC Access"
            },
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "PT5 instead. NO slot confirmed."
            },
            {
              "date": "14-JAN",
              "source": "excel",
              "text": "Might be included in StdAero TPA."
            },
            {
              "date": "05-MAR",
              "source": "excel",
              "text": "possible induction date. — NEXT: Confirm — [CLOSED] — Will be induced in PW SOrocaba"
            },
            {
              "date": "2026-01-05",
              "source": "meeting",
              "text": "HSI - GGC Access (Weld) Can not be done in Sorocaba, GGC Access"
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "PT5 instead. NO slot confirmed."
            },
            {
              "date": "2026-01-14",
              "source": "meeting",
              "text": "Might be included in StdAero TPA."
            },
            {
              "date": "2026-03-05",
              "source": "meeting",
              "text": "possible induction date."
            }
          ],
          "nextAction": "",
          "nextActionBy": "",
          "targetDate": "2026-03-05"
        }
      },
      {
        "id": "min-e6d85231-bef",
        "number": "4.21",
        "sectionNumber": "4",
        "principalTopic": "PW Canada Overhauls",
        "subTopic": "ED1142",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-16",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "NORMAL",
          "history": [
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "Induction date"
            },
            {
              "date": "16-APR",
              "source": "excel",
              "text": ". NO release date yet. — NEXT: Confirm — [PENDING]"
            },
            {
              "date": "2026-03-25",
              "source": "excel",
              "text": "Induction date"
            },
            {
              "date": "2026-04-16",
              "source": "excel",
              "text": "NO release date yet."
            }
          ],
          "nextAction": "Confirm",
          "nextActionBy": "AZUL",
          "targetDate": "2026-04-16"
        }
      },
      {
        "id": "min-64431e34-7f1",
        "number": "5.1",
        "sectionNumber": "5",
        "principalTopic": "PW Sorocaba / Std Aero HSI",
        "subTopic": "—",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "List of engines for HSI, sequence of induction and workscopes received (not on the workscope but Azul confirmed new LLP's will be installed) — NEXT: Confirm induction dates & TAT — [CLOSED]"
            }
          ],
          "nextAction": "",
          "nextActionBy": "PWC / Azul",
          "targetDate": ""
        }
      },
      {
        "id": "min-9ad8ec1e-9e2",
        "number": "5.2",
        "sectionNumber": "5",
        "principalTopic": "PW Sorocaba / Std Aero HSI",
        "subTopic": "ED0712",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-05-13",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "04-FEB",
              "source": "excel",
              "text": "Possible delay due to parts LT."
            },
            {
              "date": "20-FEB",
              "source": "excel",
              "text": "Delayed (parts). Release expected by mid-March"
            },
            {
              "date": "04-MAR",
              "source": "excel",
              "text": "Relase"
            },
            {
              "date": "11-MAR",
              "source": "excel",
              "text": "Issue with balance. MAR-23 new release date."
            },
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "Engine SV. Awaiting payment scheudled for this week. — NEXT: Pending ESV package — [IN PROGRESS]"
            },
            {
              "date": "2011-03-13",
              "source": "excel",
              "text": "MAR: Issue with balance. MAR-23 new release date."
            },
            {
              "date": "2026-02-04",
              "source": "excel",
              "text": "Possible delay due to parts LT."
            },
            {
              "date": "2026-02-20",
              "source": "excel",
              "text": "Delayed (parts). Release expected by mid-March"
            },
            {
              "date": "2026-03-04",
              "source": "excel",
              "text": "Relase"
            },
            {
              "date": "2026-03-25",
              "source": "meeting",
              "text": "March shop releases remain firm, with a 2-day delay. Azul to confirm release dates for the three engines (ED1007, ED0712, ED0797) by Friday, 27 March."
            },
            {
              "date": "2026-03-25",
              "source": "excel",
              "text": "Engine SV. Awaiting payment scheudled for this week."
            },
            {
              "date": "2026-05-13",
              "source": "meeting",
              "text": "ED0712, ED0799: Received at Azul facilities. Azul to provide shop visit packages."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Induction date NOV-11 Engine arrived to shop. Awaiting payment update."
            }
          ],
          "nextAction": "Pending ESV package",
          "nextActionBy": "AZUL",
          "targetDate": "2026-05-13"
        }
      },
      {
        "id": "min-e9a2076a-893",
        "number": "5.3",
        "sectionNumber": "5",
        "principalTopic": "PW Sorocaba / Std Aero HSI",
        "subTopic": "ED0710",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-05-29",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "21-JAN",
              "source": "excel",
              "text": "Induction in"
            },
            {
              "date": "26-JAN",
              "source": "excel",
              "text": "Workscope approved. Ok to induct"
            },
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "Engine inducted on Feb 02nd, redelivery date probably in May."
            },
            {
              "date": "27-MAY",
              "source": "excel",
              "text": "Released and received in Azul — NEXT: Azul to provide ESV Report — [IN PROGRESS]"
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "Engine scheduled for HSI at StandardAero subject to TPA. Tracked on item 11.1 below."
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "Engine scheduled for HSI at StandardAero subject to TPA. Tracked on item 11.1 below."
            },
            {
              "date": "2026-01-21",
              "source": "excel",
              "text": "Induction in"
            },
            {
              "date": "2026-01-26",
              "source": "excel",
              "text": "Workscope approved. Ok to induct"
            },
            {
              "date": "2026-01-27",
              "source": "excel",
              "text": "Release TBC"
            },
            {
              "date": "27-JAN-26",
              "source": "excel",
              "text": ". Release TBC"
            },
            {
              "date": "2026-03-25",
              "source": "excel",
              "text": "Engine inducted on Feb 02nd, redelivery date probably in May."
            },
            {
              "date": "2026-05-27",
              "source": "excel",
              "text": "Released and received in Azul"
            },
            {
              "date": "2026-05-29",
              "source": "meeting",
              "text": "Azul confirmed the release in May of engines ED0701, ED0710, and ED0799 ."
            },
            {
              "date": "2026-05-29",
              "source": "meeting",
              "text": "Shop visit reports have been provided by Azul. ED0710 report pending."
            },
            {
              "date": "",
              "source": "excel",
              "text": "HSI"
            }
          ],
          "nextAction": "Azul to provide ESV Report",
          "nextActionBy": "AZUL",
          "targetDate": "2026-05-29"
        }
      },
      {
        "id": "min-112021f1-eae",
        "number": "5.4",
        "sectionNumber": "5",
        "principalTopic": "PW Sorocaba / Std Aero HSI",
        "subTopic": "ED0607",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-03-31",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "28-JAN",
              "source": "excel",
              "text": "Will move to PT5. Shipment in progress."
            },
            {
              "date": "25-FEB",
              "source": "excel",
              "text": "Moving to PT5. Induction in March."
            },
            {
              "date": "18-MAR",
              "source": "excel",
              "text": "Refund issue being discussed with DAE via email. (Credit for other engines, or refund and forward payment to PT5). 38K Customs charge for refunding the payment."
            },
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "31-MARCH induction date. No release date yet. — NEXT: Confirm release date — [IN PROGRESS] — to PT5"
            },
            {
              "date": "24-NOV",
              "source": "excel",
              "text": "Payment approved. Scheduled for DEC 5th Release expected MAR-10"
            },
            {
              "date": "08-DEC",
              "source": "excel",
              "text": "DAE confirmed acceptance"
            },
            {
              "date": "2025-11-24",
              "source": "meeting",
              "text": "Payment approved. Scheduled for DEC 5th Release expected MAR-10"
            },
            {
              "date": "2025-12-08",
              "source": "meeting",
              "text": "DAE confirmed acceptance"
            },
            {
              "date": "2026-01-28",
              "source": "excel",
              "text": "Will move to PT5. Shipment in progress."
            },
            {
              "date": "2026-02-25",
              "source": "excel",
              "text": "Moving to PT5. Induction in March."
            },
            {
              "date": "2026-03-18",
              "source": "excel",
              "text": "Refund issue being discussed with DAE via email. (Credit for other engines, or refund and forward payment to PT5). 38K Customs charge for refunding the payment."
            },
            {
              "date": "2026-03-31",
              "source": "excel",
              "text": "CH induction date. No release date yet."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Induction date"
            }
          ],
          "nextAction": "Confirm release date",
          "nextActionBy": "PWC PT5",
          "targetDate": "2026-03-31"
        }
      },
      {
        "id": "min-f80ce8fe-70d",
        "number": "5.5",
        "sectionNumber": "5",
        "principalTopic": "PW Sorocaba / Std Aero HSI",
        "subTopic": "ED0799",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-05-29",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "19-JAN",
              "source": "excel",
              "text": "Added again to PWC list (out from StdAero). Engine will ship this week."
            },
            {
              "date": "21-JAN",
              "source": "excel",
              "text": "Induction in 27- JAN-26. Release TBC"
            },
            {
              "date": "26-JAN",
              "source": "excel",
              "text": "Workscope approved. Ok to induct"
            },
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "Engine inducted on Jan 26th, redelivery target to April 29th. — NEXT: Confirm release and send SV package. — [IN PROGRESS] — PO 79020 1.1M"
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "Engine scheduled for HSI at StandardAero subject to TPA. Tracked on item 11.1 below."
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "Engine scheduled for HSI at StandardAero subject to TPA. Tracked on item 11.1 below."
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Added again to PWC list (out from StdAero). Engine will ship this week."
            },
            {
              "date": "2026-01-21",
              "source": "excel",
              "text": "Induction in 27- JAN-26. Release TBC"
            },
            {
              "date": "2026-01-26",
              "source": "excel",
              "text": "Workscope approved. Ok to induct"
            },
            {
              "date": "2026-03-25",
              "source": "excel",
              "text": "Engine inducted on Jan 26th, redelivery target to April 29th."
            },
            {
              "date": "2026-05-13",
              "source": "meeting",
              "text": "ED0712, ED0799: Received at Azul facilities. Azul to provide shop visit packages."
            },
            {
              "date": "2026-05-29",
              "source": "meeting",
              "text": "Azul confirmed the release in May of engines ED0701, ED0710, and ED0799 ."
            },
            {
              "date": "",
              "source": "excel",
              "text": "HSI"
            }
          ],
          "nextAction": "Confirm release and send SV package.",
          "nextActionBy": "AZUL",
          "targetDate": "2026-05-29"
        }
      },
      {
        "id": "min-6104202e-6cb",
        "number": "5.6",
        "sectionNumber": "5",
        "principalTopic": "PW Sorocaba / Std Aero HSI",
        "subTopic": "ED0542",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-05-29",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "26-JAN",
              "source": "excel",
              "text": "Workscope approved. Ok to induct"
            },
            {
              "date": "27-FEB",
              "source": "excel",
              "text": "Workscope sent to shop."
            },
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "Engine inducted on March 18th, no redelivery date yet."
            },
            {
              "date": "08-APR",
              "source": "excel",
              "text": "Part of ESV to be performed in PT5 due to capability limitations. Azul to provide detail on affected parts. TAT might be affected."
            },
            {
              "date": "29-APR",
              "source": "excel",
              "text": "Complete engine will go to PT5. Discussions in progress. Slot TBC."
            },
            {
              "date": "27-MAY",
              "source": "excel",
              "text": "Engine arrived back to Azul. Will ship to PT5- Induction TBD (JUL-2026) — NEXT: Confirm release date — [IN PROGRESS]"
            },
            {
              "date": "2026-01-26",
              "source": "excel",
              "text": "Workscope approved. Ok to induct"
            },
            {
              "date": "2026-02-27",
              "source": "excel",
              "text": "Workscope sent to shop."
            },
            {
              "date": "2026-03-25",
              "source": "excel",
              "text": "Engine inducted on March 18th, no redelivery date yet."
            },
            {
              "date": "2026-04-08",
              "source": "meeting",
              "text": "ED0542 Due to capability limitations at PW Sorocaba, part of the engine needs to be shipped to PT5. AZUL to provide further details on which module/part needs to be shipped to PT5."
            },
            {
              "date": "2026-04-08",
              "source": "excel",
              "text": "Part of ESV to be performed in PT5 due to capability limitations. Azul to provide detail on affected parts. TAT might be affected."
            },
            {
              "date": "2026-04-29",
              "source": "excel",
              "text": "Complete engine will go to PT5. Discussions in progress. Slot TBC."
            },
            {
              "date": "2026-05-13",
              "source": "meeting",
              "text": "ED0542: Arrived at PT5. Workscope may be escalated to OVH due to findings."
            },
            {
              "date": "2026-05-27",
              "source": "excel",
              "text": "Engine arrived back to Azul. Will ship to PT5- Induction TBD (JUL-2026)"
            },
            {
              "date": "2026-05-29",
              "source": "meeting",
              "text": "ED0542 : Returned to Azul's facilities and will be shipped to PT5 due to capability limitations at PW Sorocaba. Induction expected in July 2026."
            },
            {
              "date": "",
              "source": "excel",
              "text": "HSI"
            }
          ],
          "nextAction": "Confirm release date",
          "nextActionBy": "AZUL",
          "targetDate": "2026-05-29"
        }
      },
      {
        "id": "min-c4c29e4c-a8d",
        "number": "5.7",
        "sectionNumber": "5",
        "principalTopic": "PW Sorocaba / Std Aero HSI",
        "subTopic": "ED0655",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-06-10",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "26-JAN",
              "source": "excel",
              "text": "Workscope approved. Ok to induct"
            },
            {
              "date": "25-FEB",
              "source": "excel",
              "text": "Engine inducted on March 09th, no release date yet — NEXT: Provide release date — [IN PROGRESS]"
            },
            {
              "date": "27-FEB",
              "source": "excel",
              "text": "Workscope sent to shop."
            },
            {
              "date": "2026-01-26",
              "source": "excel",
              "text": "Workscope approved. Ok to induct"
            },
            {
              "date": "2026-02-25",
              "source": "excel",
              "text": "Engine inducted on March 09th, no release date yet"
            },
            {
              "date": "2026-02-27",
              "source": "excel",
              "text": "Workscope sent to shop."
            },
            {
              "date": "2026-06-10",
              "source": "meeting",
              "text": "Next engine release: ED0655 (PW Sorocaba) � 30 June."
            },
            {
              "date": "",
              "source": "excel",
              "text": "HSI"
            }
          ],
          "nextAction": "Provide release date",
          "nextActionBy": "AZUL",
          "targetDate": "2026-06-10"
        }
      },
      {
        "id": "min-7dcba659-0bb",
        "number": "5.8",
        "sectionNumber": "5",
        "principalTopic": "PW Sorocaba / Std Aero HSI",
        "subTopic": "ALL",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "Azul cost estimates for HSI (~$1M avg) — NEXT: Provide cost when available — [IN PROGRESS] — –"
            }
          ],
          "nextAction": "Provide cost when available",
          "nextActionBy": "Azul",
          "targetDate": ""
        }
      },
      {
        "id": "min-5c1efcb1-4b2",
        "number": "6.1",
        "sectionNumber": "6",
        "principalTopic": "Parts Swap",
        "subTopic": "—",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "Lease amendment for ED0230/2 & EB0133 — NEXT: 1 Comment received from Azul - Follow up. — [COMPLETE] — Engine delivered."
            }
          ],
          "nextAction": "",
          "nextActionBy": "DAE / Azul",
          "targetDate": ""
        }
      },
      {
        "id": "min-5bc1e493-585",
        "number": "6.2",
        "sectionNumber": "6",
        "principalTopic": "Parts Swap",
        "subTopic": "Components / Parts (MSN 554 & 548",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-05-25",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "05-JAN",
              "source": "excel",
              "text": "New revision sent. Under DAE Legal revision."
            },
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "Azul to provide executed version. Legal team review in progress."
            },
            {
              "date": "08-JAN",
              "source": "excel",
              "text": "Certificate executed. Parts released. Pending pickup and inform AWB."
            },
            {
              "date": "21-JAN",
              "source": "excel",
              "text": "Collection expected this week at the latest. Daniel will update by email."
            },
            {
              "date": "28-JAN",
              "source": "excel",
              "text": "Parts Collected. Awaiting shipment. Tracking will be provided."
            },
            {
              "date": "04-FEB",
              "source": "excel",
              "text": "Azul updating documents internally to confirm shipment. Awaiting update on AWB."
            },
            {
              "date": "11-FEB",
              "source": "excel",
              "text": "Corrected invoice provided for extinguisher."
            },
            {
              "date": "20-FEB",
              "source": "excel",
              "text": "Booking not yet confirmed"
            },
            {
              "date": "04-MAR",
              "source": "excel",
              "text": "Booking complete by fieday. Awaiting Tracking."
            },
            {
              "date": "18-MAR",
              "source": "excel",
              "text": "Shipping"
            },
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "Shipping delay. Loading BTW"
            },
            {
              "date": "26-MAR",
              "source": "excel",
              "text": ". New arrival expected"
            },
            {
              "date": "30-MAR",
              "source": "excel",
              "text": "and"
            },
            {
              "date": "02-APR",
              "source": "excel",
              "text": ". Arrival estimated"
            },
            {
              "date": "18-APR",
              "source": "excel",
              "text": "expected arrival."
            },
            {
              "date": "21-APR",
              "source": "excel",
              "text": ". Azul to share AWB by the end of the day."
            },
            {
              "date": "29-APR",
              "source": "excel",
              "text": "Arrived to Santos. Clearance in progress. Incoming inspection scheudle TBC."
            },
            {
              "date": "20-MAY",
              "source": "excel",
              "text": "Arrived in Azul facilities. Incoming inspection starts"
            },
            {
              "date": "25-MAY",
              "source": "excel",
              "text": "Azul rejects 65 out of 66 parts. — NEXT: Confirm pickup of parts and provide AWB — [IN PROGRESS] — Follow up with Daniel Salinas"
            },
            {
              "date": "17-NOV",
              "source": "excel",
              "text": "— [COMPLETE] — Azul Legal reviewing (since 22/Oct)"
            },
            {
              "date": "01-DEC",
              "source": "excel",
              "text": "Rudder Damper FE205-000 S/N FR1013 Added to shipment"
            },
            {
              "date": "01-DEC",
              "source": "excel",
              "text": "UN# provided"
            },
            {
              "date": "03-DEC",
              "source": "excel",
              "text": "Azul revieweing PO. Feedback expected by EBD"
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "Awaiting shipping quotes."
            },
            {
              "date": "14-DEC",
              "source": "excel",
              "text": "Azul new comments on acceptance certificate"
            },
            {
              "date": "17-DEC",
              "source": "excel",
              "text": "Azul to send reviewed wording on 2(iii)."
            },
            {
              "date": "18-DEC",
              "source": "excel",
              "text": "Azul executed version did not match last agreed version."
            },
            {
              "date": "2003-11-26",
              "source": "meeting",
              "text": "DEC: Azul revieweing PO. Feedback expected by EBD"
            },
            {
              "date": "2025-12-01",
              "source": "meeting",
              "text": "Rudder Damper FE205-000 S/N FR1013 Added to shipment"
            },
            {
              "date": "2025-12-01",
              "source": "meeting",
              "text": "UN# provided"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "Awaiting shipping quotes."
            },
            {
              "date": "2025-12-14",
              "source": "meeting",
              "text": "Azul new comments on acceptance certificate"
            },
            {
              "date": "2025-12-17",
              "source": "meeting",
              "text": "Azul to send reviewed wording on 2(iii)."
            },
            {
              "date": "2025-12-18",
              "source": "meeting",
              "text": "Azul executed version did not match last agreed version."
            },
            {
              "date": "2026-01-05",
              "source": "meeting",
              "text": "New revision sent. Under DAE Legal revision."
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "AZul to provide executed version. Legal team review in progress."
            },
            {
              "date": "2026-01-08",
              "source": "meeting",
              "text": "Certificate executed. Parts released. Pending pickup and inform AWB."
            },
            {
              "date": "2026-01-21",
              "source": "excel",
              "text": "Collection expected this week at the latest. Daniel will update by email."
            },
            {
              "date": "2026-01-28",
              "source": "excel",
              "text": "Parts Collected. Awaiting shipment. Tracking will be provided."
            },
            {
              "date": "2026-02-04",
              "source": "excel",
              "text": "Azul updating documents internally to confirm shipment. Awaiting update on AWB."
            },
            {
              "date": "2026-02-11",
              "source": "excel",
              "text": "Corrected invoice provided for extinguisher."
            },
            {
              "date": "2026-02-20",
              "source": "excel",
              "text": "Booking not yet confirmed"
            },
            {
              "date": "2026-03-04",
              "source": "excel",
              "text": "Booking complete by fieday. Awaiting Tracking."
            },
            {
              "date": "2026-03-18",
              "source": "excel",
              "text": "Shipping"
            },
            {
              "date": "2026-03-25",
              "source": "excel",
              "text": "Shipping delay. Loading BTW"
            },
            {
              "date": "2026-03-26",
              "source": "excel",
              "text": "New arrival expected"
            },
            {
              "date": "2026-03-30",
              "source": "excel",
              "text": "and"
            },
            {
              "date": "2026-04-02",
              "source": "excel",
              "text": "Arrival estimated"
            },
            {
              "date": "2026-04-18",
              "source": "excel",
              "text": "expected arrival."
            },
            {
              "date": "2026-04-21",
              "source": "excel",
              "text": "Azul to share AWB by the end of the day."
            },
            {
              "date": "2026-04-28",
              "source": "excel",
              "text": "APR: Arrived to Santos. Clearance in progress. Incoming inspection scheudle TBC."
            },
            {
              "date": "2026-05-20",
              "source": "excel",
              "text": "Arrived in Azul facilities. Incoming inspection starts"
            },
            {
              "date": "2026-05-25",
              "source": "excel",
              "text": "Azul rejects 65 out of 66 parts."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Term Sheet approved; 68 parts acceptance certificate - Term sheet submitted to the court & approved - Provided for Azul review on 22/Oct -Azul reviewing with Legal team reviewing the documents will provide comments on the acceptance cert — NEXT: Week of"
            },
            {
              "date": "",
              "source": "excel",
              "text": "68 parts removed, packed, EASA Form One available — NEXT: Ship parts & provide invoice — [COMPLETE] — Consolidated in Billund"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Azul review delayed Azul to expedite review to confirm shipment can take place. - HF XVR P/N 822-0101-002 S/N 1623 Added to shipment"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Azul requires the SPV entity that the parts are being purchased from - DAE advised that should be the same SPV for ED0809... - DAE reconfirmed via email but Azul to advise if any additional action required — NEXT: Azul to advise if further action needed Same SPV ED0809 used. — [COMPLETE]"
            }
          ],
          "nextAction": "Confirm pickup of parts and provide AWB",
          "nextActionBy": "AZUL (Legal), DAE, AZUL",
          "targetDate": "2026-05-25"
        }
      },
      {
        "id": "min-6ff8e72e-423",
        "number": "7.1",
        "sectionNumber": "7",
        "principalTopic": "Engine Records (ESV)",
        "subTopic": "ED0305 ED0306 ED0324 ED0325",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "Historical documentation uploaded — NEXT: Confirmed uploaded — [COMPLETE] — –"
            }
          ],
          "nextAction": "",
          "nextActionBy": "DAE",
          "targetDate": ""
        }
      },
      {
        "id": "min-99e7f3d0-d12",
        "number": "7.3",
        "sectionNumber": "7",
        "principalTopic": "Engine Records (ESV)",
        "subTopic": "ED0305 ED0306",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "ED0305/6 overhaul completed & accepted — NEXT: Acceptance confirmed Expecting to have them ready for delivery ahead of time STD Aero Paris. In progess with DAE. Release expected by early december — [COMPLETE] — Traacked on section 2. Swaps"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Prepare delivery certificate — [COMPLETE] — Traacked on section 2. Swaps"
            }
          ],
          "nextAction": "",
          "nextActionBy": "DAE",
          "targetDate": ""
        }
      },
      {
        "id": "min-13c0a47a-072",
        "number": "7.4",
        "sectionNumber": "7",
        "principalTopic": "Engine Records (ESV)",
        "subTopic": "ED0324 ED0325",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "-HSI Complete - Engines held in shop for PT2 blades replacement - work in progress at Std Aero (stator repair / replacement pacing item) — NEXT: ED0324 - Available probably earlier than FEB ED0325 - TBD. — [IN PROGRESS] — Commitments maintained"
            },
            {
              "date": "",
              "source": "excel",
              "text": "AZUL Engineering reviewing (HSI + PT2 blades) — NEXT: Confirm acceptance — [IN PROGRESS] — Inform if there is any objection with records ASAP."
            }
          ],
          "nextAction": "ED0324 - Available probably earlier than FEB ED0325 - TBD.\nConfirm acceptance",
          "nextActionBy": "Std Aero, Azul",
          "targetDate": ""
        }
      },
      {
        "id": "min-1b972a52-d94",
        "number": "8.1",
        "sectionNumber": "8",
        "principalTopic": "Landing Gear",
        "subTopic": "MN728 MN889 MN846",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "Review DAE-proposed LG documentation — NEXT: Complete review and feedback — [COMPLETE] — DAE supporting info"
            }
          ],
          "nextAction": "",
          "nextActionBy": "Azul",
          "targetDate": ""
        }
      },
      {
        "id": "min-c2c677ea-f8a",
        "number": "8.2",
        "sectionNumber": "8",
        "principalTopic": "Landing Gear",
        "subTopic": "14B26218 B726 B731",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-29",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "19-JAN",
              "source": "excel",
              "text": "No response from technical team from AZUL. Leonardo to follow-up internally."
            },
            {
              "date": "21-JAN",
              "source": "excel",
              "text": "No comments from technical team. Awaiting update from technical manager."
            },
            {
              "date": "28-JAN",
              "source": "excel",
              "text": "Azul requested further records by email. DAE to provide."
            },
            {
              "date": "04-FEB",
              "source": "excel",
              "text": "No update. will follow up separatelly."
            },
            {
              "date": "11-FEB",
              "source": "excel",
              "text": "Additional documents required from DAE."
            },
            {
              "date": "20-FEB",
              "source": "excel",
              "text": "Review of records in progress. Missing docs. Daniel to send PRR."
            },
            {
              "date": "24-FEB",
              "source": "excel",
              "text": "AZUL technical team will send update today on what is missing for the records review of the candidate LGs."
            },
            {
              "date": "11-MAR",
              "source": "excel",
              "text": "Updated plan added to weekly minutes."
            },
            {
              "date": "18-MAR",
              "source": "excel",
              "text": "DAE and AZUL to coordinate inspections for 1st week of April | 2 side braces sent to OVH. Review of alternate plan in porgress. Azul infoms no other side braces are available for swap. | Records review in progress for outstanding documents."
            },
            {
              "date": "08-APR",
              "source": "excel",
              "text": "Inspection feedback provided - AZUL to provide Serviceability table status update and supporting records. Cap on reimbursements."
            },
            {
              "date": "29-APR",
              "source": "excel",
              "text": "Pending LLP Status, Inst/Rem history, NIS . Proforma invoice in progress. Safran working on outstanding incoming LG records. Information is on the available records. Records ot be accepted in same condition upon redelivery. AZUL preparing the booking in paralell. — NEXT: - AZUL confirm rep for 1st week of april inspection in Shannon and Tolouse - DAE to confirm inspectors for 1st week of april in VPC and PLU - AZUL revieweing records. - AZUL to provide LG6 records for review. - DAE to provide pending NIS. PRR avlialabe . — [IN PROGRESS]"
            },
            {
              "date": "03-DEC",
              "source": "excel",
              "text": "Azul reviewing."
            },
            {
              "date": "07-DEC",
              "source": "excel",
              "text": "Dae to check and provide additional information request (New list of requirements)."
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "Azul will review"
            },
            {
              "date": "11-DEC",
              "source": "excel",
              "text": "."
            },
            {
              "date": "17-DEC",
              "source": "excel",
              "text": "Azul to provide update after today's meeting."
            },
            {
              "date": "2025-12-03",
              "source": "meeting",
              "text": "Azul reviewing."
            },
            {
              "date": "2025-12-07",
              "source": "meeting",
              "text": "Dae to check and provide additional information request (New list of requirements)."
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "Azul will review"
            },
            {
              "date": "2025-12-17",
              "source": "meeting",
              "text": "Azul to provide update after today's meeting."
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "No response from technical team from AZUL. Leonardo to follow-up internally."
            },
            {
              "date": "2026-01-21",
              "source": "excel",
              "text": "No comments from technical team. Awaiting update from technical manager."
            },
            {
              "date": "2026-01-28",
              "source": "excel",
              "text": "Azul requested further records by email. DAE to provide."
            },
            {
              "date": "2026-02-04",
              "source": "excel",
              "text": "No update. will follow up separatelly."
            },
            {
              "date": "2026-02-11",
              "source": "excel",
              "text": "Additional documents required from DAE."
            },
            {
              "date": "2026-02-20",
              "source": "excel",
              "text": "Review of records in progress. Missing docs. Daniel to send PRR."
            },
            {
              "date": "2026-02-24",
              "source": "excel",
              "text": "AZUL technical team will send update today on what is missing for the records review of the candidate LGs."
            },
            {
              "date": "2026-03-11",
              "source": "excel",
              "text": "Updated plan added to weekly minutes."
            },
            {
              "date": "2026-03-18",
              "source": "excel",
              "text": "DAE and AZUL to coordinate inspections for 1st week of April | 2 side braces sent to OVH. Review of alternate plan in porgress. Azul infoms no other side braces are available for swap. | Records review in progress for outstanding documents."
            },
            {
              "date": "2026-04-08",
              "source": "excel",
              "text": "Inspection feedback provided - AZUL to provide Serviceability table status update and supporting records. Cap on reimbursements."
            },
            {
              "date": "2026-04-29",
              "source": "excel",
              "text": "Pending LLP Status, Inst/Rem history, NIS . Proforma invoice in progress. Safran working on outstanding incoming LG records. Information is on the available records. Records ot be accepted in same condition upon redelivery. AZUL preparing the booking in paralell."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Formal confirmation of LG exchanges"
            }
          ],
          "nextAction": "- AZUL confirm rep for 1st week of april inspection in Shannon and Tolouse - DAE to confirm inspectors for 1st week of april in VPC and PLU",
          "nextActionBy": "AZUL",
          "targetDate": "2026-04-29"
        }
      },
      {
        "id": "min-c8071ea7-d83",
        "number": "8.3",
        "sectionNumber": "8",
        "principalTopic": "Landing Gear",
        "subTopic": "—",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "Confirm aircraft receiving exchange LG — NEXT: Gears will be installed on MSN 1088 (AQI) + 1180 (AQS) — [COMPLETE] — –"
            }
          ],
          "nextAction": "",
          "nextActionBy": "Azul",
          "targetDate": ""
        }
      },
      {
        "id": "min-8fc17e41-702",
        "number": "9.1",
        "sectionNumber": "9",
        "principalTopic": "Aircraft Heavy Maintenance / RTS",
        "subTopic": "1115 (AQN)",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2025-11-20",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "20-NOV",
              "source": "excel",
              "text": "with non-DAE engines"
            },
            {
              "date": "2025-11-20",
              "source": "excel",
              "text": "with non-DAE engines"
            },
            {
              "date": "",
              "source": "excel",
              "text": "i. CRS expected end Nov but subject to engines availability — [COMPLETE] — CRS"
            },
            {
              "date": "",
              "source": "excel",
              "text": "ED0230 ED0232 — Awaiting confirmation on 1043 - 1113 — NEXT: Confirm — [COMPLETE] — ED0232 arrival + 15DY"
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL",
          "targetDate": "2025-11-20"
        }
      },
      {
        "id": "min-a28ead78-9c0",
        "number": "9.2",
        "sectionNumber": "9",
        "principalTopic": "Aircraft Heavy Maintenance / RTS",
        "subTopic": "1043 (ATV) 1113 (AQM)",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "-Next induction to be confirmed - planning team working on the new production line (final adjustments) -Azul to share asap -next MSN's are likely 1043 & 1113 with induction in Pampulha induction subject to engines availability — NEXT: Confirm — [PENDING]"
            }
          ],
          "nextAction": "Confirm",
          "nextActionBy": "AZUL",
          "targetDate": ""
        }
      },
      {
        "id": "min-439b2ce0-b5c",
        "number": "9.3",
        "sectionNumber": "9",
        "principalTopic": "Aircraft Heavy Maintenance / RTS",
        "subTopic": "12 aircraft on storage. RTS Plan",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-08",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "New plan revision available. Azul to share -"
            },
            {
              "date": "14-JAN",
              "source": "excel",
              "text": "Daniel to share updated plan. -"
            },
            {
              "date": "19-JAN",
              "source": "excel",
              "text": "Plan Shared. No inductions in the next months. Pending for review during"
            },
            {
              "date": "21-JAN",
              "source": "excel",
              "text": "meeting. -"
            },
            {
              "date": "21-JAN",
              "source": "excel",
              "text": "Azul reports lack of available engines to support return-to-service of grounded aircraft in 1H 2026. Azul is exploring the possibility of leasing spare engines from DAE; however, restoration of oudtoing engines would be required. Azul is urged to provide the support records for outgoing engines, re-evaluate the recovery plan, and promptly submit an updated engine allocation plan. -"
            },
            {
              "date": "27-JAN",
              "source": "excel",
              "text": "is incomplete and does not provide a comprehensive plan for returning the grounded aircraft to service. An updated report showing all engines, all MSNs requested. -"
            },
            {
              "date": "28-JAN",
              "source": "excel",
              "text": "Report received on"
            },
            {
              "date": "04-FEB",
              "source": "excel",
              "text": "Azul working on new draft that plans to return all 12 airfrat back to service during 2026. Possible use of external MROs given availalbe slots. Final version commited for"
            },
            {
              "date": "11-FEB",
              "source": "excel",
              "text": "No updates -"
            },
            {
              "date": "23-FEB",
              "source": "excel",
              "text": ". -"
            },
            {
              "date": "25-FEB",
              "source": "excel",
              "text": "Expecting to share a copy by end of day today. 2 to 3 A/C reactivation scheduled for 1st half of 2026. Hoping to reactivate all 12 A/C by end of 2026. -"
            },
            {
              "date": "04-MAR",
              "source": "excel",
              "text": "MSN 1088 Workscope pending. Confirm assigned engines. Confirm MRO for outsourced mtx. -"
            },
            {
              "date": "11-MAR",
              "source": "excel",
              "text": "Azul visited MRO in Brazil. No definitions yet. -"
            },
            {
              "date": "25-MAR",
              "source": "excel",
              "text": "Azul provided engine allocation plan. Meeting about external MROs today. -"
            },
            {
              "date": "08-APR",
              "source": "excel",
              "text": "GTX Aeropsace Porto Alegre might be assigned for MSN 1281 and 1342. No GTA in place. — [IN PROGRESS] — Awaiting AZUL tech team update."
            },
            {
              "date": "01-DEC",
              "source": "excel",
              "text": "Azul plan to send engines to Std Aero -"
            },
            {
              "date": "03-DEC",
              "source": "excel",
              "text": "Azul works on new plan for having all DAE A/C in service during 2026. -"
            },
            {
              "date": "10-DEC",
              "source": "excel",
              "text": "Draft of new plan is available. Expecting 26 ATRs operative by Q1-27 -"
            },
            {
              "date": "17-DEC",
              "source": "excel",
              "text": "Azul to review milestones"
            },
            {
              "date": "18-DEC",
              "source": "excel",
              "text": ". -"
            },
            {
              "date": "2025-12-01",
              "source": "meeting",
              "text": "Azul plan to send engines to Std Aero -"
            },
            {
              "date": "2025-12-03",
              "source": "meeting",
              "text": "Azul works on new plan for having all DAE A/C in service during 2026. -"
            },
            {
              "date": "2025-12-10",
              "source": "meeting",
              "text": "Draft of new plan is available. Expecting 26 ATRs operative by Q1-27 -"
            },
            {
              "date": "2025-12-17",
              "source": "meeting",
              "text": "Azul to review milestones"
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "New plan revision available. Azul to share"
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "New plan revision available. Azul to share -"
            },
            {
              "date": "2026-01-14",
              "source": "meeting",
              "text": "Daniel to share updated plan."
            },
            {
              "date": "2026-01-14",
              "source": "meeting",
              "text": "Daniel to share updated plan. -"
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Plan Shared. No inductions in the next months. Pending for review during"
            },
            {
              "date": "2026-01-21",
              "source": "meeting",
              "text": "meeting."
            },
            {
              "date": "2026-01-21",
              "source": "excel",
              "text": "Azul reports lack of available engines to support return-to-service of grounded aircraft in 1H 2026. Azul is exploring the possibility of leasing spare engines from DAE; however, restoration of oudtoing engines would be required. Azul is urged to provide the support records for outgoing engines, re-evaluate the recovery plan, and promptly submit an updated engine allocation plan. -"
            },
            {
              "date": "2026-01-21",
              "source": "excel",
              "text": "meeting. -"
            },
            {
              "date": "2026-01-27",
              "source": "excel",
              "text": "is incomplete and does not provide a comprehensive plan for returning the grounded aircraft to service. An updated report showing all engines, all MSNs requested. -"
            },
            {
              "date": "2026-01-28",
              "source": "excel",
              "text": "Report received on"
            },
            {
              "date": "2026-02-04",
              "source": "excel",
              "text": "Azul working on new draft that plans to return all 12 airfrat back to service during 2026. Possible use of external MROs given availalbe slots. Final version commited for"
            },
            {
              "date": "2026-02-11",
              "source": "excel",
              "text": "No updates -"
            },
            {
              "date": "2026-02-25",
              "source": "excel",
              "text": "Expecting to share a copy by end of day today. 2 to 3 A/C reactivation scheduled for 1st half of 2026. Hoping to reactivate all 12 A/C by end of 2026. -"
            },
            {
              "date": "2026-03-04",
              "source": "excel",
              "text": "MSN 1088 Workscope pending. Confirm assigned engines. Confirm MRO for outsourced mtx. -"
            },
            {
              "date": "2026-03-11",
              "source": "excel",
              "text": "Azul visited MRO in Brazil. No definitions yet. -"
            },
            {
              "date": "2026-03-25",
              "source": "excel",
              "text": "Azul provided engine allocation plan. Meeting about external MROs today. -"
            },
            {
              "date": "2026-04-08",
              "source": "excel",
              "text": "GTX Aeropsace Porto Alegre might be assigned for MSN 1281 and 1342. No GTA in place."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Engine allocation plan Plan provided WK 48 - Feedback sent to Azul. Awaiting response. -"
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL",
          "targetDate": "2026-04-08"
        }
      },
      {
        "id": "min-99f3ae07-aa2",
        "number": "9.4",
        "sectionNumber": "9",
        "principalTopic": "Aircraft Heavy Maintenance / RTS",
        "subTopic": "1166 (AQQ)",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2025-12-17",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "17-DEC",
              "source": "excel",
              "text": "Induction might be delayed depending on ED0230 condition. — NEXT: Induction by"
            },
            {
              "date": "2025-12-17",
              "source": "excel",
              "text": "Induction might be delayed depending on ED0230 condition."
            },
            {
              "date": "25-DEC-2025",
              "source": "excel",
              "text": "— [COMPLETE] — Engines ED0230, ED0232 fitted"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Aircraft parked in Bauru due to ED0736 / ED0904 remaining life used AQQ will remain in storage till engines are available engines for AQQ to be confirmed - PWC engines and/or EB0133 - tbc"
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL",
          "targetDate": "2025-12-17"
        }
      },
      {
        "id": "min-c3c0da7e-e79",
        "number": "9.5",
        "sectionNumber": "9",
        "principalTopic": "Aircraft Heavy Maintenance / RTS",
        "subTopic": "1342 (AKI)",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "NEXT: Induction by JAN 2026 — [PENDING] — Last update"
            },
            {
              "date": "",
              "source": "excel",
              "text": "1043 (ATV) — NEXT: Induction by end of SEP-2026 — [PENDING] — Last update"
            },
            {
              "date": "",
              "source": "excel",
              "text": "1113 (AQM) — NEXT: Induction by OCT-2026 — [PENDING] — Last update"
            }
          ],
          "nextAction": "Induction by JAN 2026\nInduction by end of SEP-2026\nInduction by OCT-2026",
          "nextActionBy": "AZUL",
          "targetDate": ""
        }
      },
      {
        "id": "min-d9d647b3-db0",
        "number": "10.1",
        "sectionNumber": "10",
        "principalTopic": "AOG / Insurance / Claims",
        "subTopic": "ESN 599811",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-05-13",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "07-JAN",
              "source": "excel",
              "text": "Insurance query (?) - Engine serviceable after bird strike inspection. /"
            },
            {
              "date": "21-JAN",
              "source": "excel",
              "text": "Workscope approved. Induction expected by"
            },
            {
              "date": "04-FEB",
              "source": "excel",
              "text": "Engine inducted. Awaiting release date."
            },
            {
              "date": "20-FEB",
              "source": "excel",
              "text": "MAY-11 Release."
            },
            {
              "date": "13-MAY",
              "source": "excel",
              "text": "Released from shop. REceived by Azul. Pending SV Package. — NEXT: Azul to provide SV package. — [IN PROGRESS] — LEAP-1A26 assigned to MSN 10070 PR-YSG Eduardo - Follow up."
            },
            {
              "date": "29-DEC",
              "source": "excel",
              "text": "Work scope provided - Bird strike ?"
            },
            {
              "date": "2025-12-29",
              "source": "meeting",
              "text": "Work scope provided - Bird strike ?"
            },
            {
              "date": "2025-12-29",
              "source": "meeting",
              "text": "Workscope provded - Birdstrike ?"
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "Insruance query (?) - Engine serviceable after birdstrike inspection. /"
            },
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "Insurance query (?) - Engine serviceable after bird strike inspection. /"
            },
            {
              "date": "2026-01-21",
              "source": "excel",
              "text": "Workscope approved. Induction expected by"
            },
            {
              "date": "03-Feb-2026",
              "source": "excel",
              "text": "."
            },
            {
              "date": "2026-02-04",
              "source": "excel",
              "text": "Engine inducted. Awaiting release date."
            },
            {
              "date": "2026-02-20",
              "source": "excel",
              "text": "MAY-11 Release."
            },
            {
              "date": "2026-05-13",
              "source": "excel",
              "text": "Released from shop. REceived by Azul. Pending SV Package."
            },
            {
              "date": "",
              "source": "excel",
              "text": "No activity reported the last 2 months. Engine U/S will be inducted in JAN-15-2026 - GE Celma Vibration - Possible debris found Provide storage records."
            },
            {
              "date": "",
              "source": "excel",
              "text": "Workscope - Provide when available — [CLOSED]"
            }
          ],
          "nextAction": "Azul to provide SV package.",
          "nextActionBy": "AZUL",
          "targetDate": "2026-05-13"
        }
      },
      {
        "id": "min-86453917-199",
        "number": "10.2",
        "sectionNumber": "10",
        "principalTopic": "AOG / Insurance / Claims",
        "subTopic": "MSN 1342 | PR-AKI Insurance claim",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-04-08",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "NORMAL",
          "history": [
            {
              "date": "13-JAN",
              "source": "excel",
              "text": "NLG Insurance claim"
            },
            {
              "date": "19-JAN",
              "source": "excel",
              "text": "Leonardo will follow up and provide maintenace records."
            },
            {
              "date": "21-JAN",
              "source": "excel",
              "text": "Azul insisting internally to provide the support records."
            },
            {
              "date": "28-JAN",
              "source": "excel",
              "text": "No update."
            },
            {
              "date": "04-FEB",
              "source": "excel",
              "text": "Azul requested 1+ week."
            },
            {
              "date": "10-FEB",
              "source": "excel",
              "text": "Safran report provided. Under review"
            },
            {
              "date": "16-FEB",
              "source": "excel",
              "text": "Feedback provided."
            },
            {
              "date": "11-MAR",
              "source": "excel",
              "text": "AZUL technical team to provide update for closing claim."
            },
            {
              "date": "18-MAR",
              "source": "excel",
              "text": "Call will be scheudled for today to discuss in detail. Awaiting invitation from AZUL."
            },
            {
              "date": "08-APR",
              "source": "excel",
              "text": "Pending ATR0166536 response from ATR confirming A/C inspections are acceptable. Pending Assigned LG Data. — NEXT: AZUL to confirm SN of assigned LG (BER replaced, repaired ??) — [IN PROGRESS] — Following up with Daniel"
            },
            {
              "date": "2022-08-27",
              "source": "meeting",
              "text": "Azul to provide incident report."
            },
            {
              "date": "27-AUG-2022",
              "source": "excel",
              "text": "Azul to provide incident report."
            },
            {
              "date": "2026-01-13",
              "source": "meeting",
              "text": "NLG Insurance claim"
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "Leonardo will follow up and provide maintenace records."
            },
            {
              "date": "2026-01-21",
              "source": "excel",
              "text": "Azul insisting internally to provide the support records."
            },
            {
              "date": "2026-01-28",
              "source": "excel",
              "text": "No update."
            },
            {
              "date": "2026-02-04",
              "source": "excel",
              "text": "Azul requested 1+ week."
            },
            {
              "date": "2026-02-10",
              "source": "excel",
              "text": "Safran report provided. Under review"
            },
            {
              "date": "2026-02-16",
              "source": "excel",
              "text": "Feedback provided."
            },
            {
              "date": "2026-03-11",
              "source": "excel",
              "text": "AZUL technical team to provide update for closing claim."
            },
            {
              "date": "2026-03-18",
              "source": "excel",
              "text": "Call will be scheudled for today to discuss in detail. Awaiting invitation from AZUL."
            },
            {
              "date": "2026-04-08",
              "source": "excel",
              "text": "Pending ATR0166536 response from ATR confirming A/C inspections are acceptable. Pending Assigned LG Data."
            }
          ],
          "nextAction": "AZUL to confirm SN of assigned LG (BER replaced, repaired ??)",
          "nextActionBy": "AZUL",
          "targetDate": "2026-04-08"
        }
      },
      {
        "id": "min-5abdc7db-a27",
        "number": "10.3",
        "sectionNumber": "10",
        "principalTopic": "AOG / Insurance / Claims",
        "subTopic": "MSN 1195 NLG towing incident",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "—",
          "priority": "NORMAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "AZUL to provide details. — NEXT: AZUL to confirm SN of assigned LG (BER replaced, repaired ??)"
            }
          ],
          "nextAction": "AZUL to confirm SN of assigned LG (BER replaced, repaired ??)",
          "nextActionBy": "AZUL",
          "targetDate": ""
        }
      },
      {
        "id": "min-bdb76672-ddc",
        "number": "12.1",
        "sectionNumber": "12",
        "principalTopic": "Others",
        "subTopic": "Utilzation reports",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "PENDING",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "",
              "source": "excel",
              "text": "Provide updates requested by email on swapped engines utilization. — NEXT: Confirm issue is closed. — [PENDING] — Following up with Leonardo"
            }
          ],
          "nextAction": "Confirm issue is closed.",
          "nextActionBy": "DAE",
          "targetDate": ""
        }
      },
      {
        "id": "min-2e30ce6d-cba",
        "number": "11.1",
        "sectionNumber": "11",
        "principalTopic": "Standard Aero TPA / Utilization",
        "subTopic": "Utilization reports",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-01-19",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "2026-01-07",
              "source": "meeting",
              "text": "Std Aero reviewing TPA"
            },
            {
              "date": "2026-01-14",
              "source": "meeting",
              "text": "Agreement accepted. ED0607 Might be added."
            },
            {
              "date": "2026-01-19",
              "source": "meeting",
              "text": "ED0799 is being sent to PWC"
            },
            {
              "date": "",
              "source": "excel",
              "text": "Do not reflect the recent swaps. — NEXT: Update assigned engines on utilization reports. — [CLOSED]"
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL",
          "targetDate": "2026-01-19"
        }
      },
      {
        "id": "min-f17e9c76-0bf",
        "number": "11.2",
        "sectionNumber": "11",
        "principalTopic": "Standard Aero TPA / Utilization",
        "subTopic": "MSN 1044 (ATV)",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-03-07",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "—",
          "priority": "NORMAL",
          "history": [
            {
              "date": "07-MAR",
              "source": "excel",
              "text": ". OK ?"
            },
            {
              "date": "2026-03-07",
              "source": "excel",
              "text": "OK ?"
            },
            {
              "date": "",
              "source": "excel",
              "text": "6M flight on"
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL",
          "targetDate": "2026-03-07"
        }
      },
      {
        "id": "min-76017dae-c42",
        "number": "13.2",
        "sectionNumber": "13",
        "principalTopic": "MR Claims",
        "subTopic": "Claim #4540 (MSN 1115)",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-03-18",
        "status": "open",
        "comments": [],
        "_tracker": {
          "status": "IN PROGRESS",
          "priority": "CRITICAL",
          "history": [
            {
              "date": "18-MAR",
              "source": "excel",
              "text": "Azul is reviewing internally and will provide an update to resume the claim process — [IN PROGRESS]"
            },
            {
              "date": "2026-03-18",
              "source": "excel",
              "text": "Azul is reviewing internally and will provide an update to resume the claim process"
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL",
          "targetDate": "2026-03-18"
        }
      },
      {
        "id": "min-ba817c78-43b",
        "number": "13.3",
        "sectionNumber": "13",
        "principalTopic": "MR Claims",
        "subTopic": "Workscopes",
        "owner": "",
        "targetOriginal": "",
        "targetUpdated": "2026-03-18",
        "status": "closed",
        "comments": [],
        "_tracker": {
          "status": "CLOSED",
          "priority": "NORMAL",
          "history": [
            {
              "date": "18-MAR",
              "source": "excel",
              "text": "Azul shared by email worksopes for DAE review MSN 1144 AIRFRAME 1CFH + 12YE +8YE+ 4YE + 2YE + 5000FH + 24000FC MSN 1043 AIRFRAME 2YE+1CFH+5000FH checks. Both workscopes are for Airframes maked \"S\" for relevant checks on the amended terms sheet Appendix 3. — [CLOSED]"
            },
            {
              "date": "2026-03-18",
              "source": "excel",
              "text": "Azul shared by email worksopes for DAE review MSN 1144 AIRFRAME 1CFH + 12YE +8YE+ 4YE + 2YE + 5000FH + 24000FC MSN 1043 AIRFRAME 2YE+1CFH+5000FH checks. Both workscopes are for Airframes maked \"S\" for relevant checks on the amended terms sheet Appendix 3."
            }
          ],
          "nextAction": "",
          "nextActionBy": "AZUL",
          "targetDate": "2026-03-18"
        }
      }
    ],
    "tasks": [
      {
        "id": "tsk-28f95fc6-b00",
        "number": "2.3.1",
        "parentNumber": "2",
        "title": "Completeness 55%. DAE to provide feedback.",
        "asset": "ED0541↔ ED0230",
        "owner": "AZUL, DAE",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-0a510426-786",
        "comments": []
      },
      {
        "id": "tsk-5ab18115-9e4",
        "number": "2.4.1",
        "parentNumber": "2",
        "title": "0% Progress Storage and insurance priority 07-JAN: DFPs will be prepared. 04-FEB: Provide schedule and records.",
        "asset": "ED0569↔ EB0133",
        "owner": "DAE/NTE, DAE, AZUL",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-29",
        "dependsOn": [],
        "linkedMinuteId": "min-3ce6a263-f01",
        "comments": []
      },
      {
        "id": "tsk-de1ae3f9-5c7",
        "number": "2.4.2",
        "parentNumber": "2",
        "title": "Confirm installation",
        "asset": "ED0569↔ EB0133",
        "owner": "DAE/NTE, DAE, AZUL",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-29",
        "dependsOn": [],
        "linkedMinuteId": "min-3ce6a263-f01",
        "comments": []
      },
      {
        "id": "tsk-24dd528b-4bf",
        "number": "2.4.3",
        "parentNumber": "2",
        "title": "Azul will send details by email Confirm with Rafael Matias if travel is possible, or confirm if AZUL will accept the post test cell BSI repo",
        "asset": "ED0569↔ EB0133",
        "owner": "DAE/NTE, DAE, AZUL",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-29",
        "dependsOn": [],
        "linkedMinuteId": "min-3ce6a263-f01",
        "comments": []
      },
      {
        "id": "tsk-b614c556-72a",
        "number": "2.4.4",
        "parentNumber": "2",
        "title": "details for the PT2 blades & engine shop visit reports, once available",
        "asset": "ED0569↔ EB0133",
        "owner": "DAE/NTE, DAE, AZUL",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-29",
        "dependsOn": [],
        "linkedMinuteId": "min-3ce6a263-f01",
        "comments": []
      },
      {
        "id": "tsk-659e3c3b-f26",
        "number": "2.5.1",
        "parentNumber": "2",
        "title": "Completeness 55%.",
        "asset": "ED0570↔ ED0232",
        "owner": "DAE/AZUL, AZUL, AZUL DAE, DAE",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-34c8e96d-550",
        "comments": []
      },
      {
        "id": "tsk-fb65f625-749",
        "number": "2.5.2",
        "parentNumber": "2",
        "title": "Confirm configuration matches incoming engine",
        "asset": "ED0570↔ ED0232",
        "owner": "DAE/AZUL, AZUL, AZUL DAE, DAE",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-34c8e96d-550",
        "comments": []
      },
      {
        "id": "tsk-3b03cbe1-6a3",
        "number": "2.5.3",
        "parentNumber": "2",
        "title": "Confirm arrival to NTE",
        "asset": "ED0570↔ ED0232",
        "owner": "DAE/AZUL, AZUL, AZUL DAE, DAE",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-34c8e96d-550",
        "comments": []
      },
      {
        "id": "tsk-d518ea40-808",
        "number": "2.5.4",
        "parentNumber": "2",
        "title": "Confirm arrival and installation on DAE Aircraft 07-JAN: Eng fitted on DAE A/C MSN: 1166",
        "asset": "ED0570↔ ED0232",
        "owner": "DAE/AZUL, AZUL, AZUL DAE, DAE",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-34c8e96d-550",
        "comments": []
      },
      {
        "id": "tsk-9824fce7-1c4",
        "number": "2.6.1",
        "parentNumber": "2",
        "title": "Share records for redelivery",
        "asset": "ED0886 ED0570 ED0541 ED0569",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "normal",
        "startDate": "",
        "targetDate": "",
        "dependsOn": [],
        "linkedMinuteId": "min-8df5e438-483",
        "comments": []
      },
      {
        "id": "tsk-54345962-93e",
        "number": "2.7.1",
        "parentNumber": "2",
        "title": "Confirm installation in MSN 1042",
        "asset": "ED0904↔ ED0306",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-15c50b42-eec",
        "comments": []
      },
      {
        "id": "tsk-2433d4dc-e38",
        "number": "2.7.2",
        "parentNumber": "2",
        "title": "Azul to provide recxords 07-JAN: In sequence - After ED0230+ED0232 swaps",
        "asset": "ED0904↔ ED0306",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-15c50b42-eec",
        "comments": []
      },
      {
        "id": "tsk-b69d78c9-a30",
        "number": "2.7.3",
        "parentNumber": "2",
        "title": "Provide proof of storage and insurance prior TA Confirm if A/C will be ferried to Belo Horizonte for engine drop.",
        "asset": "ED0904↔ ED0306",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-15c50b42-eec",
        "comments": []
      },
      {
        "id": "tsk-599b837b-aa6",
        "number": "2.8.1",
        "parentNumber": "2",
        "title": "Confirm installation in MSN 1042",
        "asset": "ED0736↔ ED0305",
        "owner": "AZUL, DAE",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-746985f9-523",
        "comments": []
      },
      {
        "id": "tsk-0419da62-7bb",
        "number": "2.8.2",
        "parentNumber": "2",
        "title": "0% Progress",
        "asset": "ED0736↔ ED0305",
        "owner": "AZUL, DAE",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-746985f9-523",
        "comments": []
      },
      {
        "id": "tsk-f387075f-c23",
        "number": "2.8.3",
        "parentNumber": "2",
        "title": "Provide proof of storage and insurance prior TA Confirm if A/C will be ferried to Belo Horizonte for engine drop.",
        "asset": "ED0736↔ ED0305",
        "owner": "AZUL, DAE",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-746985f9-523",
        "comments": []
      },
      {
        "id": "tsk-4b6e8cbe-874",
        "number": "2.8.4",
        "parentNumber": "2",
        "title": "Inspect aircraft in PLU 12-JAN",
        "asset": "ED0736↔ ED0305",
        "owner": "AZUL, DAE",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-01-19",
        "dependsOn": [],
        "linkedMinuteId": "min-746985f9-523",
        "comments": []
      },
      {
        "id": "tsk-9b00115e-4f6",
        "number": "2.9.1",
        "parentNumber": "2",
        "title": "Azul to provide AWB",
        "asset": "ED0671↔ ED0325",
        "owner": "DAE, AZUL, Std Aero, Azul",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-06",
        "dependsOn": [],
        "linkedMinuteId": "min-3611c806-d0a",
        "comments": []
      },
      {
        "id": "tsk-a6bb638b-053",
        "number": "2.9.2",
        "parentNumber": "2",
        "title": "0% Progress",
        "asset": "ED0671↔ ED0325",
        "owner": "DAE, AZUL, Std Aero, Azul",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-06",
        "dependsOn": [],
        "linkedMinuteId": "min-3611c806-d0a",
        "comments": []
      },
      {
        "id": "tsk-afffc1ee-07a",
        "number": "2.9.3",
        "parentNumber": "2",
        "title": "Confirm installation in MSN 1042",
        "asset": "ED0671↔ ED0325",
        "owner": "DAE, AZUL, Std Aero, Azul",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-06",
        "dependsOn": [],
        "linkedMinuteId": "min-3611c806-d0a",
        "comments": []
      },
      {
        "id": "tsk-41ed01d9-90e",
        "number": "2.10.1",
        "parentNumber": "2",
        "title": "Confirm pickup and installation",
        "asset": "ED0942↔ ED0324",
        "owner": "AZUL, Std Aero",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-06",
        "dependsOn": [],
        "linkedMinuteId": "min-ad4b1724-a30",
        "comments": []
      },
      {
        "id": "tsk-181a08b7-a82",
        "number": "2.10.2",
        "parentNumber": "2",
        "title": "0% Progress",
        "asset": "ED0942↔ ED0324",
        "owner": "AZUL, Std Aero",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-06",
        "dependsOn": [],
        "linkedMinuteId": "min-ad4b1724-a30",
        "comments": []
      },
      {
        "id": "tsk-df93ec5d-56d",
        "number": "2.10.3",
        "parentNumber": "2",
        "title": "Inspect aircraft in PLU 12-JAN 07-JAN: Inspection date might change. 11-FEB: AZUL to provide inspection date. 20-FEB: Provide storage data a",
        "asset": "ED0942↔ ED0324",
        "owner": "AZUL, Std Aero",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-06",
        "dependsOn": [],
        "linkedMinuteId": "min-ad4b1724-a30",
        "comments": []
      },
      {
        "id": "tsk-4408092c-706",
        "number": "2.10.4",
        "parentNumber": "2",
        "title": "Azul to provide AWB",
        "asset": "ED0942↔ ED0324",
        "owner": "AZUL, Std Aero",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-05-06",
        "dependsOn": [],
        "linkedMinuteId": "min-ad4b1724-a30",
        "comments": []
      },
      {
        "id": "tsk-4f15ed9a-27e",
        "number": "3.2.1",
        "parentNumber": "3",
        "title": "Confirm acceptance",
        "asset": "ED0230",
        "owner": "DAE NTE, AZUL, DAE",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2025-11-04",
        "dependsOn": [],
        "linkedMinuteId": "min-75a3e14d-c1f",
        "comments": []
      },
      {
        "id": "tsk-f1b844c6-273",
        "number": "3.2.2",
        "parentNumber": "3",
        "title": "Azul to confirm installation",
        "asset": "ED0230",
        "owner": "DAE NTE, AZUL, DAE",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2025-11-04",
        "dependsOn": [],
        "linkedMinuteId": "min-75a3e14d-c1f",
        "comments": []
      },
      {
        "id": "tsk-ee5569ce-cad",
        "number": "3.3.1",
        "parentNumber": "3",
        "title": "details for the PT2 blades & engine shop visit reports, once available",
        "asset": "EB0133",
        "owner": "DAE, PWC",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2025-12-03",
        "dependsOn": [],
        "linkedMinuteId": "min-2ad466f1-645",
        "comments": []
      },
      {
        "id": "tsk-08d17e1c-a61",
        "number": "4.2.1",
        "parentNumber": "4",
        "title": "Confirm",
        "asset": "ED1141",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-04-23",
        "dependsOn": [],
        "linkedMinuteId": "min-072799ef-5aa",
        "comments": []
      },
      {
        "id": "tsk-3d6a5131-945",
        "number": "4.3.1",
        "parentNumber": "4",
        "title": "Confirm installation",
        "asset": "ED1113",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-04-02",
        "dependsOn": [],
        "linkedMinuteId": "min-d376c3a9-e70",
        "comments": []
      },
      {
        "id": "tsk-900d8a4d-f00",
        "number": "4.4.1",
        "parentNumber": "4",
        "title": "Confirm installation",
        "asset": "ED0604",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-04-02",
        "dependsOn": [],
        "linkedMinuteId": "min-d75a53ba-7b6",
        "comments": []
      },
      {
        "id": "tsk-7bc18193-6cf",
        "number": "4.5.1",
        "parentNumber": "4",
        "title": "Confirm installation",
        "asset": "ED0941",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-04-02",
        "dependsOn": [],
        "linkedMinuteId": "min-552e236a-3a1",
        "comments": []
      },
      {
        "id": "tsk-2566bf1c-a9d",
        "number": "4.6.1",
        "parentNumber": "4",
        "title": "Confirm installation",
        "asset": "ED1110",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-04-02",
        "dependsOn": [],
        "linkedMinuteId": "min-0831eca2-1b2",
        "comments": []
      },
      {
        "id": "tsk-02ccefae-13a",
        "number": "4.7.1",
        "parentNumber": "4",
        "title": "Azul to provide ESV Report",
        "asset": "ED0701",
        "owner": "PWC",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-05-29",
        "dependsOn": [],
        "linkedMinuteId": "min-54a2b76d-599",
        "comments": []
      },
      {
        "id": "tsk-a54b4750-0b6",
        "number": "4.8.1",
        "parentNumber": "4",
        "title": "Confirm induction dates & TAT Confirm insurance coverage on price difference. Confirm insurance inspection was performed.",
        "asset": "ED0905",
        "owner": "PWC PT5",
        "status": "in_progress",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-06-03",
        "dependsOn": [],
        "linkedMinuteId": "min-e5d04207-e40",
        "comments": []
      },
      {
        "id": "tsk-741ad7d4-5df",
        "number": "4.9.1",
        "parentNumber": "4",
        "title": "Confirm installation",
        "asset": "ED1007",
        "owner": "PWC",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-03-25",
        "dependsOn": [],
        "linkedMinuteId": "min-0099fc94-826",
        "comments": []
      },
      {
        "id": "tsk-f944f7f0-44a",
        "number": "4.10.1",
        "parentNumber": "4",
        "title": "Confirm installation",
        "asset": "ED0797",
        "owner": "PWC",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-03-25",
        "dependsOn": [],
        "linkedMinuteId": "min-89446469-ff9",
        "comments": []
      },
      {
        "id": "tsk-83cd323c-359",
        "number": "4.11.1",
        "parentNumber": "4",
        "title": "Confirm installation",
        "asset": "ED1085",
        "owner": "PWC",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-02-20",
        "dependsOn": [],
        "linkedMinuteId": "min-037d7c8f-917",
        "comments": []
      },
      {
        "id": "tsk-b3519ca8-f03",
        "number": "4.21.1",
        "parentNumber": "4",
        "title": "Confirm",
        "asset": "ED1142",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-04-16",
        "dependsOn": [],
        "linkedMinuteId": "min-e6d85231-bef",
        "comments": []
      },
      {
        "id": "tsk-be6c235c-a79",
        "number": "5.2.1",
        "parentNumber": "5",
        "title": "Pending ESV package",
        "asset": "ED0712",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-05-13",
        "dependsOn": [],
        "linkedMinuteId": "min-9ad8ec1e-9e2",
        "comments": []
      },
      {
        "id": "tsk-a50e71bd-79e",
        "number": "5.3.1",
        "parentNumber": "5",
        "title": "Azul to provide ESV Report",
        "asset": "ED0710",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-05-29",
        "dependsOn": [],
        "linkedMinuteId": "min-e9a2076a-893",
        "comments": []
      },
      {
        "id": "tsk-11892959-c6c",
        "number": "5.4.1",
        "parentNumber": "5",
        "title": "Confirm release date",
        "asset": "ED0607",
        "owner": "PWC PT5",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-03-31",
        "dependsOn": [],
        "linkedMinuteId": "min-112021f1-eae",
        "comments": []
      },
      {
        "id": "tsk-bacca04a-07e",
        "number": "5.5.1",
        "parentNumber": "5",
        "title": "Confirm release and send SV package.",
        "asset": "ED0799",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-05-29",
        "dependsOn": [],
        "linkedMinuteId": "min-f80ce8fe-70d",
        "comments": []
      },
      {
        "id": "tsk-624f88de-828",
        "number": "5.6.1",
        "parentNumber": "5",
        "title": "Confirm release date",
        "asset": "ED0542",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-05-29",
        "dependsOn": [],
        "linkedMinuteId": "min-6104202e-6cb",
        "comments": []
      },
      {
        "id": "tsk-fc79bc73-872",
        "number": "5.7.1",
        "parentNumber": "5",
        "title": "Provide release date",
        "asset": "ED0655",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-06-10",
        "dependsOn": [],
        "linkedMinuteId": "min-c4c29e4c-a8d",
        "comments": []
      },
      {
        "id": "tsk-ad7479b6-6ee",
        "number": "5.8.1",
        "parentNumber": "5",
        "title": "Provide cost when available",
        "asset": "ALL",
        "owner": "Azul",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "",
        "dependsOn": [],
        "linkedMinuteId": "min-7dcba659-0bb",
        "comments": []
      },
      {
        "id": "tsk-27a96b95-1e2",
        "number": "6.2.1",
        "parentNumber": "6",
        "title": "Confirm pickup of parts and provide AWB",
        "asset": "Components / Parts (MSN 554 & 548",
        "owner": "AZUL (Legal), DAE, AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-05-25",
        "dependsOn": [],
        "linkedMinuteId": "min-5bc1e493-585",
        "comments": []
      },
      {
        "id": "tsk-4b869460-c77",
        "number": "7.4.1",
        "parentNumber": "7",
        "title": "ED0324 - Available probably earlier than FEB ED0325 - TBD.",
        "asset": "ED0324 ED0325",
        "owner": "Std Aero, Azul",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "",
        "dependsOn": [],
        "linkedMinuteId": "min-13c0a47a-072",
        "comments": []
      },
      {
        "id": "tsk-97ecf2d1-89c",
        "number": "7.4.2",
        "parentNumber": "7",
        "title": "Confirm acceptance",
        "asset": "ED0324 ED0325",
        "owner": "Std Aero, Azul",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "",
        "dependsOn": [],
        "linkedMinuteId": "min-13c0a47a-072",
        "comments": []
      },
      {
        "id": "tsk-8c78321f-e92",
        "number": "8.2.1",
        "parentNumber": "8",
        "title": "- AZUL confirm rep for 1st week of april inspection in Shannon and Tolouse - DAE to confirm inspectors for 1st week of april in VPC and PLU",
        "asset": "14B26218 B726 B731",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "high",
        "startDate": "",
        "targetDate": "2026-04-29",
        "dependsOn": [],
        "linkedMinuteId": "min-c2c677ea-f8a",
        "comments": []
      },
      {
        "id": "tsk-96178307-94f",
        "number": "9.2.1",
        "parentNumber": "9",
        "title": "Confirm",
        "asset": "1043 (ATV) 1113 (AQM)",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "normal",
        "startDate": "",
        "targetDate": "",
        "dependsOn": [],
        "linkedMinuteId": "min-a28ead78-9c0",
        "comments": []
      },
      {
        "id": "tsk-18cbaadf-ca2",
        "number": "9.5.1",
        "parentNumber": "9",
        "title": "Induction by JAN 2026",
        "asset": "1342 (AKI)",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "normal",
        "startDate": "",
        "targetDate": "",
        "dependsOn": [],
        "linkedMinuteId": "min-c3c0da7e-e79",
        "comments": []
      },
      {
        "id": "tsk-3555d9d3-e69",
        "number": "9.5.2",
        "parentNumber": "9",
        "title": "Induction by end of SEP-2026",
        "asset": "1342 (AKI)",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "normal",
        "startDate": "",
        "targetDate": "",
        "dependsOn": [],
        "linkedMinuteId": "min-c3c0da7e-e79",
        "comments": []
      },
      {
        "id": "tsk-afc14b99-ede",
        "number": "9.5.3",
        "parentNumber": "9",
        "title": "Induction by OCT-2026",
        "asset": "1342 (AKI)",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "normal",
        "startDate": "",
        "targetDate": "",
        "dependsOn": [],
        "linkedMinuteId": "min-c3c0da7e-e79",
        "comments": []
      },
      {
        "id": "tsk-b0b0b326-937",
        "number": "10.1.1",
        "parentNumber": "10",
        "title": "Azul to provide SV package.",
        "asset": "ESN 599811",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-05-13",
        "dependsOn": [],
        "linkedMinuteId": "min-d9d647b3-db0",
        "comments": []
      },
      {
        "id": "tsk-98fe19d1-408",
        "number": "10.2.1",
        "parentNumber": "10",
        "title": "AZUL to confirm SN of assigned LG (BER replaced, repaired ??)",
        "asset": "MSN 1342 | PR-AKI Insurance claim",
        "owner": "AZUL",
        "status": "in_progress",
        "priority": "normal",
        "startDate": "",
        "targetDate": "2026-04-08",
        "dependsOn": [],
        "linkedMinuteId": "min-86453917-199",
        "comments": []
      },
      {
        "id": "tsk-8fbd0cfb-cf2",
        "number": "10.3.1",
        "parentNumber": "10",
        "title": "AZUL to confirm SN of assigned LG (BER replaced, repaired ??)",
        "asset": "MSN 1195 NLG towing incident",
        "owner": "AZUL",
        "status": "not_started",
        "priority": "normal",
        "startDate": "",
        "targetDate": "",
        "dependsOn": [],
        "linkedMinuteId": "min-5abdc7db-a27",
        "comments": []
      },
      {
        "id": "tsk-32b0ed81-524",
        "number": "12.1.1",
        "parentNumber": "12",
        "title": "Confirm issue is closed.",
        "asset": "Utilzation reports",
        "owner": "DAE",
        "status": "not_started",
        "priority": "high",
        "startDate": "",
        "targetDate": "",
        "dependsOn": [],
        "linkedMinuteId": "min-bdb76672-ddc",
        "comments": []
      }
    ],
    "attachments": [],
    "linkedSurveillanceId": null,
    "azulTracker": {
      "metrics": {
        "subtopics": 66,
        "topics": 13,
        "critical": 11,
        "inProgress": 26,
        "pending": 17,
        "closed": 21,
        "openActions": 57
      },
      "sections": [
        {
          "sec": "1",
          "top": "MR Adjustment Calculations",
          "subs": [
            {
              "i": "1.1",
              "a": "ED0707 ED0230 ED0232 EB0133 2X LG shipsets",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "DAE / Azul",
              "u": "",
              "n": [],
              "x": [
                "Agreement for 4x Engine Swaps ) & 2x LG shipsets swaps — NEXT: Agreement confirmed — [COMPLETE] — –"
              ],
              "t": []
            },
            {
              "i": "1.2",
              "a": "ED0305 ED0306",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "AZUL, DAE",
              "u": "2026-03-25",
              "n": [],
              "x": [
                "Pending agreement for engines — NEXT: Agreement confirmed — [COMPLETE]",
                "ED0324 ED0325 — Pending agreement for engines PT2 blades replaced HSI Complete — NEXT: - Finalize selection & confirmation - Additional forms for some compents requested. Leonardo to send request to DAE. — [COMPLETE] — Engineering evaluation ongoing DAE to respond about ARCs ENG in Std Aero"
              ],
              "t": [
                [
                  "2026-03-25",
                  "mtg",
                  "ED0324 : Last update received Friday, 20 March. Azul to confirm arrival in Brazil and installation status."
                ]
              ]
            },
            {
              "i": "1.3",
              "a": "ED0904 ED0736",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-06-10",
              "n": [],
              "x": [
                "DAE provided calculations using — [COMPLETE]",
                "ED0942 ED0671 — ED0671 + ed0942 CONFIRMED 26-nov. Azil confirms calculuatoins are acceptable. DAE ( Follow up with Liam) — [COMPLETE] — ED0904 , ED0736 will be considered 'OVH' for the purposes of the calculations."
              ],
              "t": [
                [
                  "2025-11-26",
                  "xlsx",
                  "Azil confirms calculuatoins are acceptable. DAE ( Follow up with Liam)"
                ],
                [
                  "2026-04-08",
                  "mtg",
                  "Records: DAE reviewed the newly provided records. Progress remains minimal. AZUL to immediately assign sufficient labor resources to complete the records promptly. This issue requi"
                ],
                [
                  "2026-04-23",
                  "mtg",
                  "ED0671 / ED0942 DAE to confirm shipping location. In progress."
                ],
                [
                  "2026-05-13",
                  "mtg",
                  "ED0671, ED0942: Shipment to Standard Aero in PEI, Canada requested on May 6. Azul to provide AWB. Confirmation required that logbooks are included with engines."
                ],
                [
                  "2026-05-29",
                  "mtg",
                  "ED0942 & ED0671 : DAE to provide shop details to resume the shipping process to PEI."
                ],
                [
                  "2026-06-08",
                  "mtg",
                  "3. Engines ED0942 / ED0671 Azul to confirm shipping status, provide AWB, and confirm logbooks are traveling with engines."
                ],
                [
                  "2026-06-10",
                  "mtg",
                  "Engines ED0942 and ED0671:"
                ]
              ]
            },
            {
              "i": "1.4",
              "a": "ED0942 ED0671",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "",
              "n": [],
              "x": [
                "Azul to confirm if engines will be exchanged or overhauled — [COMPLETE]"
              ],
              "t": []
            }
          ]
        },
        {
          "sec": "2",
          "top": "Engines Delivered",
          "subs": [
            {
              "i": "2.1",
              "a": "ED0809",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "DAE / Azul",
              "u": "",
              "n": [],
              "x": [
                "ED0809 – temporary lease installed on MSN 1241 — [COMPLETE]"
              ],
              "t": []
            },
            {
              "i": "2.2",
              "a": "ED0707 ↔ ED0886",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-04-23",
              "n": [],
              "x": [
                "ED0707 swapped with ED0886 – install on MSN1195 — NEXT: Confirm installation Pending NIS and Statemnet Pending confirmation of Nozzles, Flow devider , Logbook included. — [COMPLETE] — Leonardo will confirm. (AQV) Email sent to shop.20-NOV",
                "ED0886 — ii. Missing components — NEXT: Ensure all parts match delivered configuration — [COMPLETE] — Complete",
                "iii. Storage gap – DAE requires Azul statement — [COMPLETE] — Statement provided 24-NOV",
                "Shipped with AWB 25110122941 on 7/NOV — NEXT: Tracking in progress — [COMPLETE] — Follow up with Gustavo",
                "Ship Logbook to shop Shipped with FedEx AWB 886461486187 — [COMPLETE] — Delivered 1-DEC"
              ],
              "t": [
                [
                  "2026-04-23",
                  "mtg",
                  "ED0886 Statement of Storage Azul provided the updated statement."
                ]
              ]
            },
            {
              "i": "2.3",
              "a": "ED0541↔ ED0230",
              "s": "PENDING",
              "p": "CRITICAL",
              "o": "AZUL, DAE",
              "u": "2026-01-19",
              "n": [
                "Completeness 55%. DAE to provide feedback."
              ],
              "x": [
                "Engine ready. TA signed — [COMPLETE] — Records in progress with Rafael. Pending to provide estimated date of completeness (priority)",
                "ED0541 — Pendging Records — NEXT: Completeness 55%. DAE to provide feedback. — [PENDING] — Urgent - Follow up with Rafael",
                "Coordinate inspections 03-DEC: Removal scheduled for DEC-16. Will be trucked to PLU. — [COMPLETE] — Inspected",
                "10:DEC: Shipping - Export process started. To be shipped by 25-DEC 27-DEC: Shipped with AWB 369-83317103 05-JAN: In transit MIA 12-JAN: Engine delivered. — NEXT: Confirm arrival to NTE — [CLOSED] — Delivered",
                "ED0230 (In Transit) — Engine was picked up by AZUL. Arriving WK 48 Expected in GRU 26-NOV 02-DEC - Engine in customs 03-DEC: @ VCP --> Going to PLU 09-DEC: Arrived. - Azul confirm installation. 17-DEC: Azul reports suspected corrosion during incoming inspection. Assigned to MSN 1116 — NEXT: Confirm installation on DAE Aircraft 18-DEC: Azul to provide maintenance records on finding. 07-JAN: Eng fitted on DAE A/C MSN: 1166 — [CLOSED]",
                "Records Shop visit pack shared with AZUL 10-DEC: AZul email received. Under DAE review — NEXT: Confirm acceptance — [CLOSED] — Engine in operation"
              ],
              "t": [
                [
                  "2002-11-26",
                  "xlsx",
                  "DEC - Engine in customs"
                ],
                [
                  "2025-12-03",
                  "xlsx",
                  "VCP --> Going to PLU"
                ],
                [
                  "2025-12-03",
                  "xlsx",
                  "Removal scheduled for DEC-16. Will be trucked to PLU."
                ],
                [
                  "2025-12-09",
                  "xlsx",
                  "Arrived. - Azul confirm installation."
                ],
                [
                  "2025-12-10",
                  "xlsx",
                  "AZul email received. Under DAE review"
                ],
                [
                  "2025-12-17",
                  "mtg",
                  "Azul to complete by end of year"
                ],
                [
                  "2025-12-17",
                  "xlsx",
                  "Azul reports suspected corrosion during incoming inspection. Assigned to MSN 1116"
                ],
                [
                  "2025-12-18",
                  "xlsx",
                  "Azul to provide maintenance records on finding."
                ],
                [
                  "2025-12-25",
                  "xlsx",
                  "DEC: Shipped with AWB 369-83317103"
                ],
                [
                  "2026-01-05",
                  "xlsx",
                  "In transit MIA"
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "Updates expected today . DFPs being collected."
                ],
                [
                  "2026-01-07",
                  "xlsx",
                  "Eng fitted on DAE A/C MSN: 1166"
                ],
                [
                  "2026-01-12",
                  "xlsx",
                  "Engine delivered."
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Leonardo will follow-up with Rafael. Priority on LLPs."
                ]
              ]
            },
            {
              "i": "2.4",
              "a": "ED0569↔ EB0133",
              "s": "PENDING",
              "p": "CRITICAL",
              "o": "DAE/NTE, DAE, AZUL",
              "u": "2026-05-29",
              "n": [
                "0% Progress Storage and insurance priority 07-JAN: DFPs will be prepared. 04-FEB: Provide schedule and records.",
                "Confirm installation",
                "Azul will send details by email Confirm with Rafael Matias if travel is possible, or confirm if AZUL will accept the post test cell BSI repo",
                "details for the PT2 blades & engine shop visit reports, once available"
              ],
              "x": [
                "Thrust upgrade + PT pack replacement. Impeller case replacement. Release pushed to December. — [IN PROGRESS]",
                "ED0569 — Physical inspection — NEXT: Inspect aircraft in VCP 8-JAN — [CLOSED] — Engine was inspected",
                "Shipped 11-MAR with AWB 26030027934 - to PWC Singapore. AWB shows destination Miami. — NEXT: Provide status of shipment — [CLOSED] — Link to AWB tracking",
                "Pendging Records — NEXT: 0% Progress Storage and insurance priority 07-JAN: DFPs will be prepared. 04-FEB: Provide schedule and records. — [PENDING] — Contact Rafael.",
                "EB0133 — Confirm installation — NEXT: Confirm installation — [PENDING] — Daniel / Leonardo.",
                "AZUL Requests -Confirmation that the DCU will be supplied together with the engine -A new inspection of the engine is recommended to validate the reported information -The engine will only be accepted if the RGB issue is classified as CAT 1 or lower, without requiring re-inspection every 500 flight hour 07-JAN: AZUL confirms engine is acceptable if in the new inspection the engine shows another condition. 14-JAN: RGB BSI report reviewed. Azul rejects engine due to impossibility of performing repetitive inspections. Awaiting Azul email. 19-JAN: If engine has no repetitive inspections , AZUL is likely to technically accept the engine. 21-JAN:Azul reports engine not acceptable unless RGB 1st stage helical shaft finding (CAT II with repetitive inspections) is addressed; test cell scheduled for 23-JAN. It is strongly recommended that Azul send a technical representative to witness the post–test cell BSI, as the shop expects to release the engine with no limitations; if no representative is assigned, Azul to confirm acceptance of the shop report on a permanent basis. If further discussion is required, Powerplant to be advised by email. Email chain retained in parallel. — NEXT: Azul will send details by email Confirm with Rafael Matias if travel is possible, or confirm if AZUL will accept the post test cell BSI report. — [PENDING] — Tracked above. Inspectoin 30-JAN",
                "Records — NEXT: details for the PT2 blades & engine shop visit reports, once available — [PENDING]"
              ],
              "t": [
                [
                  "2025-12-01",
                  "mtg",
                  "Engine will ship to STD Aero"
                ],
                [
                  "2025-12-03",
                  "mtg",
                  "PT2 Blades on backorder with PWC"
                ],
                [
                  "2025-12-17",
                  "mtg",
                  "PT2 Pack released and shipping"
                ],
                [
                  "2025-12-18",
                  "mtg",
                  "to NTE. ETA"
                ],
                [
                  "2025-12-29",
                  "mtg",
                  "Ship to StandardAero PEI"
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "AZUL confirms engine is acceptable if in the new inspection the engine shows another condition."
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "Azul to confirm if reinspection is possible in the coming days."
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "DFPs will be prepared."
                ],
                [
                  "2026-01-14",
                  "mtg",
                  "RGB BSI report reviewed. Azul rejects engine due to impossibility of performing repetitive inspections. Awaiting Azul email."
                ],
                [
                  "2026-01-14",
                  "mtg",
                  "Release pushed to"
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "If engine has no repetitive inspections , AZUL is likely to technically accept the engine."
                ],
                [
                  "2026-01-21",
                  "xlsx",
                  "Azul reports engine not acceptable unless RGB 1st stage helical shaft finding (CAT II with repetitive inspections) is addressed; test cell scheduled for"
                ],
                [
                  "2026-01-23",
                  "xlsx",
                  "It is strongly recommended that Azul send a technical representative to witness the post–test cell BSI, as the shop expects to release the engine with no limitations; if no representative is assigned, Azul to confirm acceptance of the shop report on a permanent basis. If further discussion is required, Powerplant to be advised by email. Email chain retained in parallel."
                ],
                [
                  "2026-02-04",
                  "xlsx",
                  "Provide schedule and records."
                ],
                [
                  "2026-03-11",
                  "xlsx",
                  "with AWB 26030027934 - to PWC Singapore. AWB shows destination Miami."
                ],
                [
                  "2026-04-08",
                  "mtg",
                  "Records: DAE reviewed the newly provided records. Progress remains minimal. AZUL to immediately assign sufficient labor resources to complete the records promptly. This issue requi"
                ],
                [
                  "2026-04-23",
                  "mtg",
                  "ED0569 Arrival confirmed at the shop in Singapore. Closed."
                ],
                [
                  "2026-05-13",
                  "mtg",
                  "ED0569 TLB: Azul plans to ship by 14-MAY. AWB to be shared with DAE when available."
                ],
                [
                  "2026-05-29",
                  "mtg",
                  "ED0569 : Parts received with the engine are to be disposed of by the shop if no update is received from Azul by end of day today."
                ]
              ]
            },
            {
              "i": "2.5",
              "a": "ED0570↔ ED0232",
              "s": "PENDING",
              "p": "CRITICAL",
              "o": "DAE/AZUL, AZUL, AZUL DAE, DAE",
              "u": "2026-01-19",
              "n": [
                "Completeness 55%.",
                "Confirm configuration matches incoming engine",
                "Confirm arrival to NTE",
                "Confirm arrival and installation on DAE Aircraft 07-JAN: Eng fitted on DAE A/C MSN: 1166"
              ],
              "x": [
                "- TA Executed 20-NOV - Engine released 20-NOV. Pending pikcup from NTE — [PENDING] — ED0570 in PLU Records expected by [Confirm with Gustavo]",
                "ED0570 — Pendging Records — NEXT: Completeness 55%. — [PENDING] — Urgent - Follow up with Rafael",
                "Inspection performed 02-DEC QEC incomplete. No access to exhaust cone where corrosion was reported — NEXT: Confirm configuration matches incoming engine — [PENDING] — Engine shipped",
                "10-DEC: Shipping - Export process started. To be shipped by 25-DEC 27-DEC: Shipped with AWB 369-83317102 05-JAN: In transit MIA — NEXT: Confirm arrival to NTE — [PENDING] — Engine arrived",
                "ED0232 (In transit) — Shipped 02-DEC - Engine in customs 03-DEC: @ VCP --> Going to PLU — NEXT: Confirm arrival and installation on DAE Aircraft 07-JAN: Eng fitted on DAE A/C MSN: 1166 — [PENDING]",
                "Records Shop visit pack shared with AZUL — NEXT: Confirm acceptance — [PENDING]",
                "HPT Blades query - Follow up. 10-DEC Email : DAE to confirm if 32 HPT blades were replaced during 2023 SV and provide support data 23-DEC: DAE responded to all queries. No answer received. — NEXT: Awaiting Leonardo's email. — [PENDING]"
              ],
              "t": [
                [
                  "2025-11-20",
                  "mtg",
                  "Engine released"
                ],
                [
                  "2025-11-20",
                  "mtg",
                  "Pending pikcup from NTE"
                ],
                [
                  "2025-12-02",
                  "xlsx",
                  "Engine in customs"
                ],
                [
                  "2025-12-02",
                  "xlsx",
                  "QEC incomplete. No access to exhaust cone where corrosion was reported"
                ],
                [
                  "2025-12-03",
                  "xlsx",
                  "VCP --> Going to PLU"
                ],
                [
                  "2025-12-10",
                  "mtg",
                  "Shipping - Export process started. To be shipped by"
                ],
                [
                  "2025-12-10",
                  "xlsx",
                  "Email : DAE to confirm if 32 HPT blades were replaced during 2023 SV and provide support data"
                ],
                [
                  "2025-12-17",
                  "mtg",
                  "Azul to complete by end of year"
                ],
                [
                  "2025-12-23",
                  "xlsx",
                  "DAE responded to all queries. No answer received."
                ],
                [
                  "2025-12-25",
                  "mtg",
                  "DEC: Shipped with AWB 369-83317102"
                ],
                [
                  "2026-01-05",
                  "mtg",
                  "In transit MIA"
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "DFPs will be prepared."
                ],
                [
                  "2026-01-07",
                  "xlsx",
                  "Eng fitted on DAE A/C MSN: 1166"
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Leonardo will follow-up with Rafael. Priority on LLPs."
                ]
              ]
            },
            {
              "i": "2.6",
              "a": "ED0886 ED0570 ED0541 ED0569",
              "s": "PENDING",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "",
              "n": [
                "Share records for redelivery"
              ],
              "x": [
                "i. Azul to expedite documentation for the engines returning — NEXT: Share records for redelivery — [PENDING] — Follow up with Rafael Tracked on each engine swap"
              ],
              "t": []
            },
            {
              "i": "2.7",
              "a": "ED0904↔ ED0306",
              "s": "PENDING",
              "p": "CRITICAL",
              "o": "AZUL",
              "u": "2026-01-19",
              "n": [
                "Confirm installation in MSN 1042",
                "Azul to provide recxords 07-JAN: In sequence - After ED0230+ED0232 swaps",
                "Provide proof of storage and insurance prior TA Confirm if A/C will be ferried to Belo Horizonte for engine drop."
              ],
              "x": [
                "[PENDING]",
                "ED0306 — Delivered — NEXT: Confirm installation in MSN 1042 — [PENDING] — Executed.",
                "ED0904 — Pending records — NEXT: Azul to provide recxords 07-JAN: In sequence - After ED0230+ED0232 swaps — [PENDING]",
                "On wing in MSN 1166 (AQQ) Insppection pending 10-DEC: Coordinate inspections for 17-DEC (@JTC) - Will be redelivered at belo Horizonte. (PLU) 31-DEC : Engine inspected. — NEXT: Provide proof of storage and insurance prior TA Confirm if A/C will be ferried to Belo Horizonte for engine drop. — [PENDING] — Engine inspeted"
              ],
              "t": [
                [
                  "2025-12-05",
                  "mtg",
                  "in Std Aero Paris"
                ],
                [
                  "2025-12-10",
                  "mtg",
                  "Insurance and sotrage records pending from AZUL."
                ],
                [
                  "2025-12-10",
                  "mtg",
                  "Insurance and storage records pending from AZUL."
                ],
                [
                  "2025-12-10",
                  "xlsx",
                  "Coordinate inspections for"
                ],
                [
                  "2025-12-17",
                  "xlsx",
                  "JTC) - Will be redelivered at belo Horizonte. (PLU)"
                ],
                [
                  "2025-12-31",
                  "xlsx",
                  "Engine inspected."
                ],
                [
                  "2026-01-06",
                  "mtg",
                  "Pending release from French customs."
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "In sequence - After ED0230+ED0232 swaps"
                ],
                [
                  "2026-01-14",
                  "mtg",
                  "Engine released from French Customs. Azul to pickup and provide shipping data. Confirm arrival and installation."
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Leonardo will follow-up with Rafael. Priority on LLPs."
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Pickup scheduled for"
                ]
              ]
            },
            {
              "i": "2.8",
              "a": "ED0736↔ ED0305",
              "s": "PENDING",
              "p": "CRITICAL",
              "o": "AZUL, DAE",
              "u": "2026-01-19",
              "n": [
                "Confirm installation in MSN 1042",
                "0% Progress",
                "Provide proof of storage and insurance prior TA Confirm if A/C will be ferried to Belo Horizonte for engine drop.",
                "Inspect aircraft in PLU 12-JAN"
              ],
              "x": [
                "[PENDING]",
                "ED0305 — Delivered — NEXT: Confirm installation in MSN 1042 — [PENDING]",
                "ED0736 — Pending records — NEXT: 0% Progress — [PENDING]",
                "On wing in MSN 1166 (AQQ) Inspection pending 10-DEC: Coordinate inspections for 17-DEC (@JTC) - Will be redelivered at belo Horizonte. (PLU) — NEXT: Provide proof of storage and insurance prior TA Confirm if A/C will be ferried to Belo Horizonte for engine drop. — [PENDING] — Inspected",
                "Physical inspection — NEXT: Inspect aircraft in PLU 12-JAN — [PENDING] — Inspected"
              ],
              "t": [
                [
                  "2025-12-05",
                  "mtg",
                  "in Std Aero Paris"
                ],
                [
                  "2025-12-10",
                  "mtg",
                  "Coordinate inspections for"
                ],
                [
                  "2025-12-10",
                  "mtg",
                  "Insurance and sotrage records pending from AZUL."
                ],
                [
                  "2025-12-13",
                  "mtg",
                  "Pending pikcup"
                ],
                [
                  "2025-12-17",
                  "mtg",
                  "JTC) - Will be redelivered at belo Horizonte. (PLU)"
                ],
                [
                  "2025-12-17",
                  "mtg",
                  "Doublecheck customs paperwork if anything is holding the engine."
                ],
                [
                  "2026-01-06",
                  "mtg",
                  "Pending release from french customs."
                ],
                [
                  "2026-01-14",
                  "mtg",
                  "Engine released from French Customs."
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Leonardo will follow-up with Rafael. Priority on LLPs."
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Pickup scheduled for"
                ]
              ]
            },
            {
              "i": "2.9",
              "a": "ED0671↔ ED0325",
              "s": "PENDING",
              "p": "CRITICAL",
              "o": "DAE, AZUL, Std Aero, Azul",
              "u": "2026-05-06",
              "n": [
                "Azul to provide AWB",
                "0% Progress",
                "Confirm installation in MSN 1042"
              ],
              "x": [
                "[PENDING] — Eng in Gonesse France",
                "ED0671 — 06-MAY: Ship to Standard Aero PEI Canada. — NEXT: Azul to provide AWB",
                "Pending records — NEXT: 0% Progress — [PENDING]",
                "Physical inspection — NEXT: Inspect aircraft in VCP 8-JAN — [CLOSED] — Inspected",
                "ED0325 — Delivered — NEXT: Confirm installation in MSN 1042 — [PENDING] — Follow up with Gustavo.",
                "-HSI Complete - Engines held in shop for PT2 blades replacement - work in progress at Std Aero (stator repair / replacement pacing item) — NEXT: ED0324 - Available probably earlier than FEB ED0325 - TBD. — [CLOSED] — Engine released",
                "AZUL Engineering reviewing (HIS + PT2 blades) — NEXT: Confirm acceptance — [CLOSED] — Tracked above"
              ],
              "t": [
                [
                  "2025-12-03",
                  "mtg",
                  "Awaiting shop visit report. LRUs to be covered under shop ARC umbrella. Full B2B to be provided."
                ],
                [
                  "2026-01-13",
                  "mtg",
                  "Records sent for review (ESV 2026)"
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Leonardo will follow-up with Rafael. Priority on LLPs."
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "No comments on the documentation provided. AZUL to confirm if review is complete. Gustavo to inspect."
                ],
                [
                  "2026-05-06",
                  "xlsx",
                  "Ship to Standard Aero PEI Canada."
                ]
              ]
            },
            {
              "i": "2.10",
              "a": "ED0942↔ ED0324",
              "s": "PENDING",
              "p": "CRITICAL",
              "o": "AZUL, Std Aero",
              "u": "2026-05-06",
              "n": [
                "Confirm pickup and installation",
                "0% Progress",
                "Inspect aircraft in PLU 12-JAN 07-JAN: Inspection date might change. 11-FEB: AZUL to provide inspection date. 20-FEB: Provide storage data a",
                "Azul to provide AWB"
              ],
              "x": [
                "[IN PROGRESS] — Eng in SA Prince Edward Island Canada",
                "ED0324 — Confirm pickup and installation — NEXT: Confirm pickup and installation — [PENDING]",
                "Eng in SA Prince Edward Island Canada 'Test cell 03-DEC 15-DEC: Possible release by 23-DEC — NEXT: ED0324 - Available probably earlier than FEB ED0325 - TBD. — [CLOSED] — Engine released",
                "AZUL Engineering reviewing (HIS + PT2 blades) — NEXT: Confirm acceptance — [CLOSED] — Inform if there is any objection with records ASAP. Tracked on records above.",
                "ED0942 — Pending records — NEXT: 0% Progress — [PENDING]",
                "Physical inspection 21-JAN: Inspection to be scheduled in Campinas. No stand available. Date to be confirmed. 11-FEB: Engine on wing 20-FEB: Eng removed. @JTC and will be shipped to PLU for inspection 24-FEB: Engine is off-wing. Will ship to Campinas. — NEXT: Inspect aircraft in PLU 12-JAN 07-JAN: Inspection date might change. 11-FEB: AZUL to provide inspection date. 20-FEB: Provide storage data and confirm inspection date and location — [IN PROGRESS]",
                "06-MAY: Ship to Standard Aero PEI Canada. — NEXT: Azul to provide AWB — [PENDING]"
              ],
              "t": [
                [
                  "2007-01-12",
                  "mtg",
                  "JAN: Inspection date might change."
                ],
                [
                  "2015-12-03",
                  "mtg",
                  "DEC: Possible release by"
                ],
                [
                  "2025-12-03",
                  "mtg",
                  "Awaiting shop visit report. LRUs to be covered under shop ARC umbrella. Full B2B to be provided."
                ],
                [
                  "2026-01-13",
                  "mtg",
                  "Records sent for review (ESV 2026)"
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Leonardo will follow-up with Rafael. Priority on LLPs."
                ],
                [
                  "2026-01-21",
                  "xlsx",
                  "Inspection to be scheduled in Campinas. No stand available. Date to be confirmed."
                ],
                [
                  "2026-02-11",
                  "xlsx",
                  "AZUL to provide inspection date."
                ],
                [
                  "2026-02-11",
                  "xlsx",
                  "Engine on wing"
                ],
                [
                  "2026-02-20",
                  "xlsx",
                  "Eng removed. @JTC and will be shipped to PLU for inspection"
                ],
                [
                  "2026-02-20",
                  "xlsx",
                  "Provide storage data and confirm inspection date and location"
                ],
                [
                  "2026-02-24",
                  "xlsx",
                  "Engine is off-wing. Will ship to Campinas."
                ],
                [
                  "2026-05-06",
                  "xlsx",
                  "Ship to Standard Aero PEI Canada."
                ]
              ]
            }
          ]
        },
        {
          "sec": "3",
          "top": "Engines at NTE / Std Aero",
          "subs": [
            {
              "i": "3.1",
              "a": "ED0232",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "DAE NTE, AZUL",
              "u": "",
              "n": [],
              "x": [
                "Engine released TA Executed — [COMPLETE] — Wil be installed on MSN 1115",
                "Records Shop visit pack shared with AZUL — NEXT: Confirm acceptance — [COMPLETE] — Tracked on section above"
              ],
              "t": []
            },
            {
              "i": "3.2",
              "a": "ED0230",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "DAE NTE, AZUL, DAE",
              "u": "2025-11-04",
              "n": [
                "Confirm acceptance",
                "Azul to confirm installation"
              ],
              "x": [
                "PT2 pack - Received at Std Aero on 22/OCT - Shipped from Std Aero 4-NOV to NTE - Stator delayed to 4-NOV - Engine ready for pkcup. — [COMPLETE] — Azul to inspect ED0230/2 on 5/Nov Will be installed on MSN 1115",
                "Records Shop visit pack shared with AZUL — NEXT: Confirm acceptance — [IN PROGRESS] — Tracked on section above",
                "Sign technical acceptance — [COMPLETE] — Tracked on section above",
                "Installation on MSN 1115 — NEXT: Azul to confirm installation — [IN PROGRESS] — Tracked on section above",
                "ED0230 ED0232 — Inpsections @ NTE GVI + witness BSIs regardless of PT2 completeness. — NEXT: Gustavo on site AZUL to confirm acceptance of BSI. (verbal confirmation received) — [COMPLETE]"
              ],
              "t": [
                [
                  "2025-11-04",
                  "xlsx",
                  "Engine ready for pkcup."
                ],
                [
                  "2025-11-04",
                  "xlsx",
                  "to NTE - Stator delayed to"
                ]
              ]
            },
            {
              "i": "3.3",
              "a": "EB0133",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "DAE, PWC",
              "u": "2025-12-03",
              "n": [
                "details for the PT2 blades & engine shop visit reports, once available"
              ],
              "x": [
                "PT2 Blades and Trhust upgrade - ENG at NTE for PT2 removal - PT2 pack removed/shipment to STD Aero being confirmed - Engine availability delayed to 24/Nov (pending PT2 blades availability - delay on the supply chain from PWC) - RGB replacement (?) - PT2 blades on backorder - AOG request with PWC. Possible exchange with ED1541 blades. 01-DEC: Engine will ship to STD Aero 03-DEC: PT2 Blades on backorder with PWC — [IN PROGRESS]",
                "Records — NEXT: details for the PT2 blades & engine shop visit reports, once available — [IN PROGRESS]",
                "10x engines (9 in work) — NEXT: Maintain release plan (3 engines/month) — [CLOSED] — Tracked below"
              ],
              "t": [
                [
                  "2025-12-01",
                  "xlsx",
                  "Engine will ship to STD Aero"
                ],
                [
                  "2025-12-03",
                  "xlsx",
                  "PT2 Blades on backorder with PWC"
                ]
              ]
            }
          ]
        },
        {
          "sec": "4",
          "top": "PW Canada Overhauls",
          "subs": [
            {
              "i": "4.1",
              "a": "ED1083",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2026-01-06",
              "n": [],
              "x": [
                "WS: OVERHAUL + LLP HP blade distress\" Released. Payment being sent WK 49. 03-DEC: Expected end of WK50 in Brazil 10-DEC: Arrived at AZUL. 12-DEC: Provide ESV Package. 06-JAN: ESV package received. — NEXT: - Confirm installation — [CLOSED] — ESV provided"
              ],
              "t": [
                [
                  "2025-12-03",
                  "xlsx",
                  "Expected end of WK50 in Brazil"
                ],
                [
                  "2025-12-10",
                  "xlsx",
                  "Arrived at AZUL."
                ],
                [
                  "2025-12-12",
                  "xlsx",
                  "Provide ESV Package."
                ],
                [
                  "2026-01-06",
                  "xlsx",
                  "ESV package received."
                ]
              ]
            },
            {
              "i": "4.2",
              "a": "ED1141",
              "s": "PENDING",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-04-23",
              "n": [
                "Confirm"
              ],
              "x": [
                "Provide plan 25-MAR: Going to STD Aero — NEXT: Confirm — [PENDING]"
              ],
              "t": [
                [
                  "2026-03-25",
                  "xlsx",
                  "Going to STD Aero"
                ],
                [
                  "2026-04-23",
                  "mtg",
                  "TPA Standard Aero Payment approved for engines ED1141, ED1025, and ED1008. Payment scheduled for 30 April. DAE contacted the shop and confirmed the timeline is acceptable."
                ]
              ]
            },
            {
              "i": "4.3",
              "a": "ED1113",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-04-02",
              "n": [
                "Confirm installation"
              ],
              "x": [
                "Released from shop - SV Available. — NEXT: Confirm installation — [IN PROGRESS] — Follow up with Otavio."
              ],
              "t": [
                [
                  "2014-01-08",
                  "mtg",
                  "JAN- Changed to"
                ],
                [
                  "2026-01-05",
                  "mtg",
                  "ETD"
                ],
                [
                  "2026-04-02",
                  "mtg",
                  "Engines in Shop: Azul confirmed the release of engines ED1113, ED0604, ED0941, and ED1110 in late March. Awaiting ESV records."
                ]
              ]
            },
            {
              "i": "4.4",
              "a": "ED0604",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-04-02",
              "n": [
                "Confirm installation"
              ],
              "x": [
                "Released from shop - SV Available. — NEXT: Confirm installation — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2014-01-12",
                  "mtg",
                  "JAN changed to"
                ],
                [
                  "2026-01-05",
                  "mtg",
                  "ETD"
                ],
                [
                  "2026-04-02",
                  "mtg",
                  "Engines in Shop: Azul confirmed the release of engines ED1113, ED0604, ED0941, and ED1110 in late March. Awaiting ESV records."
                ]
              ]
            },
            {
              "i": "4.5",
              "a": "ED0941",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-04-02",
              "n": [
                "Confirm installation"
              ],
              "x": [
                "Released from shop - SV Available. — NEXT: Confirm installation — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2026-01-05",
                  "mtg",
                  "HP, LP Disk- LP Impeller - HPT Front & Rear cover - HP, LP & PT Blades - PT Stator -GGC"
                ],
                [
                  "2026-04-02",
                  "mtg",
                  "Engines in Shop: Azul confirmed the release of engines ED1113, ED0604, ED0941, and ED1110 in late March. Awaiting ESV records."
                ]
              ]
            },
            {
              "i": "4.6",
              "a": "ED1110",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-04-02",
              "n": [
                "Confirm installation"
              ],
              "x": [
                "Released from shop - SV Available. — NEXT: Confirm installation — [IN PROGRESS] — –"
              ],
              "t": [
                [
                  "2026-01-05",
                  "mtg",
                  "HP, LP Disk- LP Impeller - HPT Front & Rear cover - HP, LP & PT Blades - PT Stator -GGC"
                ],
                [
                  "2026-01-14",
                  "mtg",
                  "Release updated to"
                ],
                [
                  "2026-04-02",
                  "mtg",
                  "Engines in Shop: Azul confirmed the release of engines ED1113, ED0604, ED0941, and ED1110 in late March. Awaiting ESV records."
                ]
              ]
            },
            {
              "i": "4.7",
              "a": "ED0701",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2026-05-29",
              "n": [
                "Azul to provide ESV Report"
              ],
              "x": [
                "WS: TAIL PIPE SMOKE + REP EMT INVESTIGATION Not disassembled yet - Awaiting induction in APR-2026 27-MAY: Released 26-MAY — NEXT: Azul to provide ESV Report — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2026-05-27",
                  "xlsx",
                  "Released"
                ],
                [
                  "2026-05-29",
                  "mtg",
                  "Azul confirmed the release in May of engines ED0701, ED0710, and ED0799 ."
                ]
              ]
            },
            {
              "i": "4.8",
              "a": "ED0905",
              "s": "IN PROGRESS",
              "p": "CRITICAL",
              "o": "PWC PT5",
              "u": "2026-06-03",
              "n": [
                "Confirm induction dates & TAT Confirm insurance coverage on price difference. Confirm insurance inspection was performed."
              ],
              "x": [
                "WS: HSI + FOD HSI - Will be inducted at Plant 5 insurance related & confirmed - induction subject to clearing the shop (likely Jan/26) 5-JAN: Engine is being prepared for shipment at PL5 07-JAN : Engine in shop. Release changed to APR 2026 28-JAN: Induction 25-FEB (PT5) 11-FEB: Shop quotation gap (Approx 500k difference ) - Azul to confirm if insurance will cover the difference. Azul to confirm. 19-FEB: Insruance will inspect engine at PT5. 23-FEB: Insurance deductible 100K. It could take 6 months for insurance payment. Under review. 11-MAR: Azul to confirm if insurance inspection took place. 18-MAR: Insurance inspetion completed. Awaiting PWC report. Payment to be made by azul on the Insurance amount per terms sheet conditions. 22-MAY: Breakout costs requested to shop. (FOD / HSI related....) 3-JUN: Azul to confirm cost of shop visit - How much is the insurance covering ? — NEXT: Confirm induction dates & TAT Confirm insurance coverage on price difference. Confirm insurance inspection was performed. — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2026-01-05",
                  "mtg",
                  "Engine is being prepared for shipment at PL5"
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "Engine in shop. Release changed to APR 2026"
                ],
                [
                  "2026-01-28",
                  "xlsx",
                  "Induction"
                ],
                [
                  "2026-02-11",
                  "xlsx",
                  "Shop quotation gap (Approx 500k difference ) - Azul to confirm if insurance will cover the difference. Azul to confirm."
                ],
                [
                  "2026-02-19",
                  "xlsx",
                  "Insruance will inspect engine at PT5."
                ],
                [
                  "2026-02-23",
                  "xlsx",
                  "Insurance deductible 100K. It could take 6 months for insurance payment. Under review."
                ],
                [
                  "2026-02-25",
                  "xlsx",
                  "PT5)"
                ],
                [
                  "2026-03-11",
                  "xlsx",
                  "Azul to confirm if insurance inspection took place."
                ],
                [
                  "2026-03-18",
                  "xlsx",
                  "Insurance inspetion completed. Awaiting PWC report. Payment to be made by azul on the Insurance amount per terms sheet conditions."
                ],
                [
                  "2026-05-22",
                  "xlsx",
                  "Breakout costs requested to shop. (FOD / HSI related....)"
                ],
                [
                  "2026-06-03",
                  "xlsx",
                  "Azul to confirm cost of shop visit - How much is the insurance covering ?"
                ]
              ]
            },
            {
              "i": "4.9",
              "a": "ED1007",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2026-03-25",
              "n": [
                "Confirm installation"
              ],
              "x": [
                "WS: OVH Might improve to JAN-26 5-JAN: Rework 85% completed Ordered parts missing (70% received) :LP Disc - LP Impeller- Rear cover -HP & 2x PT Blades -PT Stator -GGC 04-FEB: Release date 27-FEB 20-FEB: Release date 15-MAR 04-MAR: Release 17-MAR. 18-MAR: Release 21-MAR.(Materials) — NEXT: Confirm installation — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2004-03-15",
                  "xlsx",
                  "MAR: Release"
                ],
                [
                  "2020-02-27",
                  "xlsx",
                  "FEB: Release date"
                ],
                [
                  "2026-01-05",
                  "mtg",
                  "Rework 85% completed Ordered parts missing (70% received) :LP Disc - LP Impeller- Rear cover -HP & 2x PT Blades -PT Stator -GGC"
                ],
                [
                  "2026-02-04",
                  "xlsx",
                  "Release date"
                ],
                [
                  "2026-03-18",
                  "xlsx",
                  "Release"
                ],
                [
                  "2026-03-21",
                  "xlsx",
                  "Materials)"
                ],
                [
                  "2026-03-25",
                  "mtg",
                  "March shop releases remain firm, with a 2-day delay. Azul to confirm release dates for the three engines (ED1007, ED0712, ED0797) by Friday, 27 March."
                ]
              ]
            },
            {
              "i": "4.10",
              "a": "ED0797",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2026-03-25",
              "n": [
                "Confirm installation"
              ],
              "x": [
                "WS: OVH + LLP Might improve to JAN-26 5-JAN: Rework 90% 20-FEB: Release date MAR-23 04-MAR: Release date MAR-28 — NEXT: Confirm installation — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2026-01-05",
                  "mtg",
                  "Rework 90%"
                ],
                [
                  "2026-02-20",
                  "xlsx",
                  "Release date MAR-23"
                ],
                [
                  "2026-03-04",
                  "xlsx",
                  "Release date MAR-28"
                ],
                [
                  "2026-03-25",
                  "mtg",
                  "March shop releases remain firm, with a 2-day delay. Azul to confirm release dates for the three engines (ED1007, ED0712, ED0797) by Friday, 27 March."
                ]
              ]
            },
            {
              "i": "4.11",
              "a": "ED1085",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2026-02-20",
              "n": [
                "Confirm installation"
              ],
              "x": [
                "WS: EMT INVESTIGATION ? PIPE SMOKE + OH & LLP Should pull to FEB-26 20-FEB: Release 31-MAR — NEXT: Confirm installation — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2026-02-20",
                  "xlsx",
                  "Release"
                ]
              ]
            },
            {
              "i": "4.12",
              "a": "ED1008",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2026-04-23",
              "n": [],
              "x": [
                "25-MAR: Engine inducted in the queue for dissaslbly. No release date yet. — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2026-03-25",
                  "xlsx",
                  "Engine inducted in the queue for dissaslbly. No release date yet."
                ],
                [
                  "2026-04-23",
                  "mtg",
                  "TPA Standard Aero Payment approved for engines ED1141, ED1025, and ED1008. Payment scheduled for 30 April. DAE contacted the shop and confirmed the timeline is acceptable."
                ]
              ]
            },
            {
              "i": "4.13",
              "a": "ED0942",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "PWC",
              "u": "",
              "n": [],
              "x": [
                "Possible exchange with ED0234 — NEXT: Confirm — [CLOSED] — Exchange weith ED0324"
              ],
              "t": []
            },
            {
              "i": "4.14",
              "a": "ED0863",
              "s": "PENDING",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2025-12-10",
              "n": [],
              "x": [
                "10-DEC: WS: OVH - (With ED1463-GB) — [PENDING]"
              ],
              "t": [
                [
                  "2025-12-10",
                  "mtg",
                  "WS: OVH - (With ED1463-GB)"
                ]
              ]
            },
            {
              "i": "4.15",
              "a": "ED1463",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2025-12-10",
              "n": [],
              "x": [
                "10-DEC: WS: OVH — [CLOSED] — Not to be tracked"
              ],
              "t": [
                [
                  "2025-12-10",
                  "mtg",
                  "WS: OVH"
                ]
              ]
            },
            {
              "i": "4.16",
              "a": "ED0682",
              "s": "PENDING",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2026-03-25",
              "n": [],
              "x": [
                "10-DEC: WS: OVH 25-MAR: Engine inducted and is Cost Estimate received under Azul’s review, no redelivery date yet. — [PENDING] — Std Aero"
              ],
              "t": [
                [
                  "2025-12-10",
                  "mtg",
                  "WS: OVH"
                ],
                [
                  "2026-03-25",
                  "xlsx",
                  "Engine inducted and is Cost Estimate received under Azul’s review, no redelivery date yet."
                ]
              ]
            },
            {
              "i": "4.17",
              "a": "ED1008",
              "s": "PENDING",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2025-12-10",
              "n": [],
              "x": [
                "10-DEC: WS: OVH — [PENDING]"
              ],
              "t": [
                [
                  "2025-12-10",
                  "mtg",
                  "WS: OVH"
                ]
              ]
            },
            {
              "i": "4.18",
              "a": "ED1025",
              "s": "PENDING",
              "p": "NORMAL",
              "o": "PWC",
              "u": "2026-04-23",
              "n": [],
              "x": [
                "10-DEC: WS: OVH — [PENDING]"
              ],
              "t": [
                [
                  "2025-12-10",
                  "mtg",
                  "WS: OVH"
                ],
                [
                  "2026-04-23",
                  "mtg",
                  "TPA Standard Aero Payment approved for engines ED1141, ED1025, and ED1008. Payment scheduled for 30 April. DAE contacted the shop and confirmed the timeline is acceptable."
                ]
              ]
            },
            {
              "i": "4.19",
              "a": "ED0607",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "",
              "u": "2026-03-05",
              "n": [],
              "x": [
                "5-JAN: HSI - GGC Access (Weld) Can not be done in Sorocaba, GGC Access 07-JAN: PT5 instead. NO slot confirmed. 14-JAN: Might be included in StdAero TPA. 05-MAR possible induction date. — NEXT: Confirm — [CLOSED] — Will be induced in PW SOrocaba"
              ],
              "t": [
                [
                  "2026-01-05",
                  "mtg",
                  "HSI - GGC Access (Weld) Can not be done in Sorocaba, GGC Access"
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "PT5 instead. NO slot confirmed."
                ],
                [
                  "2026-01-14",
                  "mtg",
                  "Might be included in StdAero TPA."
                ],
                [
                  "2026-03-05",
                  "mtg",
                  "possible induction date."
                ]
              ]
            },
            {
              "i": "4.21",
              "a": "ED1142",
              "s": "PENDING",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-04-16",
              "n": [
                "Confirm"
              ],
              "x": [
                "25-MAR: Induction date 16-APR. NO release date yet. — NEXT: Confirm — [PENDING]"
              ],
              "t": [
                [
                  "2026-03-25",
                  "xlsx",
                  "Induction date"
                ],
                [
                  "2026-04-16",
                  "xlsx",
                  "NO release date yet."
                ]
              ]
            }
          ]
        },
        {
          "sec": "5",
          "top": "PW Sorocaba / Std Aero HSI",
          "subs": [
            {
              "i": "5.1",
              "a": "",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "PWC / Azul",
              "u": "",
              "n": [],
              "x": [
                "List of engines for HSI, sequence of induction and workscopes received (not on the workscope but Azul confirmed new LLP's will be installed) — NEXT: Confirm induction dates & TAT — [CLOSED]"
              ],
              "t": []
            },
            {
              "i": "5.2",
              "a": "ED0712",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-05-13",
              "n": [
                "Pending ESV package"
              ],
              "x": [
                "Induction date NOV-11 Engine arrived to shop. Awaiting payment update. 04-FEB: Possible delay due to parts LT. 20-FEB: Delayed (parts). Release expected by mid-March 04-MAR: Relase 13-MAR 11-MAR: Issue with balance. MAR-23 new release date. 25-MAR: Engine SV. Awaiting payment scheudled for this week. — NEXT: Pending ESV package — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2011-03-13",
                  "xlsx",
                  "MAR: Issue with balance. MAR-23 new release date."
                ],
                [
                  "2026-02-04",
                  "xlsx",
                  "Possible delay due to parts LT."
                ],
                [
                  "2026-02-20",
                  "xlsx",
                  "Delayed (parts). Release expected by mid-March"
                ],
                [
                  "2026-03-04",
                  "xlsx",
                  "Relase"
                ],
                [
                  "2026-03-25",
                  "mtg",
                  "March shop releases remain firm, with a 2-day delay. Azul to confirm release dates for the three engines (ED1007, ED0712, ED0797) by Friday, 27 March."
                ],
                [
                  "2026-03-25",
                  "xlsx",
                  "Engine SV. Awaiting payment scheudled for this week."
                ],
                [
                  "2026-05-13",
                  "mtg",
                  "ED0712, ED0799: Received at Azul facilities. Azul to provide shop visit packages."
                ]
              ]
            },
            {
              "i": "5.3",
              "a": "ED0710",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-05-29",
              "n": [
                "Azul to provide ESV Report"
              ],
              "x": [
                "HSI 10-DEC: Engine scheduled for HSI at StandardAero subject to TPA. Tracked on item 11.1 below. 21-JAN: Induction in 27-JAN-26. Release TBC 26-JAN: Workscope approved. Ok to induct 25-MAR: Engine inducted on Feb 02nd, redelivery date probably in May. 27-MAY: Released and received in Azul — NEXT: Azul to provide ESV Report — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2025-12-10",
                  "mtg",
                  "Engine scheduled for HSI at StandardAero subject to TPA. Tracked on item 11.1 below."
                ],
                [
                  "2026-01-21",
                  "xlsx",
                  "Induction in"
                ],
                [
                  "2026-01-26",
                  "xlsx",
                  "Workscope approved. Ok to induct"
                ],
                [
                  "2026-01-27",
                  "xlsx",
                  "Release TBC"
                ],
                [
                  "2026-03-25",
                  "xlsx",
                  "Engine inducted on Feb 02nd, redelivery date probably in May."
                ],
                [
                  "2026-05-27",
                  "xlsx",
                  "Released and received in Azul"
                ],
                [
                  "2026-05-29",
                  "mtg",
                  "Azul confirmed the release in May of engines ED0701, ED0710, and ED0799 ."
                ],
                [
                  "2026-05-29",
                  "mtg",
                  "Shop visit reports have been provided by Azul. ED0710 report pending."
                ]
              ]
            },
            {
              "i": "5.4",
              "a": "ED0607",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "PWC PT5",
              "u": "2026-03-31",
              "n": [
                "Confirm release date"
              ],
              "x": [
                "Induction date 08-DEC DAE confirmed acceptance 24-NOV Payment approved. Scheduled for DEC 5th Release expected MAR-10 28-JAN: Will move to PT5. Shipment in progress. 25-FEB: Moving to PT5. Induction in March. 18-MAR: Refund issue being discussed with DAE via email. (Credit for other engines, or refund and forward payment to PT5). 38K Customs charge for refunding the payment. 25-MAR: 31-MARCH induction date. No release date yet. — NEXT: Confirm release date — [IN PROGRESS] — to PT5"
              ],
              "t": [
                [
                  "2025-11-24",
                  "mtg",
                  "Payment approved. Scheduled for DEC 5th Release expected MAR-10"
                ],
                [
                  "2025-12-08",
                  "mtg",
                  "DAE confirmed acceptance"
                ],
                [
                  "2026-01-28",
                  "xlsx",
                  "Will move to PT5. Shipment in progress."
                ],
                [
                  "2026-02-25",
                  "xlsx",
                  "Moving to PT5. Induction in March."
                ],
                [
                  "2026-03-18",
                  "xlsx",
                  "Refund issue being discussed with DAE via email. (Credit for other engines, or refund and forward payment to PT5). 38K Customs charge for refunding the payment."
                ],
                [
                  "2026-03-31",
                  "xlsx",
                  "CH induction date. No release date yet."
                ]
              ]
            },
            {
              "i": "5.5",
              "a": "ED0799",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-05-29",
              "n": [
                "Confirm release and send SV package."
              ],
              "x": [
                "HSI 10-DEC: Engine scheduled for HSI at StandardAero subject to TPA. Tracked on item 11.1 below. 19-JAN: Added again to PWC list (out from StdAero). Engine will ship this week. 21-JAN: Induction in 27- JAN-26. Release TBC 26-JAN: Workscope approved. Ok to induct 25-MAR : Engine inducted on Jan 26th, redelivery target to April 29th. — NEXT: Confirm release and send SV package. — [IN PROGRESS] — PO 79020 1.1M"
              ],
              "t": [
                [
                  "2025-12-10",
                  "mtg",
                  "Engine scheduled for HSI at StandardAero subject to TPA. Tracked on item 11.1 below."
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Added again to PWC list (out from StdAero). Engine will ship this week."
                ],
                [
                  "2026-01-21",
                  "xlsx",
                  "Induction in 27- JAN-26. Release TBC"
                ],
                [
                  "2026-01-26",
                  "xlsx",
                  "Workscope approved. Ok to induct"
                ],
                [
                  "2026-03-25",
                  "xlsx",
                  "Engine inducted on Jan 26th, redelivery target to April 29th."
                ],
                [
                  "2026-05-13",
                  "mtg",
                  "ED0712, ED0799: Received at Azul facilities. Azul to provide shop visit packages."
                ],
                [
                  "2026-05-29",
                  "mtg",
                  "Azul confirmed the release in May of engines ED0701, ED0710, and ED0799 ."
                ]
              ]
            },
            {
              "i": "5.6",
              "a": "ED0542",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-05-29",
              "n": [
                "Confirm release date"
              ],
              "x": [
                "HSI 26-JAN: Workscope approved. Ok to induct 27-FEB: Workscope sent to shop. 25-MAR: Engine inducted on March 18th, no redelivery date yet. 08-APR: Part of ESV to be performed in PT5 due to capability limitations. Azul to provide detail on affected parts. TAT might be affected. 29-APR: Complete engine will go to PT5. Discussions in progress. Slot TBC. 27-MAY: Engine arrived back to Azul. Will ship to PT5- Induction TBD (JUL-2026) — NEXT: Confirm release date — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2026-01-26",
                  "xlsx",
                  "Workscope approved. Ok to induct"
                ],
                [
                  "2026-02-27",
                  "xlsx",
                  "Workscope sent to shop."
                ],
                [
                  "2026-03-25",
                  "xlsx",
                  "Engine inducted on March 18th, no redelivery date yet."
                ],
                [
                  "2026-04-08",
                  "mtg",
                  "ED0542 Due to capability limitations at PW Sorocaba, part of the engine needs to be shipped to PT5. AZUL to provide further details on which module/part needs to be shipped to PT5."
                ],
                [
                  "2026-04-08",
                  "xlsx",
                  "Part of ESV to be performed in PT5 due to capability limitations. Azul to provide detail on affected parts. TAT might be affected."
                ],
                [
                  "2026-04-29",
                  "xlsx",
                  "Complete engine will go to PT5. Discussions in progress. Slot TBC."
                ],
                [
                  "2026-05-13",
                  "mtg",
                  "ED0542: Arrived at PT5. Workscope may be escalated to OVH due to findings."
                ],
                [
                  "2026-05-27",
                  "xlsx",
                  "Engine arrived back to Azul. Will ship to PT5- Induction TBD (JUL-2026)"
                ],
                [
                  "2026-05-29",
                  "mtg",
                  "ED0542 : Returned to Azul's facilities and will be shipped to PT5 due to capability limitations at PW Sorocaba. Induction expected in July 2026."
                ]
              ]
            },
            {
              "i": "5.7",
              "a": "ED0655",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-06-10",
              "n": [
                "Provide release date"
              ],
              "x": [
                "HSI 26-JAN: Workscope approved. Ok to induct 27-FEB: Workscope sent to shop. 25-FEB: Engine inducted on March 09th, no release date yet — NEXT: Provide release date — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2026-01-26",
                  "xlsx",
                  "Workscope approved. Ok to induct"
                ],
                [
                  "2026-02-25",
                  "xlsx",
                  "Engine inducted on March 09th, no release date yet"
                ],
                [
                  "2026-02-27",
                  "xlsx",
                  "Workscope sent to shop."
                ],
                [
                  "2026-06-10",
                  "mtg",
                  "Next engine release: ED0655 (PW Sorocaba) � 30 June."
                ]
              ]
            },
            {
              "i": "5.8",
              "a": "ALL",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "Azul",
              "u": "",
              "n": [
                "Provide cost when available"
              ],
              "x": [
                "Azul cost estimates for HSI (~$1M avg) — NEXT: Provide cost when available — [IN PROGRESS] — –"
              ],
              "t": []
            }
          ]
        },
        {
          "sec": "6",
          "top": "Parts Swap",
          "subs": [
            {
              "i": "6.1",
              "a": "",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "DAE / Azul",
              "u": "",
              "n": [],
              "x": [
                "Lease amendment for ED0230/2 & EB0133 — NEXT: 1 Comment received from Azul - Follow up. — [COMPLETE] — Engine delivered."
              ],
              "t": []
            },
            {
              "i": "6.2",
              "a": "Components / Parts (MSN 554 & 548",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL (Legal), DAE, AZUL",
              "u": "2026-05-25",
              "n": [
                "Confirm pickup of parts and provide AWB"
              ],
              "x": [
                "Term Sheet approved; 68 parts acceptance certificate - Term sheet submitted to the court & approved - Provided for Azul review on 22/Oct -Azul reviewing with Legal team reviewing the documents will provide comments on the acceptance cert — NEXT: Week of 17-NOV — [COMPLETE] — Azul Legal reviewing (since 22/Oct)",
                "68 parts removed, packed, EASA Form One available — NEXT: Ship parts & provide invoice — [COMPLETE] — Consolidated in Billund",
                "Azul review delayed Azul to expedite review to confirm shipment can take place. - HF XVR P/N 822-0101-002 S/N 1623 Added to shipment 01-DEC - Rudder Damper FE205-000 S/N FR1013 Added to shipment 01-DEC - UN# provided 26-NOV 03-DEC: Azul revieweing PO. Feedback expected by EBD 10-DEC: Awaiting shipping quotes. 14-DEC: Azul new comments on acceptance certificate 17-DEC: Azul to send reviewed wording on 2(iii). 18-DEC: Azul executed version did not match last agreed version. 05-JAN: New revision sent. Under DAE Legal revision. 07-JAN: Azul to provide executed version. Legal team review in progress. 08-JAN: Certificate executed. Parts released. Pending pickup and inform AWB. 21-JAN: Collection expected this week at the latest. Daniel will update by email. 28-JAN: Parts Collected. Awaiting shipment. Tracking will be provided. 04-FEB: Azul updating documents internally to confirm shipment. Awaiting update on AWB. 11-FEB: Corrected invoice provided for extinguisher. 20-FEB: Booking not yet confirmed 04-MAR: Booking complete by fieday. Awaiting Tracking. 11-MAR: 18-APR expected arrival. 18-MAR: Shipping 26-MAR. New arrival expected 21-APR. Azul to share AWB by the end of the day. 25-MAR: Shipping delay. Loading BTW 30-MAR and 02-APR. Arrival estimated 28-APR 29-APR: Arrived to Santos. Clearance in progress. Incoming inspection scheudle TBC. 20-MAY: Arrived in Azul facilities. Incoming inspection starts 25-MAY: Azul rejects 65 out of 66 parts. — NEXT: Confirm pickup of parts and provide AWB — [IN PROGRESS] — Follow up with Daniel Salinas",
                "Azul requires the SPV entity that the parts are being purchased from - DAE advised that should be the same SPV for ED0809... - DAE reconfirmed via email but Azul to advise if any additional action required — NEXT: Azul to advise if further action needed Same SPV ED0809 used. — [COMPLETE]"
              ],
              "t": [
                [
                  "2003-11-26",
                  "mtg",
                  "DEC: Azul revieweing PO. Feedback expected by EBD"
                ],
                [
                  "2025-12-01",
                  "mtg",
                  "Rudder Damper FE205-000 S/N FR1013 Added to shipment"
                ],
                [
                  "2025-12-01",
                  "mtg",
                  "UN# provided"
                ],
                [
                  "2025-12-10",
                  "mtg",
                  "Awaiting shipping quotes."
                ],
                [
                  "2025-12-14",
                  "mtg",
                  "Azul new comments on acceptance certificate"
                ],
                [
                  "2025-12-17",
                  "mtg",
                  "Azul to send reviewed wording on 2(iii)."
                ],
                [
                  "2025-12-18",
                  "mtg",
                  "Azul executed version did not match last agreed version."
                ],
                [
                  "2026-01-05",
                  "mtg",
                  "New revision sent. Under DAE Legal revision."
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "AZul to provide executed version. Legal team review in progress."
                ],
                [
                  "2026-01-08",
                  "mtg",
                  "Certificate executed. Parts released. Pending pickup and inform AWB."
                ],
                [
                  "2026-01-21",
                  "xlsx",
                  "Collection expected this week at the latest. Daniel will update by email."
                ],
                [
                  "2026-01-28",
                  "xlsx",
                  "Parts Collected. Awaiting shipment. Tracking will be provided."
                ],
                [
                  "2026-02-04",
                  "xlsx",
                  "Azul updating documents internally to confirm shipment. Awaiting update on AWB."
                ],
                [
                  "2026-02-11",
                  "xlsx",
                  "Corrected invoice provided for extinguisher."
                ],
                [
                  "2026-02-20",
                  "xlsx",
                  "Booking not yet confirmed"
                ],
                [
                  "2026-03-04",
                  "xlsx",
                  "Booking complete by fieday. Awaiting Tracking."
                ],
                [
                  "2026-03-18",
                  "xlsx",
                  "Shipping"
                ],
                [
                  "2026-03-25",
                  "xlsx",
                  "Shipping delay. Loading BTW"
                ],
                [
                  "2026-03-26",
                  "xlsx",
                  "New arrival expected"
                ],
                [
                  "2026-03-30",
                  "xlsx",
                  "and"
                ],
                [
                  "2026-04-02",
                  "xlsx",
                  "Arrival estimated"
                ],
                [
                  "2026-04-18",
                  "xlsx",
                  "expected arrival."
                ],
                [
                  "2026-04-21",
                  "xlsx",
                  "Azul to share AWB by the end of the day."
                ],
                [
                  "2026-04-28",
                  "xlsx",
                  "APR: Arrived to Santos. Clearance in progress. Incoming inspection scheudle TBC."
                ],
                [
                  "2026-05-20",
                  "xlsx",
                  "Arrived in Azul facilities. Incoming inspection starts"
                ],
                [
                  "2026-05-25",
                  "xlsx",
                  "Azul rejects 65 out of 66 parts."
                ]
              ]
            }
          ]
        },
        {
          "sec": "7",
          "top": "Engine Records (ESV)",
          "subs": [
            {
              "i": "7.1",
              "a": "ED0305 ED0306 ED0324 ED0325",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "DAE",
              "u": "",
              "n": [],
              "x": [
                "Historical documentation uploaded — NEXT: Confirmed uploaded — [COMPLETE] — –"
              ],
              "t": []
            },
            {
              "i": "7.3",
              "a": "ED0305 ED0306",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "DAE",
              "u": "",
              "n": [],
              "x": [
                "ED0305/6 overhaul completed & accepted — NEXT: Acceptance confirmed Expecting to have them ready for delivery ahead of time STD Aero Paris. In progess with DAE. Release expected by early december — [COMPLETE] — Traacked on section 2. Swaps",
                "Prepare delivery certificate — [COMPLETE] — Traacked on section 2. Swaps"
              ],
              "t": []
            },
            {
              "i": "7.4",
              "a": "ED0324 ED0325",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "Std Aero, Azul",
              "u": "",
              "n": [
                "ED0324 - Available probably earlier than FEB ED0325 - TBD.",
                "Confirm acceptance"
              ],
              "x": [
                "-HSI Complete - Engines held in shop for PT2 blades replacement - work in progress at Std Aero (stator repair / replacement pacing item) — NEXT: ED0324 - Available probably earlier than FEB ED0325 - TBD. — [IN PROGRESS] — Commitments maintained",
                "AZUL Engineering reviewing (HSI + PT2 blades) — NEXT: Confirm acceptance — [IN PROGRESS] — Inform if there is any objection with records ASAP."
              ],
              "t": []
            }
          ]
        },
        {
          "sec": "8",
          "top": "Landing Gear",
          "subs": [
            {
              "i": "8.1",
              "a": "MN728 MN889 MN846",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "Azul",
              "u": "",
              "n": [],
              "x": [
                "Review DAE-proposed LG documentation — NEXT: Complete review and feedback — [COMPLETE] — DAE supporting info"
              ],
              "t": []
            },
            {
              "i": "8.2",
              "a": "14B26218 B726 B731",
              "s": "IN PROGRESS",
              "p": "CRITICAL",
              "o": "AZUL",
              "u": "2026-04-29",
              "n": [
                "- AZUL confirm rep for 1st week of april inspection in Shannon and Tolouse - DAE to confirm inspectors for 1st week of april in VPC and PLU "
              ],
              "x": [
                "Formal confirmation of LG exchanges 03-DEC: Azul reviewing. 10-DEC: Azul will review 11-DEC. 17-DEC: Azul to provide update after today's meeting. 07-DEC: Dae to check and provide additional information request (New list of requirements). 19-JAN: No response from technical team from AZUL. Leonardo to follow-up internally. 21-JAN: No comments from technical team. Awaiting update from technical manager. 28-JAN: Azul requested further records by email. DAE to provide. 04-FEB: No update. will follow up separatelly. 11-FEB: Additional documents required from DAE. 20-FEB: Review of records in progress. Missing docs. Daniel to send PRR. 24-FEB: AZUL technical team will send update today on what is missing for the records review of the candidate LGs. 11-MAR: Updated plan added to weekly minutes. 18-MAR: DAE and AZUL to coordinate inspections for 1st week of April | 2 side braces sent to OVH. Review of alternate plan in porgress. Azul infoms no other side braces are available for swap. | Records review in progress for outstanding documents. 08-APR: Inspection feedback provided - AZUL to provide Serviceability table status update and supporting records. Cap on reimbursements. 29-APR: Pending LLP Status, Inst/Rem history, NIS . Proforma invoice in progress. Safran working on outstanding incoming LG records. Information is on the available records. Records ot be accepted in same condition upon redelivery. AZUL preparing the booking in paralell. — NEXT: - AZUL confirm rep for 1st week of april inspection in Shannon and Tolouse - DAE to confirm inspectors for 1st week of april in VPC and PLU - AZUL revieweing records. - AZUL to provide LG6 records for review. - DAE to provide pending NIS. PRR avlialabe . — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2025-12-03",
                  "mtg",
                  "Azul reviewing."
                ],
                [
                  "2025-12-07",
                  "mtg",
                  "Dae to check and provide additional information request (New list of requirements)."
                ],
                [
                  "2025-12-10",
                  "mtg",
                  "Azul will review"
                ],
                [
                  "2025-12-17",
                  "mtg",
                  "Azul to provide update after today's meeting."
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "No response from technical team from AZUL. Leonardo to follow-up internally."
                ],
                [
                  "2026-01-21",
                  "xlsx",
                  "No comments from technical team. Awaiting update from technical manager."
                ],
                [
                  "2026-01-28",
                  "xlsx",
                  "Azul requested further records by email. DAE to provide."
                ],
                [
                  "2026-02-04",
                  "xlsx",
                  "No update. will follow up separatelly."
                ],
                [
                  "2026-02-11",
                  "xlsx",
                  "Additional documents required from DAE."
                ],
                [
                  "2026-02-20",
                  "xlsx",
                  "Review of records in progress. Missing docs. Daniel to send PRR."
                ],
                [
                  "2026-02-24",
                  "xlsx",
                  "AZUL technical team will send update today on what is missing for the records review of the candidate LGs."
                ],
                [
                  "2026-03-11",
                  "xlsx",
                  "Updated plan added to weekly minutes."
                ],
                [
                  "2026-03-18",
                  "xlsx",
                  "DAE and AZUL to coordinate inspections for 1st week of April | 2 side braces sent to OVH. Review of alternate plan in porgress. Azul infoms no other side braces are available for swap. | Records review in progress for outstanding documents."
                ],
                [
                  "2026-04-08",
                  "xlsx",
                  "Inspection feedback provided - AZUL to provide Serviceability table status update and supporting records. Cap on reimbursements."
                ],
                [
                  "2026-04-29",
                  "xlsx",
                  "Pending LLP Status, Inst/Rem history, NIS . Proforma invoice in progress. Safran working on outstanding incoming LG records. Information is on the available records. Records ot be accepted in same condition upon redelivery. AZUL preparing the booking in paralell."
                ]
              ]
            },
            {
              "i": "8.3",
              "a": "",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "Azul",
              "u": "",
              "n": [],
              "x": [
                "Confirm aircraft receiving exchange LG — NEXT: Gears will be installed on MSN 1088 (AQI) + 1180 (AQS) — [COMPLETE] — –"
              ],
              "t": []
            }
          ]
        },
        {
          "sec": "9",
          "top": "Aircraft Heavy Maintenance / RTS",
          "subs": [
            {
              "i": "9.1",
              "a": "1115 (AQN)",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2025-11-20",
              "n": [],
              "x": [
                "i. CRS expected end Nov but subject to engines availability — [COMPLETE] — CRS 20-NOV with non-DAE engines",
                "ED0230 ED0232 — Awaiting confirmation on 1043 - 1113 — NEXT: Confirm — [COMPLETE] — ED0232 arrival + 15DY"
              ],
              "t": [
                [
                  "2025-11-20",
                  "xlsx",
                  "with non-DAE engines"
                ]
              ]
            },
            {
              "i": "9.2",
              "a": "1043 (ATV) 1113 (AQM)",
              "s": "PENDING",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "",
              "n": [
                "Confirm"
              ],
              "x": [
                "-Next induction to be confirmed - planning team working on the new production line (final adjustments) -Azul to share asap -next MSN's are likely 1043 & 1113 with induction in Pampulha induction subject to engines availability — NEXT: Confirm — [PENDING]"
              ],
              "t": []
            },
            {
              "i": "9.3",
              "a": "12 aircraft on storage. RTS Plan",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-04-08",
              "n": [],
              "x": [
                "Engine allocation plan Plan provided WK 48 - Feedback sent to Azul. Awaiting response. - 01-DEC Azul plan to send engines to Std Aero - 03-DEC : Azul works on new plan for having all DAE A/C in service during 2026. - 10-DEC: Draft of new plan is available. Expecting 26 ATRs operative by Q1-27 - 17-DEC: Azul to review milestones 18-DEC. - 07-JAN: New plan revision available. Azul to share - 14-JAN: Daniel to share updated plan. - 19-JAN: Plan Shared. No inductions in the next months. Pending for review during 21-JAN meeting. - 21-JAN: Azul reports lack of available engines to support return-to-service of grounded aircraft in 1H 2026. Azul is exploring the possibility of leasing spare engines from DAE; however, restoration of oudtoing engines would be required. Azul is urged to provide the support records for outgoing engines, re-evaluate the recovery plan, and promptly submit an updated engine allocation plan. -28-JAN: Report received on 27-JAN is incomplete and does not provide a comprehensive plan for returning the grounded aircraft to service. An updated report showing all engines, all MSNs requested. - 04-FEB: Azul working on new draft that plans to return all 12 airfrat back to service during 2026. Possible use of external MROs given availalbe slots. Final version commited for 23-FEB. - 11-FEB: No updates - 25-FEB: Expecting to share a copy by end of day today. 2 to 3 A/C reactivation scheduled for 1st half of 2026. Hoping to reactivate all 12 A/C by end of 2026. - 04-MAR: MSN 1088 Workscope pending. Confirm assigned engines. Confirm MRO for outsourced mtx. - 11-MAR: Azul visited MRO in Brazil. No definitions yet. - 25-MAR: Azul provided engine allocation plan. Meeting about external MROs today. - 08-APR: GTX Aeropsace Porto Alegre might be assigned for MSN 1281 and 1342. No GTA in place. — [IN PROGRESS] — Awaiting AZUL tech team update."
              ],
              "t": [
                [
                  "2025-12-01",
                  "mtg",
                  "Azul plan to send engines to Std Aero -"
                ],
                [
                  "2025-12-03",
                  "mtg",
                  "Azul works on new plan for having all DAE A/C in service during 2026. -"
                ],
                [
                  "2025-12-10",
                  "mtg",
                  "Draft of new plan is available. Expecting 26 ATRs operative by Q1-27 -"
                ],
                [
                  "2025-12-17",
                  "mtg",
                  "Azul to review milestones"
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "New plan revision available. Azul to share"
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "New plan revision available. Azul to share -"
                ],
                [
                  "2026-01-14",
                  "mtg",
                  "Daniel to share updated plan."
                ],
                [
                  "2026-01-14",
                  "mtg",
                  "Daniel to share updated plan. -"
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Plan Shared. No inductions in the next months. Pending for review during"
                ],
                [
                  "2026-01-21",
                  "mtg",
                  "meeting."
                ],
                [
                  "2026-01-21",
                  "xlsx",
                  "Azul reports lack of available engines to support return-to-service of grounded aircraft in 1H 2026. Azul is exploring the possibility of leasing spare engines from DAE; however, restoration of oudtoing engines would be required. Azul is urged to provide the support records for outgoing engines, re-evaluate the recovery plan, and promptly submit an updated engine allocation plan. -"
                ],
                [
                  "2026-01-21",
                  "xlsx",
                  "meeting. -"
                ],
                [
                  "2026-01-27",
                  "xlsx",
                  "is incomplete and does not provide a comprehensive plan for returning the grounded aircraft to service. An updated report showing all engines, all MSNs requested. -"
                ],
                [
                  "2026-01-28",
                  "xlsx",
                  "Report received on"
                ],
                [
                  "2026-02-04",
                  "xlsx",
                  "Azul working on new draft that plans to return all 12 airfrat back to service during 2026. Possible use of external MROs given availalbe slots. Final version commited for"
                ],
                [
                  "2026-02-11",
                  "xlsx",
                  "No updates -"
                ],
                [
                  "2026-02-25",
                  "xlsx",
                  "Expecting to share a copy by end of day today. 2 to 3 A/C reactivation scheduled for 1st half of 2026. Hoping to reactivate all 12 A/C by end of 2026. -"
                ],
                [
                  "2026-03-04",
                  "xlsx",
                  "MSN 1088 Workscope pending. Confirm assigned engines. Confirm MRO for outsourced mtx. -"
                ],
                [
                  "2026-03-11",
                  "xlsx",
                  "Azul visited MRO in Brazil. No definitions yet. -"
                ],
                [
                  "2026-03-25",
                  "xlsx",
                  "Azul provided engine allocation plan. Meeting about external MROs today. -"
                ],
                [
                  "2026-04-08",
                  "xlsx",
                  "GTX Aeropsace Porto Alegre might be assigned for MSN 1281 and 1342. No GTA in place."
                ]
              ]
            },
            {
              "i": "9.4",
              "a": "1166 (AQQ)",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2025-12-17",
              "n": [],
              "x": [
                "Aircraft parked in Bauru due to ED0736 / ED0904 remaining life used AQQ will remain in storage till engines are available engines for AQQ to be confirmed - PWC engines and/or EB0133 - tbc 17-DEC: Induction might be delayed depending on ED0230 condition. — NEXT: Induction by 25-DEC-2025 — [COMPLETE] — Engines ED0230, ED0232 fitted"
              ],
              "t": [
                [
                  "2025-12-17",
                  "xlsx",
                  "Induction might be delayed depending on ED0230 condition."
                ]
              ]
            },
            {
              "i": "9.5",
              "a": "1342 (AKI)",
              "s": "PENDING",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "",
              "n": [
                "Induction by JAN 2026",
                "Induction by end of SEP-2026",
                "Induction by OCT-2026"
              ],
              "x": [
                "NEXT: Induction by JAN 2026 — [PENDING] — Last update 13-NOV-25",
                "1043 (ATV) — NEXT: Induction by end of SEP-2026 — [PENDING] — Last update 13-NOV-25",
                "1113 (AQM) — NEXT: Induction by OCT-2026 — [PENDING] — Last update 13-NOV-25"
              ],
              "t": []
            }
          ]
        },
        {
          "sec": "10",
          "top": "AOG / Insurance / Claims",
          "subs": [
            {
              "i": "10.1",
              "a": "ESN 599811",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-05-13",
              "n": [
                "Azul to provide SV package."
              ],
              "x": [
                "No activity reported the last 2 months. Engine U/S will be inducted in JAN-15-2026 - GE Celma Vibration - Possible debris found Provide storage records. 29-DEC: Work scope provided - Bird strike ? 07-JAN: Insurance query (?) - Engine serviceable after bird strike inspection. / 21-JAN: Workscope approved. Induction expected by 03-Feb-2026. 04-FEB: Engine inducted. Awaiting release date. 20-FEB: MAY-11 Release. 13-MAY: Released from shop. REceived by Azul. Pending SV Package. — NEXT: Azul to provide SV package. — [IN PROGRESS] — LEAP-1A26 assigned to MSN 10070 PR-YSG Eduardo - Follow up.",
                "Workscope - Provide when available — [CLOSED]"
              ],
              "t": [
                [
                  "2025-12-29",
                  "mtg",
                  "Work scope provided - Bird strike ?"
                ],
                [
                  "2025-12-29",
                  "mtg",
                  "Workscope provded - Birdstrike ?"
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "Insruance query (?) - Engine serviceable after birdstrike inspection. /"
                ],
                [
                  "2026-01-07",
                  "mtg",
                  "Insurance query (?) - Engine serviceable after bird strike inspection. /"
                ],
                [
                  "2026-01-21",
                  "xlsx",
                  "Workscope approved. Induction expected by"
                ],
                [
                  "2026-02-04",
                  "xlsx",
                  "Engine inducted. Awaiting release date."
                ],
                [
                  "2026-02-20",
                  "xlsx",
                  "MAY-11 Release."
                ],
                [
                  "2026-05-13",
                  "xlsx",
                  "Released from shop. REceived by Azul. Pending SV Package."
                ]
              ]
            },
            {
              "i": "10.2",
              "a": "MSN 1342 | PR-AKI Insurance claim",
              "s": "IN PROGRESS",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-04-08",
              "n": [
                "AZUL to confirm SN of assigned LG (BER replaced, repaired ??)"
              ],
              "x": [
                "13-JAN : NLG Insurance claim 27-AUG-2022 Azul to provide incident report. 19-JAN: Leonardo will follow up and provide maintenace records. 21-JAN: Azul insisting internally to provide the support records. 28-JAN: No update. 04-FEB: Azul requested 1+ week. 10-FEB: Safran report provided. Under review 16-FEB: Feedback provided. 11-MAR: AZUL technical team to provide update for closing claim. 18-MAR: Call will be scheudled for today to discuss in detail. Awaiting invitation from AZUL. 08-APR: Pending ATR0166536 response from ATR confirming A/C inspections are acceptable. Pending Assigned LG Data. — NEXT: AZUL to confirm SN of assigned LG (BER replaced, repaired ??) — [IN PROGRESS] — Following up with Daniel"
              ],
              "t": [
                [
                  "2022-08-27",
                  "mtg",
                  "Azul to provide incident report."
                ],
                [
                  "2026-01-13",
                  "mtg",
                  "NLG Insurance claim"
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "Leonardo will follow up and provide maintenace records."
                ],
                [
                  "2026-01-21",
                  "xlsx",
                  "Azul insisting internally to provide the support records."
                ],
                [
                  "2026-01-28",
                  "xlsx",
                  "No update."
                ],
                [
                  "2026-02-04",
                  "xlsx",
                  "Azul requested 1+ week."
                ],
                [
                  "2026-02-10",
                  "xlsx",
                  "Safran report provided. Under review"
                ],
                [
                  "2026-02-16",
                  "xlsx",
                  "Feedback provided."
                ],
                [
                  "2026-03-11",
                  "xlsx",
                  "AZUL technical team to provide update for closing claim."
                ],
                [
                  "2026-03-18",
                  "xlsx",
                  "Call will be scheudled for today to discuss in detail. Awaiting invitation from AZUL."
                ],
                [
                  "2026-04-08",
                  "xlsx",
                  "Pending ATR0166536 response from ATR confirming A/C inspections are acceptable. Pending Assigned LG Data."
                ]
              ]
            },
            {
              "i": "10.3",
              "a": "MSN 1195 NLG towing incident",
              "s": "—",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "",
              "n": [
                "AZUL to confirm SN of assigned LG (BER replaced, repaired ??)"
              ],
              "x": [
                "AZUL to provide details. — NEXT: AZUL to confirm SN of assigned LG (BER replaced, repaired ??)"
              ],
              "t": []
            }
          ]
        },
        {
          "sec": "12",
          "top": "Others",
          "subs": [
            {
              "i": "12.1",
              "a": "Utilzation reports",
              "s": "PENDING",
              "p": "CRITICAL",
              "o": "DAE",
              "u": "",
              "n": [
                "Confirm issue is closed."
              ],
              "x": [
                "Provide updates requested by email on swapped engines utilization. — NEXT: Confirm issue is closed. — [PENDING] — Following up with Leonardo"
              ],
              "t": []
            }
          ]
        },
        {
          "sec": "11",
          "top": "Standard Aero TPA / Utilization",
          "subs": [
            {
              "i": "11.1",
              "a": "Utilization reports",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-01-19",
              "n": [],
              "x": [
                "Do not reflect the recent swaps. — NEXT: Update assigned engines on utilization reports. — [CLOSED]"
              ],
              "t": [
                [
                  "2026-01-07",
                  "mtg",
                  "Std Aero reviewing TPA"
                ],
                [
                  "2026-01-14",
                  "mtg",
                  "Agreement accepted. ED0607 Might be added."
                ],
                [
                  "2026-01-19",
                  "mtg",
                  "ED0799 is being sent to PWC"
                ]
              ]
            },
            {
              "i": "11.2",
              "a": "MSN 1044 (ATV)",
              "s": "—",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-03-07",
              "n": [],
              "x": [
                "6M flight on 07-MAR. OK ?"
              ],
              "t": [
                [
                  "2026-03-07",
                  "xlsx",
                  "OK ?"
                ]
              ]
            }
          ]
        },
        {
          "sec": "13",
          "top": "MR Claims",
          "subs": [
            {
              "i": "13.2",
              "a": "Claim #4540 (MSN 1115)",
              "s": "IN PROGRESS",
              "p": "CRITICAL",
              "o": "AZUL",
              "u": "2026-03-18",
              "n": [],
              "x": [
                "18-MAR: Azul is reviewing internally and will provide an update to resume the claim process — [IN PROGRESS]"
              ],
              "t": [
                [
                  "2026-03-18",
                  "xlsx",
                  "Azul is reviewing internally and will provide an update to resume the claim process"
                ]
              ]
            },
            {
              "i": "13.3",
              "a": "Workscopes",
              "s": "CLOSED",
              "p": "NORMAL",
              "o": "AZUL",
              "u": "2026-03-18",
              "n": [],
              "x": [
                "18-MAR : Azul shared by email worksopes for DAE review MSN 1144 AIRFRAME 1CFH + 12YE +8YE+ 4YE + 2YE + 5000FH + 24000FC MSN 1043 AIRFRAME 2YE+1CFH+5000FH checks. Both workscopes are for Airframes maked \"S\" for relevant checks on the amended terms sheet Appendix 3. — [CLOSED]"
              ],
              "t": [
                [
                  "2026-03-18",
                  "xlsx",
                  "Azul shared by email worksopes for DAE review MSN 1144 AIRFRAME 1CFH + 12YE +8YE+ 4YE + 2YE + 5000FH + 24000FC MSN 1043 AIRFRAME 2YE+1CFH+5000FH checks. Both workscopes are for Airframes maked \"S\" for relevant checks on the amended terms sheet Appendix 3."
                ]
              ]
            }
          ]
        }
      ]
    }
  }
};

export const GIANCARLO_IMPORTS = [
  {
    "operatorMatch": [
      "avianca"
    ],
    "project": {
      "id": "proj-332154906440",
      "title": "MSN 7120 Avianca — ESN 645190 engine proposal",
      "type": "engine_exchange",
      "summary": "This is a replacement engine proposal from Avianca (ESN 645190) due to a BER engine back in Aug 2025 (all HPT failure and onwards Modules ESN 573511), Indaer ICA was contracted to perform the Records review. Pending Acceptance from Powerplant for the latest MPA and BSI performed last week, there are 12 open items still pending from AVIANCA to response and they will have another meeting either this week or next week, once PP review the BSI/MPA and all items are closed, we will need to ask Sara and Cata to do a lease amendment for this aircraft MSN 7120, also we need to ask Sara if the Lessor Contribution will apply to this engine since in the lease only mentions a lessor contribution to the previous title engines S/N. Need to confirm with Legal and Commercial if the Lessor Contributions to First Qualifying Maintenance Event would be available or not to the exchange engines recent PRSV (ESN 645190 Apr 2025) as that portion of the lease (Part A-3, para 5) makes specific mention of the ESNs that the section is applicable to.",
      "criticalItems": [],
      "contacts": [
        {
          "id": "ct-83e796f6f693",
          "firstName": "Emilio",
          "lastName": "Morell",
          "email": "emorell@indaer.com",
          "phone": "",
          "company": "Indaer",
          "position": "Operation officer"
        },
        {
          "id": "ct-02b9a3a52abf",
          "firstName": "Sergio",
          "lastName": "Acevedo",
          "email": "sacevedo@indaer.com",
          "phone": "",
          "company": "Indaer",
          "position": "Rep"
        },
        {
          "id": "ct-55fbb007a241",
          "firstName": "Catalina",
          "lastName": "Mazo",
          "email": "cmazo@indaer.com",
          "phone": "",
          "company": "Indaer",
          "position": "Rep"
        },
        {
          "id": "ct-91a9edc1a50e",
          "firstName": "Johann",
          "lastName": "Pena",
          "email": "johann.pena@avianca.com",
          "phone": "",
          "company": "AVIANCA",
          "position": "Technical Fleet Engineer"
        },
        {
          "id": "ct-ef40510b5afb",
          "firstName": "Salvador",
          "lastName": "Azahar",
          "email": "salvador.azahar@aethonvolans.com",
          "phone": "",
          "company": "AVIANCA",
          "position": "Rep"
        },
        {
          "id": "ct-e271990e747b",
          "firstName": "",
          "lastName": "",
          "email": "flotatecnica25@avianca.com",
          "phone": "",
          "company": "General Email",
          "position": ""
        },
        {
          "id": "ct-4a1bd6d113fb",
          "firstName": "3",
          "lastName": "CLAIMS IN DRAFT CUSTOMER PORTAL:",
          "email": "",
          "phone": "",
          "company": "General Email",
          "position": ""
        }
      ],
      "minutes": [
        {
          "id": "min-fefd42c4cbcd",
          "number": "1",
          "principalTopic": "Overview",
          "subTopic": "This is a replacement engine proposal from Avianca (ESN 645190) due to a BER engine back in Aug 2025 (all HPT failure and onwards Modules ESN 573511), Indaer ICA was contracted to perform the Records ",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "comments": [
            {
              "id": "c-199631b0315d",
              "text": "Pending Acceptance from Powerplant for the latest MPA and BSI performed last week, there are 12 open items still pending from AVIANCA to response and they will have another meeting either this week or next week, once PP review the BSI/MPA and all items are closed, we will need to ask Sara and Cata to do a lease amendment for this aircraft MSN 7120, also we need to ask Sara if the Lessor Contribution will apply to this engine since in the lease only mentions a lessor contribution to the previous title engines S/N. · Need to confirm with Legal and Commercial if the Lessor Contributions to First Qualifying Maintenance Event would be available or not to the exchange engines recent PRSV (ESN 645190 Apr 2025) as that portion of the lease (Part A-3, para 5) makes specific mention of the ESNs that the section is applicable to.",
              "at": "2026-06-26T00:00:00.000Z",
              "by": "import"
            }
          ]
        }
      ],
      "tasks": [],
      "attachments": [],
      "linkedSurveillanceId": null
    }
  },
  {
    "operatorMatch": [
      "avianca"
    ],
    "project": {
      "id": "proj-45727738d736",
      "title": "Avianca LG set claims (#4686 / #4680)",
      "type": "claim",
      "summary": "This is a claim from Avianca for Lessor Contribution based on the lease for the 1st qualified maintenance events. Avianca submitted the claim but for different LG Set S/N on both aircraft. If this is the course of action then it will be needed to review the proposed replacement LG set on both aircraft as per the lease such as MFD, TT, TC, Mods, WV Last OVH and BTB, Folio 12. If the (2) LG set are ok then we can proceed with the Claim. Note: No need to issue a lease amendment for LG set replacement.",
      "criticalItems": [],
      "contacts": [
        {
          "id": "ct-4a4cf2361e15",
          "firstName": "Todor",
          "lastName": "Ivandjikov",
          "email": "todor.ivandjikov@dubaiaerospace.com",
          "phone": "",
          "company": "IAS",
          "position": ""
        },
        {
          "id": "ct-b0e25955b23a",
          "firstName": "Juan",
          "lastName": "Camilo Hernandez",
          "email": "juancamilo.hernandez@avianca.com",
          "phone": "",
          "company": "AVIANCA",
          "position": "fleet contract analyst"
        }
      ],
      "minutes": [
        {
          "id": "min-280cf3dd186c",
          "number": "1",
          "principalTopic": "Overview",
          "subTopic": "This is a claim from Avianca for Lessor Contribution based on the lease for the 1st qualified maintenance events.",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "comments": [
            {
              "id": "c-fb7096a6a1e7",
              "text": "Avianca submitted the claim but for different LG Set S/N on both aircraft. If this is the course of action then it will be needed to review the proposed replacement LG set on both aircraft as per the lease such as MFD, TT, TC, Mods, WV Last OVH and BTB, Folio 12. If the (2) LG set are ok then we can proceed with the Claim. · Note: No need to issue a lease amendment for LG set replacement.",
              "at": "2026-06-26T00:00:00.000Z",
              "by": "import"
            }
          ]
        }
      ],
      "tasks": [],
      "attachments": [],
      "linkedSurveillanceId": null
    }
  },
  {
    "operatorMatch": [
      "arajet"
    ],
    "project": {
      "id": "proj-190e8ff9d9e7",
      "title": "Arajet 9-year check claim (#4687)",
      "type": "claim",
      "summary": "The customer launched the Claim in Customer Portal and the status still in Draft and as today corresponding files has not been uploaded. email sent, reply is the docs will be uploaded. I did a review already for the 9 Ye check MPD Routine M/H that will be shared.",
      "criticalItems": [],
      "contacts": [
        {
          "id": "ct-584fcad341df",
          "firstName": "Istvan",
          "lastName": "Jambor",
          "email": "istvan.jambor@arajet.com",
          "phone": "",
          "company": "Arajet",
          "position": "VP of fleet"
        },
        {
          "id": "ct-e972c424e5af",
          "firstName": "Joffre",
          "lastName": "Portorreal",
          "email": "Joffre.Portorreal@arajet.com",
          "phone": "",
          "company": "Arajet",
          "position": "Engineering"
        },
        {
          "id": "ct-cd12c362b57c",
          "firstName": "Victor",
          "lastName": "Avelar",
          "email": "Victor.Avelar@arajet.com",
          "phone": "",
          "company": "Arajet",
          "position": "Planning"
        }
      ],
      "minutes": [
        {
          "id": "min-fad3fa11eacd",
          "number": "1",
          "principalTopic": "Overview",
          "subTopic": "The customer launched the Claim in Customer Portal and the status still in Draft and as today corresponding files has not been uploaded. email sent, reply is the docs will be uploaded.",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "comments": [
            {
              "id": "c-63d5f92d613c",
              "text": "I did a review already for the 9 Ye check MPD Routine M/H that will be shared.",
              "at": "2026-06-26T00:00:00.000Z",
              "by": "import"
            }
          ]
        }
      ],
      "tasks": [],
      "attachments": [],
      "linkedSurveillanceId": null
    }
  },
  {
    "operatorMatch": [
      "aruba"
    ],
    "project": {
      "id": "proj-6ca0f06b1204",
      "title": "Aruba Airlines MSN 4459 claim",
      "type": "claim",
      "summary": "2nd Reimbursement for the payment performed by Aruba Airlines to Mexicana MRO. This claim has been processed already and is with Finance, Antonio Already approved. No actions to be taken only FYI. AIRCRAFT SURVEILLANCE ONGOING:",
      "criticalItems": [],
      "contacts": [],
      "minutes": [
        {
          "id": "min-9b19245b7c3e",
          "number": "1",
          "principalTopic": "Overview",
          "subTopic": "2nd Reimbursement for the payment performed by Aruba Airlines to Mexicana MRO.",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "comments": [
            {
              "id": "c-fbaaef914e80",
              "text": "This claim has been processed already and is with Finance, Antonio Already approved. · No actions to be taken only FYI. · AIRCRAFT SURVEILLANCE ONGOING:",
              "at": "2026-06-26T00:00:00.000Z",
              "by": "import"
            }
          ]
        }
      ],
      "tasks": [],
      "attachments": [],
      "linkedSurveillanceId": null
    }
  },
  {
    "operatorMatch": [
      "volaris"
    ],
    "project": {
      "id": "proj-f2bc913f3215",
      "title": "Volaris surveillance Q2-2026",
      "type": "surveillance",
      "summary": "MSN 6705 and 6906 completed PI on June 22nd , pending records review and upload in ATS, Volaris provided the link on June 22nd MSN 6969 pending schedule for PI (potential for next week June 29-July 3rd) in Mexico Mexico City to be performed by Benjamin IAS and same records review and upload in ATS",
      "criticalItems": [],
      "contacts": [
        {
          "id": "ct-0e8d35020da0",
          "firstName": "Benjamin",
          "lastName": "Alvarado",
          "email": "b.alvarado@ias-eu.com",
          "phone": "",
          "company": "IAS",
          "position": ""
        },
        {
          "id": "ct-c49677ece3ea",
          "firstName": "Ramiro",
          "lastName": "Galvan",
          "email": "ramiro.galvan@volaris.com",
          "phone": "",
          "company": "VOLARIS",
          "position": "Management engineer"
        },
        {
          "id": "ct-f5fc853a4aa0",
          "firstName": "Felipe",
          "lastName": "Jimenez",
          "email": "felipe.jimenez@volaris.com",
          "phone": "",
          "company": "VOLARIS",
          "position": ""
        },
        {
          "id": "ct-bc310b2d3b4c",
          "firstName": "Alonso",
          "lastName": "Velazquez Jimenez",
          "email": "alonso.velazquez@volaris.com",
          "phone": "",
          "company": "VOLARIS",
          "position": ""
        }
      ],
      "minutes": [
        {
          "id": "min-8fb24c699d80",
          "number": "1",
          "principalTopic": "Overview",
          "subTopic": "MSN 6705 and 6906 completed PI on June 22nd , pending records review and upload in ATS, Volaris provided the link on June 22nd",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "comments": [
            {
              "id": "c-f8eead4e205d",
              "text": "MSN 6969 pending schedule for PI (potential for next week June 29-July 3rd) in Mexico Mexico City to be performed by Benjamin IAS and same records review and upload in ATS",
              "at": "2026-06-26T00:00:00.000Z",
              "by": "import"
            }
          ]
        }
      ],
      "tasks": [],
      "attachments": [],
      "linkedSurveillanceId": null
    }
  },
  {
    "operatorMatch": [
      "viva"
    ],
    "project": {
      "id": "proj-89c60126965e",
      "title": "MSN 7043 redelivery — Viva / Air Sial",
      "type": "redelivery",
      "summary": "Meetings (physical and records) with Viva every Tuesday and Thursdays 11:30 AM (Miami Local Time) Monday / Wednesday / Friday Records meeting with Air Sial.",
      "criticalItems": [],
      "contacts": [
        {
          "id": "ct-c4a19a9a9fcf",
          "firstName": "Jesus",
          "lastName": "Giraldo",
          "email": "jgiraldo@indaer.com",
          "phone": "",
          "company": "DAE / INDAER",
          "position": ""
        },
        {
          "id": "ct-cc1582f71d7c",
          "firstName": "Wilbert",
          "lastName": "Arjona",
          "email": "arjonawil@yahoo.com.mx",
          "phone": "",
          "company": "DAE / INDAER",
          "position": ""
        },
        {
          "id": "ct-eef8dfca13fc",
          "firstName": "Andres",
          "lastName": "Garcia",
          "email": "afgarcia@indaer.com",
          "phone": "",
          "company": "DAE / INDAER",
          "position": "remote some days"
        },
        {
          "id": "ct-17dfc2f7e82a",
          "firstName": "Natalia",
          "lastName": "and Katharine",
          "email": "",
          "phone": "",
          "company": "DAE / INDAER",
          "position": "Legal DAE for Air Sial"
        },
        {
          "id": "ct-622e2076297e",
          "firstName": "Sara",
          "lastName": "Garcia",
          "email": "",
          "phone": "",
          "company": "DAE / INDAER",
          "position": "Legal DAE for Viva"
        },
        {
          "id": "ct-b02c17eff1b2",
          "firstName": "Avisaid",
          "lastName": "Ibarra",
          "email": "avisaid.ibarra@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": ""
        },
        {
          "id": "ct-c0ec23490bc3",
          "firstName": "Patricia",
          "lastName": "Carrizales",
          "email": "patricia.carrizales@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": ""
        },
        {
          "id": "ct-0e5fa1cff392",
          "firstName": "Francisco",
          "lastName": "Arrendondo",
          "email": "francisco.arredondo@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": "onsite in GDL"
        },
        {
          "id": "ct-2b910bd0d594",
          "firstName": "Marco",
          "lastName": "Gonzalez",
          "email": "marco.gonzalez@vivaaerobus.com",
          "phone": "+52 1 8117998703",
          "company": "VIVA",
          "position": "Project Manager"
        },
        {
          "id": "ct-150082be6a21",
          "firstName": "William",
          "lastName": "Coronado",
          "email": "william.coronado@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": ""
        },
        {
          "id": "ct-38424f9bbd93",
          "firstName": "Hector",
          "lastName": "Tavera",
          "email": "hector.tavera@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": "Fleet Manager"
        },
        {
          "id": "ct-91780d17e5d7",
          "firstName": "Juancarlos",
          "lastName": "Roncallo",
          "email": "juan.roncallo@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": "Commercial"
        },
        {
          "id": "ct-3cc447550d2a",
          "firstName": "Muhammad",
          "lastName": "Azhar Qayyum",
          "email": "azhar.qayyum@airsial.com",
          "phone": "",
          "company": "AIR SIAL",
          "position": "general director Maintenance"
        },
        {
          "id": "ct-db584bdb2156",
          "firstName": "Ammad",
          "lastName": "Muhammad Khan",
          "email": "ammad.khan@airsial.com",
          "phone": "",
          "company": "AIR SIAL",
          "position": "General Manager"
        },
        {
          "id": "ct-d6fc9a256485",
          "firstName": "Muhammad",
          "lastName": "Waleed",
          "email": "muhammad.waleed@airsial.com",
          "phone": "",
          "company": "AIR SIAL",
          "position": "Onsite rep Mechanic"
        },
        {
          "id": "ct-1533a14cbdd6",
          "firstName": "Atif",
          "lastName": "Asan",
          "email": "",
          "phone": "",
          "company": "AIR SIAL",
          "position": ""
        },
        {
          "id": "ct-7f013debfa3b",
          "firstName": "Sadoon",
          "lastName": "Alwas",
          "email": "atif.hasan@airsial.com",
          "phone": "",
          "company": "AIR SIAL",
          "position": ""
        },
        {
          "id": "ct-94fccfa14ed5",
          "firstName": "",
          "lastName": "",
          "email": "sadoon.alwaz@airsial.com",
          "phone": "",
          "company": "CAMO",
          "position": ""
        }
      ],
      "minutes": [
        {
          "id": "min-39c71db89a90",
          "number": "1",
          "principalTopic": "Overview",
          "subTopic": "Meetings (physical and records) with Viva every Tuesday and Thursdays 11:30 AM (Miami Local Time)",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "comments": [
            {
              "id": "c-10295d282ef9",
              "text": "Monday / Wednesday / Friday Records meeting with Air Sial.",
              "at": "2026-06-26T00:00:00.000Z",
              "by": "import"
            }
          ]
        }
      ],
      "tasks": [],
      "attachments": [
        {
          "id": "att-c51aa46245c0",
          "kind": "link",
          "label": "OPEN ITEM LIST VIVA",
          "url": "https://vivaaerobus.sharepoint.com/:x:/g/Mantenimiento/IQBXTJLzAQGCQ648QPi7y2AXAXvF89ok0Hq0PYI4-yZAeCQ?e=TYoYfJ&xsdata=MDV8MDJ8Z2lhbmNhcmxvLm1hbGVzYW5pQGR1YmFpYWVyb3NwYWNlLmNvbXw3ODFmYjQ0Y2FlOWI0ZGZlZjVkMDA4ZGVjMGE0NDEwM3xhZDY2NDNlMjVhZDQ0MWI2ODQ0MGY3ZWUyMmFjMTRlZXwwfDB8NjM5MTYwMDA4ODY2ODE0Njg1fFVua25vd258VFdGcGJHWnNiM2Q4ZXlKRmJYQjBlVTFoY0draU9uUnlkV1VzSWxZaU9pSXdMakF1TURBd01DSXNJbEFpT2lKWGFXNHpNaUlzSWtGT0lqb2lUV0ZwYkNJc0lsZFVJam95ZlE9PXwwfHx8&sdata=L3pNWVRGbFliM0k4RUk4eitPVmh3S3F1NERKblVhRHBrZ1MrK05paXAvND0%3d",
          "fileId": null,
          "mime": null,
          "createdAt": "2026-06-26T00:00:00.000Z",
          "comments": []
        },
        {
          "id": "att-3a0a203f91fa",
          "kind": "link",
          "label": "RECORDS SHAREPOINT VIVA",
          "url": "https://vivaaerobus.sharepoint.com/:f:/g/Mantenimiento/IgAcmQtnaHkyQLj1HruW5YMiAT0J9b_WwUpUsNucbd4I_Cc?e=XacCBj&xsdata=MDV8MDJ8Z2lhbmNhcmxvLm1hbGVzYW5pQGR1YmFpYWVyb3NwYWNlLmNvbXw3ODFmYjQ0Y2FlOWI0ZGZlZjVkMDA4ZGVjMGE0NDEwM3xhZDY2NDNlMjVhZDQ0MWI2ODQ0MGY3ZWUyMmFjMTRlZXwwfDB8NjM5MTYwMDA4ODY2ODUzNDE2fFVua25vd258VFdGcGJHWnNiM2Q4ZXlKRmJYQjBlVTFoY0draU9uUnlkV1VzSWxZaU9pSXdMakF1TURBd01DSXNJbEFpT2lKWGFXNHpNaUlzSWtGT0lqb2lUV0ZwYkNJc0lsZFVJam95ZlE9PXwwfHx8&sdata=QzR0SEEvSlR5Z1FMejhpcExjUFZvMEVIamRpQ05KeWFIeDBqOTZHaSs5ST0%3d",
          "fileId": null,
          "mime": null,
          "createdAt": "2026-06-26T00:00:00.000Z",
          "comments": []
        },
        {
          "id": "att-b28be0150ad8",
          "kind": "link",
          "label": "OPEN ITEM LIST AIR SIAL",
          "url": "https://docs.google.com/spreadsheets/d/1L7WXcbo00erddbOhUtyoWnHpSXRbd4lVzIBxno96eEg/edit?gid=1819951864#gid=1819951864",
          "fileId": null,
          "mime": null,
          "createdAt": "2026-06-26T00:00:00.000Z",
          "comments": []
        }
      ],
      "linkedSurveillanceId": null
    }
  },
  {
    "operatorMatch": [
      "viva"
    ],
    "project": {
      "id": "proj-5221ff0fd825",
      "title": "MSN 7043 exception list",
      "type": "redelivery",
      "summary": "MSN 7043 - Exception List 20260622.xlsx - Google Sheets Aircraft Located in Guadalajara Mexico, the 2 onsite representatives are onsite ( Jesus Giraldo Indaer / Wilbert Arjona) the aircraft is currently under light Maintenance (short interval task cards, DMI corrections, Static checks part S corrections, Physical items corrections based on the physical OIL and waiting the engine pos. 2 V18122. This Engine ESN V18122 went to PRSV and LLPs replacement (all except for 1 LLP) in IBERIA Spain. They are currently working on the logistics to have the engine in Guadalajara Mexico on July 2nd -July 3rd.",
      "criticalItems": [
        "THSA discussion",
        "Physical items compensation M/H agreement",
        "Sidewall panel compensation with the material for Air Sial",
        "Task card to be accomplished TBD( 6 YE check task card for the lavatory)"
      ],
      "contacts": [
        {
          "id": "ct-ab2c27fd3c16",
          "firstName": "Jesus",
          "lastName": "Giraldo",
          "email": "jgiraldo@indaer.com",
          "phone": "",
          "company": "DAE / INDAER",
          "position": ""
        },
        {
          "id": "ct-4f6a14c94281",
          "firstName": "Wilbert",
          "lastName": "Arjona",
          "email": "arjonawil@yahoo.com.mx",
          "phone": "",
          "company": "DAE / INDAER",
          "position": ""
        },
        {
          "id": "ct-02f4546d2cc0",
          "firstName": "Andres",
          "lastName": "Garcia",
          "email": "afgarcia@indaer.com",
          "phone": "",
          "company": "DAE / INDAER",
          "position": "remote some days"
        },
        {
          "id": "ct-a51df07aa179",
          "firstName": "Natalia",
          "lastName": "and Katharine",
          "email": "",
          "phone": "",
          "company": "DAE / INDAER",
          "position": "Legal DAE for Air Sial"
        },
        {
          "id": "ct-70b67984d5cf",
          "firstName": "Sara",
          "lastName": "Garcia",
          "email": "",
          "phone": "",
          "company": "DAE / INDAER",
          "position": "Legal DAE for Viva"
        },
        {
          "id": "ct-32a55b67cc3b",
          "firstName": "Avisaid",
          "lastName": "Ibarra",
          "email": "avisaid.ibarra@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": ""
        },
        {
          "id": "ct-43401130805f",
          "firstName": "Patricia",
          "lastName": "Carrizales",
          "email": "patricia.carrizales@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": ""
        },
        {
          "id": "ct-42153e450a0e",
          "firstName": "Francisco",
          "lastName": "Arrendondo",
          "email": "francisco.arredondo@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": "onsite in GDL"
        },
        {
          "id": "ct-5de516d2cc3c",
          "firstName": "Marco",
          "lastName": "Gonzalez",
          "email": "marco.gonzalez@vivaaerobus.com",
          "phone": "+52 1 8117998703",
          "company": "VIVA",
          "position": "Project Manager"
        },
        {
          "id": "ct-e717ce7863e7",
          "firstName": "William",
          "lastName": "Coronado",
          "email": "william.coronado@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": ""
        },
        {
          "id": "ct-344470d00d0a",
          "firstName": "Hector",
          "lastName": "Tavera",
          "email": "hector.tavera@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": "Fleet Manager"
        },
        {
          "id": "ct-03b38d8772ea",
          "firstName": "Juancarlos",
          "lastName": "Roncallo",
          "email": "juan.roncallo@vivaaerobus.com",
          "phone": "",
          "company": "VIVA",
          "position": "Commercial"
        },
        {
          "id": "ct-f548f0f8c5bb",
          "firstName": "Muhammad",
          "lastName": "Azhar Qayyum",
          "email": "azhar.qayyum@airsial.com",
          "phone": "",
          "company": "AIR SIAL",
          "position": "general director Maintenance"
        },
        {
          "id": "ct-d75ac868ed43",
          "firstName": "Ammad",
          "lastName": "Muhammad Khan",
          "email": "ammad.khan@airsial.com",
          "phone": "",
          "company": "AIR SIAL",
          "position": "General Manager"
        },
        {
          "id": "ct-3664365d4790",
          "firstName": "Muhammad",
          "lastName": "Waleed",
          "email": "muhammad.waleed@airsial.com",
          "phone": "",
          "company": "AIR SIAL",
          "position": "Onsite rep Mechanic"
        },
        {
          "id": "ct-3c6ecc9b8611",
          "firstName": "Atif",
          "lastName": "Asan",
          "email": "",
          "phone": "",
          "company": "AIR SIAL",
          "position": ""
        },
        {
          "id": "ct-106838cdadcb",
          "firstName": "Sadoon",
          "lastName": "Alwas",
          "email": "atif.hasan@airsial.com",
          "phone": "",
          "company": "AIR SIAL",
          "position": ""
        },
        {
          "id": "ct-4a5a110bf527",
          "firstName": "",
          "lastName": "",
          "email": "sadoon.alwaz@airsial.com",
          "phone": "",
          "company": "CAMO",
          "position": ""
        }
      ],
      "minutes": [
        {
          "id": "min-957eff0fdff6",
          "number": "1",
          "principalTopic": "Pending",
          "subTopic": "Rectifications of the physical items and the proposal from viva for the cosmetic items to be compensated",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        },
        {
          "id": "min-300ed524957e",
          "number": "2",
          "principalTopic": "Pending",
          "subTopic": "Engine installation and a few 1C task cards accomplishment (not accomplished in Iberia)",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        },
        {
          "id": "min-a68828927cf6",
          "number": "3",
          "principalTopic": "Pending",
          "subTopic": "perform all the E checks (engine checks) ISATFM Part 1 ground check Chapter 2 – Engine Run from E1 to E48 pending to perform on both title engines post CRS.",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        },
        {
          "id": "min-ca5bf9480412",
          "number": "4",
          "principalTopic": "Pending",
          "subTopic": "ISATFM part 2 Demo Flight and PFR (if necessary)",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        },
        {
          "id": "min-d3b6288d0b47",
          "number": "5",
          "principalTopic": "Pending",
          "subTopic": "BSI to performed by BOV (PO already issued)",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        },
        {
          "id": "min-839a89f519e7",
          "number": "6",
          "principalTopic": "Pending",
          "subTopic": "WV012 and Owner Data plate installation",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        },
        {
          "id": "min-0bc544874e3b",
          "number": "7",
          "principalTopic": "Pending",
          "subTopic": "Records closure from Both parties and records inventory including the LHTPR Boxes.",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        },
        {
          "id": "min-fbd8c3935a9d",
          "number": "8",
          "principalTopic": "Pending",
          "subTopic": "CTA (VIVA-DAE / DAE Air Sial) at the same time estimated to be performed on third week of July.",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        },
        {
          "id": "min-9a33a31f368c",
          "number": "9",
          "principalTopic": "Pending",
          "subTopic": "Ferry flight from Guadalajara To Istanbul ( DAE cost around $120,000) we have in our RM transition cost $50K Budgeted and $32K funds available for the Budget BSI + compensation to be received from Viva Aerobus for physical items, this item is due to the full no compliance for the Delivery location from Air Sial ( see the excel comparison cost)",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        },
        {
          "id": "min-8d3841e7f518",
          "number": "10",
          "principalTopic": "Pending",
          "subTopic": "EOL Adjustment Excel (only to be updated with final times after the demo flight)",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        },
        {
          "id": "min-ecdb6f102722",
          "number": "11",
          "principalTopic": "Pending",
          "subTopic": "CTA forms template to be provided",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "status": "open",
          "comments": []
        }
      ],
      "tasks": [],
      "attachments": [],
      "linkedSurveillanceId": null
    }
  },
  {
    "operatorMatch": [
      "volaris"
    ],
    "project": {
      "id": "proj-08f6a4da92a1",
      "title": "MSN 7457 redelivery — Volaris Aug 2026",
      "type": "redelivery",
      "summary": "Records review for an LG set replacement in progress, pending Volaris feedback (9 open items)",
      "criticalItems": [],
      "contacts": [],
      "minutes": [
        {
          "id": "min-24256df78324",
          "number": "1",
          "principalTopic": "Overview",
          "subTopic": "Records review for an LG set replacement in progress, pending Volaris feedback (9 open items)",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "comments": []
        }
      ],
      "tasks": [],
      "attachments": [],
      "linkedSurveillanceId": null
    }
  },
  {
    "operatorMatch": [
      "viva"
    ],
    "project": {
      "id": "proj-8564a2012519",
      "title": "MSN 7020 exemption list payment",
      "type": "general",
      "summary": "Excess Inventory pickup in LHTPR SATENA 1204/ 1214 LOI Comments (possible answer from Satena with the LOI with Comments) Need to talk with Lar to give access to ORACLE for approval and receiving onsite reps and payments.",
      "criticalItems": [],
      "contacts": [],
      "minutes": [
        {
          "id": "min-898fbd2f7662",
          "number": "1",
          "principalTopic": "Overview",
          "subTopic": "Excess Inventory pickup in LHTPR",
          "owner": "",
          "targetOriginal": "",
          "targetUpdated": "",
          "comments": [
            {
              "id": "c-667ef179ae96",
              "text": "SATENA 1204/ 1214 LOI Comments (possible answer from Satena with the LOI with Comments) · Need to talk with Lar to give access to ORACLE for approval and receiving onsite reps and payments.",
              "at": "2026-06-26T00:00:00.000Z",
              "by": "import"
            }
          ]
        }
      ],
      "tasks": [],
      "attachments": [],
      "linkedSurveillanceId": null
    }
  }
];

export function importsForOperator(operatorName) {
  const n = String(operatorName || "").trim().toLowerCase();
  const out = [];
  if (n.includes("azul")) out.push(AZUL_IMPORT);
  for (const bundle of GIANCARLO_IMPORTS) {
    const match = (bundle.operatorMatch || []).some((m) => n.includes(String(m).toLowerCase()));
    if (match) out.push(bundle);
  }
  return out;
}
